import React from "react";
import { motion } from "framer-motion";

import { gradient } from "./GradientImage";

const IconMap = {
	AlignLeft: AlignLeft,
	AlignCenter: AlignCenter,
	AlignRight: AlignRight,
	AlignTop: AlignTop,
	AlignMiddle: AlignMiddle,
	AlignBottom: AlignBottom,
	AlignDistribute: AlignDistribute,

	LayerAlignLeft: LayerAlignLeft,
	LayerAlignCenter: LayerAlignCenter,
	LayerAlignRight: LayerAlignRight,
	LayerAlignTop: LayerAlignTop,
	LayerAlignMiddle: LayerAlignMiddle,
	LayerAlignBottom: LayerAlignBottom,
	LayerDistributeVertical: LayerDistributeVertical,
	LayerDistributeHorizontal: LayerDistributeHorizontal,

	TransparentFill: TransparentFill,
	TransparentColor: TransparentColor,

	Line: Line,
	LineSize: LineSize,
	LineSizeAlt: LineSizeAlt,
	LineSizeHairline: LineSizeHairline,
	LineSizeThin: LineSizeThin,
	LineSizeThick: LineSizeThick,
	LineCap: LineCap,

	LineCapStartFlat: LineCapStartFlat,
	LineCapStartRound: LineCapStartRound,
	LineCapStartCircle: LineCapStartCircle,
	LineCapStartArrow: LineCapStartArrow,

	LineCapEndFlat: LineCapEndFlat,
	LineCapEndRound: LineCapEndRound,
	LineCapEndCircle: LineCapEndCircle,
	LineCapEndArrow: LineCapEndArrow,

	ProgressRing: ProgressRing,

	ListBullet: ListBullet,
	ListNumber: ListNumber,
	ColorPaletteFill: ColorPaletteFill,
	ColorPalette: ColorPalette,
	Dropdown: Dropdown,
	Compose: Compose,
	Book: Book,
	OpenLink: OpenLink,
	Link: Link,

	Cut: Cut,
	Copy: Copy,
	Paste: Paste,
	Rename: Rename,
	PlusSquareOutline: PlusSquareOutline,
	PlusSmall: PlusSmall,
	Delete: Delete,
	Checkmark: Checkmark,
	Download: Download,
	DuplicateSquare: DuplicateSquare,
	DuplicateLandscape: DuplicateLandscape,
	SquareStack: SquareStack,
	AIImage: AIImage,
	Draggable: Draggable,

	ChevronLeft: ChevronLeft,
	ChevronDown: ChevronDown,
	ChevronRight: ChevronRight,
	CaretDown: CaretDown,
	Help: Help,
	HelpFill: HelpFill,

	PlayFilled: PlayFilled,
	PlaybackPlay: PlaybackPlay,
	PlaybackPlayButton: PlaybackPlayButton,
	PlaybackPause: PlaybackPause,
	Trim: Trim,

	VolumeHigh: VolumeHigh,
	VolumeMid: VolumeMid,
	VolumeOff: VolumeOff,
	Waveform: Waveform,
	Comment: Comment,
	CommentFill: CommentFill,
	Close: Close,
	Clear: Clear,

	Text: Text,
	TextSize: TextSize,
	TextSizeFlipped: TextSizeFlipped,
	TextSizeAlt: TextSizeAlt,
	Title: Title,
	TitleOff: TitleOff,
	ShortenText: ShortenText,
	LengthenText: LengthenText,
	TextSizeDecrease: TextSizeDecrease,
	TextSizeIncrease: TextSizeIncrease,

	FillLandscape: FillLandscape,
	FitLandscape: FitLandscape,
	Crop: Crop,
	SlowAnimation: SlowAnimation,

	Code: Code,
	Image: Image,
	Add: Add,
	Video: Video,
	History: History,
	Background: Background,
	VideoCamera: VideoCamera,
	Microphone: Microphone,
	Record: Record,
	Theme: Theme,
	MagicWand: MagicWand,
	ArrowCursor: ArrowCursor,
	Annotate: Annotate,
	Scribble: Scribble,
	Flashlight: Flashlight,
	RectSelect: RectSelect,
	LineHairline: LineHairline,
	LineWavy: LineWavy,
	ShowOnClick: ShowOnClick,
	ShowAlways: ShowAlways,
	LightMode: LightMode,
	DarkMode: DarkMode,
	Fullscreen: Fullscreen,
	FullscreenAlt1: FullscreenAlt1,
	FullscreenAlt2: FullscreenAlt2,
	Preferences: Preferences,
	Expand: Expand,
	ExpandFlipped: ExpandFlipped,
	ExpandTile: ExpandTile,
	CollapseTile: CollapseTile,
	CollapseFlipped: CollapseFlipped,
	MoreCircleOutline: MoreCircleOutline,
	More: More,
	Share: Share,
	HeartEmpty: HeartEmpty,
	AddPage: AddPage,
	Grid: Grid,
	GridFilled: GridFilled,
	GridOutline: GridOutline,
	View: View,
	ViewOff: ViewOff,
	Photo: Photo,
	Table: Table,
	Web: Web,
	Search: Search,
	Globe: Globe,

	Twitter: Twitter,
	Giphy: Giphy,
	Figma: Figma,
	Airtable: Airtable,
	Framer: Framer,
	Miro: Miro,
	Looker: Looker,
	Dalle: Dalle,
	Unsplash: Unsplash,

	AddTableRow: AddTableRow,
	AddTableColumn: AddTableColumn,
	RemoveTableRow: RemoveTableRow,
	RemoveTableColumn: RemoveTableColumn,
	WrapText: WrapText,
	UnwrapText: UnwrapText,

	PaintBucket: PaintBucket,
	Color: Color,
	Lightbulb: Lightbulb,
	PlusLandscape: PlusLandscape,

	Shapes: Shapes,
	Subtract: Subtract,
	FitCanvasToContent: FitCanvasToContent,

	ColorRing: ColorRing,
	ArrowLeft: ArrowLeft,
	ArrowRight: ArrowRight,
	ArrowUp: ArrowUp,
	ArrowTopRight: ArrowTopRight,
	ArrowLeftRightOut: ArrowLeftRightOut,
	ArrowUpDown: ArrowUpDown,
	Up: Up,

	MoveIndicator: MoveIndicator,
	MoveIndicator4Dots: MoveIndicator4Dots,

	DoubleSparkle: DoubleSparkle,
	Upload: Upload,
	Info: Info,
	Retake: Retake,
	Warning: Warning,
	Report: Report,
	Return: Return,
	TomeLogo: TomeLogo,
	Doc: Doc,
	OutlineAlt: OutlineAlt,
	Page: Page,
	PageLandscape: PageLandscape,
	MultiplePagesLandscape: MultiplePagesLandscape,
	PagesStacked: PagesStacked,

	TwoArrowCirclePathCounterclockwise: TwoArrowCirclePathCounterclockwise,
	BigText: BigText,
	Clock: Clock,
	Wavy: Wavy,
	CircleRemove: CircleRemove,

	ChartLine: ChartLine,
	LineChart: LineChart,

	SpacingHorizontal: SpacingHorizontal,

	PersonMasculine: PersonMasculine,
	PersonFeminine: PersonFeminine,
	Child: Child,
	Baby: Baby,
	Heart: Heart,
	Star: Star,
	Fire: Fire,
	Water: Water,
	EmojiHappy: EmojiHappy,
	EmojiDisappointed: EmojiDisappointed,
	ThumbsUp: ThumbsUp,
	ThumbsDown: ThumbsDown,
	Bicycle: Bicycle,
	Car: Car,
	Airplane: Airplane,
	Rocket: Rocket,
};

export const Icon = props => {
	const { name = "Add", size = 28, color = "rgba(255,255,255,0.5)", selected, forceColor = false, style } = props;
	const Drawing = IconMap[name] ? IconMap[name] : null;
	if (!Drawing) console.log("Missing Icon: " + name);
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 64 64"
			style={{
				display: "block",
				position: "relative",
				pointerEvents: "none",
				overflow: "visible",
				flexShrink: 0,
				//transition: "fill 0.2s ease-out",
				fill: color,
				...style,
			}}
		>
			<Drawing color={color} selected={selected} forceColor={forceColor} />
		</svg>
	);
};

function AlignLeft(props) {
	return (
		<motion.g>
			<path d="M12 20C12 18.8954 12.8954 18 14 18H50C51.1046 18 52 18.8954 52 20C52 21.1046 51.1046 22 50 22H14C12.8954 22 12 21.1046 12 20Z" />
			<path d="M12 32C12 30.8954 12.8954 30 14 30H38C39.1046 30 40 30.8954 40 32C40 33.1046 39.1046 34 38 34H14C12.8954 34 12 33.1046 12 32Z" />
			<path d="M14 42C12.8954 42 12 42.8954 12 44C12 45.1046 12.8954 46 14 46H50C51.1046 46 52 45.1046 52 44C52 42.8954 51.1046 42 50 42H14Z" />
		</motion.g>
	);
}

function AlignCenter(props) {
	return (
		<motion.g>
			<path d="M12 20C12 18.8954 12.8954 18 14 18H50C51.1046 18 52 18.8954 52 20C52 21.1046 51.1046 22 50 22H14C12.8954 22 12 21.1046 12 20Z" />
			<path d="M18 32C18 30.8954 18.8954 30 20 30H44C45.1046 30 46 30.8954 46 32C46 33.1046 45.1046 34 44 34H20C18.8954 34 18 33.1046 18 32Z" />
			<path d="M14 42C12.8954 42 12 42.8954 12 44C12 45.1046 12.8954 46 14 46H50C51.1046 46 52 45.1046 52 44C52 42.8954 51.1046 42 50 42H14Z" />
		</motion.g>
	);
}

function AlignRight(props) {
	return (
		<motion.g>
			<path d="M12 20C12 18.8954 12.8954 18 14 18H50C51.1046 18 52 18.8954 52 20C52 21.1046 51.1046 22 50 22H14C12.8954 22 12 21.1046 12 20Z" />
			<path d="M24 32C24 30.8954 24.8954 30 26 30H50C51.1046 30 52 30.8954 52 32C52 33.1046 51.1046 34 50 34H26C24.8954 34 24 33.1046 24 32Z" />
			<path d="M14 42C12.8954 42 12 42.8954 12 44C12 45.1046 12.8954 46 14 46H50C51.1046 46 52 45.1046 52 44C52 42.8954 51.1046 42 50 42H14Z" />
		</motion.g>
	);
}

function AlignTop(props) {
	return (
		<motion.g>
			<path d="M14 18C12.8954 18 12 18.8954 12 20C12 21.1046 12.8954 22 14 22H50C51.1046 22 52 21.1046 52 20C52 18.8954 51.1046 18 50 18H14Z" />
			<path d="M33.4142 33.5858C32.6332 32.8047 31.3668 32.8047 30.5858 33.5858L22.5858 41.5858C21.8047 42.3668 21.8047 43.6332 22.5858 44.4142C23.3668 45.1953 24.6332 45.1953 25.4142 44.4142L32 37.8284L38.5858 44.4142C39.3668 45.1953 40.6332 45.1953 41.4142 44.4142C42.1953 43.6332 42.1953 42.3668 41.4142 41.5858L33.4142 33.5858Z" />
		</motion.g>
	);
}

function AlignMiddle(props) {
	return (
		<motion.g>
			<path d="M33.4142 24.4142L41.4142 16.4142C42.1953 15.6332 42.1953 14.3668 41.4142 13.5858C40.6332 12.8047 39.3668 12.8047 38.5858 13.5858L32 20.1716L25.4142 13.5858C24.6332 12.8047 23.3668 12.8047 22.5858 13.5858C21.8047 14.3668 21.8047 15.6332 22.5858 16.4142L30.5858 24.4142C31.3668 25.1953 32.6332 25.1953 33.4142 24.4142Z" />
			<path d="M12 32C12 33.1046 12.8954 34 14 34H50C51.1046 34 52 33.1046 52 32C52 30.8954 51.1046 30 50 30H14C12.8954 30 12 30.8954 12 32Z" />
			<path d="M41.4142 47.5858L33.4142 39.5858C32.6332 38.8047 31.3668 38.8047 30.5858 39.5858L22.5858 47.5858C21.8047 48.3668 21.8047 49.6332 22.5858 50.4142C23.3668 51.1953 24.6332 51.1953 25.4142 50.4142L32 43.8284L38.5858 50.4142C39.3668 51.1953 40.6332 51.1953 41.4142 50.4142C42.1953 49.6332 42.1953 48.3668 41.4142 47.5858Z" />
		</motion.g>
	);
}

function AlignBottom(props) {
	return (
		<motion.g>
			<path d="M41.4142 22.4142L33.4142 30.4142C32.6332 31.1953 31.3668 31.1953 30.5858 30.4142L22.5858 22.4142C21.8047 21.6332 21.8047 20.3668 22.5858 19.5858C23.3668 18.8047 24.6332 18.8047 25.4142 19.5858L32 26.1716L38.5858 19.5858C39.3668 18.8047 40.6332 18.8047 41.4142 19.5858C42.1953 20.3668 42.1953 21.6332 41.4142 22.4142Z" />
			<path d="M14 46C12.8954 46 12 45.1046 12 44C12 42.8954 12.8954 42 14 42H50C51.1046 42 52 42.8954 52 44C52 45.1046 51.1046 46 50 46H14Z" />
		</motion.g>
	);
}

function AlignDistribute(props) {
	return (
		<motion.g>
			<path d="M33.4142 51.4142C32.6332 52.1953 31.3668 52.1953 30.5858 51.4142L18.5858 39.4142C17.8047 38.6332 17.8047 37.3668 18.5858 36.5858C19.3668 35.8047 20.6332 35.8047 21.4142 36.5858L32 47.1716L42.5858 36.5858C43.3668 35.8047 44.6332 35.8047 45.4142 36.5858C46.1953 37.3668 46.1953 38.6332 45.4142 39.4142L33.4142 51.4142Z" />
			<path d="M21.4142 27.4142C20.6332 28.1953 19.3668 28.1953 18.5858 27.4142C17.8047 26.6332 17.8047 25.3668 18.5858 24.5858L30.5858 12.5858C31.3668 11.8047 32.6332 11.8047 33.4142 12.5858L45.4142 24.5858C46.1953 25.3668 46.1953 26.6332 45.4142 27.4142C44.6332 28.1953 43.3668 28.1953 42.5858 27.4142L32 16.8284L21.4142 27.4142Z" />
		</motion.g>
	);
}

function LayerAlignLeft(props) {
	return (
		<motion.g>
			<path d="M14.7969 16.7871C13.6923 16.7871 12.7969 17.6825 12.7969 18.7871V46.7871C12.7969 47.8917 13.6923 48.7871 14.7969 48.7871C15.9014 48.7871 16.7969 47.8917 16.7969 46.7871V18.7871C16.7969 17.6825 15.9014 16.7871 14.7969 16.7871Z" />
			<path d="M24.7969 39.7871C24.7969 38.6825 25.6923 37.7871 26.7969 37.7871H40.7969C41.9014 37.7871 42.7969 38.6825 42.7969 39.7871C42.7969 40.8917 41.9014 41.7871 40.7969 41.7871H26.7969C25.6923 41.7871 24.7969 40.8917 24.7969 39.7871Z" />
			<path d="M26.7969 23.7871C25.6923 23.7871 24.7969 24.6825 24.7969 25.7871C24.7969 26.8917 25.6923 27.7871 26.7969 27.7871H49.7969C50.9014 27.7871 51.7969 26.8917 51.7969 25.7871C51.7969 24.6825 50.9014 23.7871 49.7969 23.7871H26.7969Z" />
		</motion.g>
	);
}

function LayerAlignCenter(props) {
	return (
		<motion.g>
			<path d="M32.7969 16.7871C31.6923 16.7871 30.7969 17.6825 30.7969 18.7871V46.7871C30.7969 47.8917 31.6923 48.7871 32.7969 48.7871C33.9014 48.7871 34.7969 47.8917 34.7969 46.7871V18.7871C34.7969 17.6825 33.9014 16.7871 32.7969 16.7871Z" />
			<path d="M21.7969 39.7871C21.7969 38.6825 22.6923 37.7871 23.7969 37.7871H41.7969C42.9014 37.7871 43.7969 38.6825 43.7969 39.7871C43.7969 40.8917 42.9014 41.7871 41.7969 41.7871H23.7969C22.6923 41.7871 21.7969 40.8917 21.7969 39.7871Z" />
			<path d="M18.7969 23.7871C17.6923 23.7871 16.7969 24.6825 16.7969 25.7871C16.7969 26.8917 17.6923 27.7871 18.7969 27.7871H46.7969C47.9014 27.7871 48.7969 26.8917 48.7969 25.7871C48.7969 24.6825 47.9014 23.7871 46.7969 23.7871H18.7969Z" />
		</motion.g>
	);
}

function LayerAlignRight(props) {
	return (
		<motion.g>
			<path d="M50.7969 16.7871C51.9014 16.7871 52.7969 17.6825 52.7969 18.7871V46.7871C52.7969 47.8917 51.9014 48.7871 50.7969 48.7871C49.6923 48.7871 48.7969 47.8917 48.7969 46.7871V18.7871C48.7969 17.6825 49.6923 16.7871 50.7969 16.7871Z" />
			<path d="M40.7969 39.7871C40.7969 38.6825 39.9014 37.7871 38.7969 37.7871H24.7969C23.6923 37.7871 22.7969 38.6825 22.7969 39.7871C22.7969 40.8917 23.6923 41.7871 24.7969 41.7871H38.7969C39.9014 41.7871 40.7969 40.8917 40.7969 39.7871Z" />
			<path d="M38.7969 23.7871C39.9014 23.7871 40.7969 24.6825 40.7969 25.7871C40.7969 26.8917 39.9014 27.7871 38.7969 27.7871H15.7969C14.6923 27.7871 13.7969 26.8917 13.7969 25.7871C13.7969 24.6825 14.6923 23.7871 15.7969 23.7871H38.7969Z" />
		</motion.g>
	);
}

function LayerAlignTop(props) {
	return (
		<motion.g>
			<path d="M16.5938 18.7871C16.5938 17.6825 17.4892 16.7871 18.5938 16.7871L46.5938 16.7871C47.6983 16.7871 48.5938 17.6825 48.5938 18.7871C48.5938 19.8917 47.6983 20.7871 46.5938 20.7871L18.5938 20.7871C17.4892 20.7871 16.5938 19.8917 16.5938 18.7871Z" />
			<path d="M39.5938 27.7871C38.4892 27.7871 37.5938 28.6825 37.5938 29.7871L37.5938 40.7871C37.5938 41.8917 38.4892 42.7871 39.5938 42.7871C40.6983 42.7871 41.5938 41.8917 41.5938 40.7871L41.5938 29.7871C41.5938 28.6825 40.6983 27.7871 39.5938 27.7871Z" />
			<path d="M23.5938 29.7871C23.5938 28.6825 24.4892 27.7871 25.5938 27.7871C26.6983 27.7871 27.5938 28.6825 27.5938 29.7871L27.5938 46.7871C27.5938 47.8917 26.6983 48.7871 25.5938 48.7871C24.4892 48.7871 23.5938 47.8917 23.5938 46.7871L23.5938 29.7871Z" />
		</motion.g>
	);
}

function LayerAlignMiddle(props) {
	return (
		<motion.g>
			<path d="M14.5938 32.7871C14.5937 33.8917 15.6011 34.7871 16.8438 34.7871L48.3438 34.7871C49.5864 34.7871 50.5937 33.8917 50.5938 32.7871C50.5938 31.6825 49.5864 30.7871 48.3438 30.7871L16.8438 30.7871C15.6011 30.7871 14.5938 31.6825 14.5938 32.7871Z" />
			<path d="M39.5938 43.7871C38.4892 43.7871 37.5938 42.8917 37.5938 41.7871L37.5938 23.7871C37.5938 22.6825 38.4892 21.7871 39.5938 21.7871C40.6983 21.7871 41.5938 22.6825 41.5938 23.7871L41.5938 41.7871C41.5938 42.8917 40.6983 43.7871 39.5938 43.7871Z" />
			<path d="M23.5938 46.7871C23.5938 47.8917 24.4892 48.7871 25.5938 48.7871C26.6983 48.7871 27.5938 47.8917 27.5938 46.7871L27.5938 18.7871C27.5938 17.6825 26.6983 16.7871 25.5938 16.7871C24.4892 16.7871 23.5938 17.6825 23.5938 18.7871L23.5938 46.7871Z" />
		</motion.g>
	);
}

function LayerAlignBottom(props) {
	return (
		<motion.g>
			<path d="M16.5937 46.7871C16.5937 47.8917 17.4892 48.7871 18.5938 48.7871L46.5938 48.7871C47.6983 48.7871 48.5937 47.8917 48.5937 46.7871C48.5937 45.6825 47.6983 44.7871 46.5937 44.7871L18.5937 44.7871C17.4892 44.7871 16.5937 45.6825 16.5937 46.7871Z" />
			<path d="M39.5938 37.7871C38.4892 37.7871 37.5938 36.8917 37.5938 35.7871L37.5937 24.7871C37.5937 23.6825 38.4892 22.7871 39.5937 22.7871C40.6983 22.7871 41.5937 23.6825 41.5937 24.7871L41.5937 35.7871C41.5937 36.8917 40.6983 37.7871 39.5938 37.7871Z" />
			<path d="M23.5938 34.7871C23.5938 35.8917 24.4892 36.7871 25.5938 36.7871C26.6983 36.7871 27.5937 35.8917 27.5937 34.7871L27.5937 18.7871C27.5937 17.6825 26.6983 16.7871 25.5937 16.7871C24.4892 16.7871 23.5937 17.6825 23.5937 18.7871L23.5938 34.7871Z" />
		</motion.g>
	);
}

function LayerDistributeVertical(props) {
	return (
		<motion.g>
			<path d="M49.5 46.7871C49.5 47.8917 48.6046 48.7871 47.5 48.7871L16.5 48.7871C15.3954 48.7871 14.5 47.8917 14.5 46.7871C14.5 45.6825 15.3954 44.7871 16.5 44.7871L47.5 44.7871C48.6046 44.7871 49.5 45.6825 49.5 46.7871Z" />
			<path d="M49.5 18.7871C49.5 19.8917 48.6046 20.7871 47.5 20.7871L16.5 20.7871C15.3954 20.7871 14.5 19.8917 14.5 18.7871C14.5 17.6825 15.3954 16.7871 16.5 16.7871L47.5 16.7871C48.6046 16.7871 49.5 17.6825 49.5 18.7871Z" />
			<path d="M23 32.7871C23 33.8917 23.8954 34.7871 25 34.7871L39 34.7871C40.1046 34.7871 41 33.8917 41 32.7871C41 31.6825 40.1046 30.7871 39 30.7871L25 30.7871C23.8954 30.7871 23 31.6825 23 32.7871Z" />
		</motion.g>
	);
}

function LayerDistributeHorizontal(props) {
	return (
		<motion.g>
			<path d="M47 16.7871C48.1046 16.7871 49 17.6825 49 18.7871V46.7871C49 47.8917 48.1046 48.7871 47 48.7871C45.8954 48.7871 45 47.8917 45 46.7871V18.7871C45 17.6825 45.8954 16.7871 47 16.7871Z" />
			<path d="M17 16.7871C18.1046 16.7871 19 17.6825 19 18.7871V46.7871C19 47.8917 18.1046 48.7871 17 48.7871C15.8954 48.7871 15 47.8917 15 46.7871V18.7871C15 17.6825 15.8954 16.7871 17 16.7871Z" />
			<path d="M32 41.7871C33.1046 41.7871 34 40.8917 34 39.7871L34 25.7871C34 24.6825 33.1046 23.7871 32 23.7871C30.8954 23.7871 30 24.6825 30 25.7871L30 39.7871C30 40.8917 30.8954 41.7871 32 41.7871Z" />
		</motion.g>
	);
}

// function TransparentFill(props) {
// 	return (
// 		<motion.g>
// 			<path d="M12.8 20.422V19.1998C12.8 15.6652 15.6654 12.7998 19.2 12.7998H20.4216V20.422H12.8Z" />
// 			<path d="M12.8 35.8574V28.14H20.421V35.8574H12.8Z" />
// 			<path d="M51.2 43.5801V44.7998C51.2 48.3344 48.3347 51.1998 44.8 51.1998H43.5722L43.574 43.5801H51.2Z" />
// 			<path d="M51.2 28.14V35.8574H43.5721V28.1448H35.8566V20.4274H43.5739V28.14H51.2Z" />
// 			<path d="M51.2 20.422H43.5723V12.7998H44.8C48.3347 12.7998 51.2 15.6652 51.2 19.1998V20.422Z" />
// 			<path d="M35.8559 12.7998V20.422H28.1386V12.7998H35.8559Z" />
// 			<path d="M35.8566 43.5801V35.8628H43.574V43.5801H35.8566Z" />
// 			<path d="M28.1397 43.5801H35.8566L35.8552 51.1998H28.1379L28.1397 43.5801Z" />
// 			<path d="M20.4224 43.5801H28.1397V35.8628H20.4224V43.5801Z" />
// 			<path d="M20.421 51.1998H19.2C15.6654 51.1998 12.8 48.3344 12.8 44.7998V43.5801H20.4224L20.421 51.1998Z" />
// 			<path d="M20.4225 20.4274H28.1398V28.14H35.8552V35.8574H28.1379V28.1448H20.4225V20.4274Z" />
// 		</motion.g>
// 	);
// }

function TransparentFill(props) {
	return (
		<motion.g>
			<path d="M12.7996 29.7796V35.4364L35.4362 12.7998H29.7793L12.7996 29.7796Z" />
			<path d="M22.7083 12.7998H19.1996C15.6649 12.7998 12.7996 15.6652 12.7996 19.1998V22.7085L22.7083 12.7998Z" />
			<path d="M42.5072 12.7998L12.7996 42.5075V44.7998C12.7996 45.7829 13.0212 46.7143 13.4173 47.5466L47.5463 13.4176C46.714 13.0215 45.7827 12.7998 44.7996 12.7998H42.5072Z" />
			<path d="M50.8695 17.1655L17.1652 50.8697C17.8043 51.0838 18.4884 51.1998 19.1996 51.1998H22.492L51.1996 22.4923V19.1998C51.1996 18.4886 51.0836 17.8046 50.8695 17.1655Z" />
			<path d="M51.1996 29.5633L29.5631 51.1998H35.2199L51.1996 35.2202V29.5633Z" />
			<path d="M51.1996 42.2913L42.291 51.1998H44.7996C48.3342 51.1998 51.1996 48.3344 51.1996 44.7998V42.2913Z" />
		</motion.g>
	);
}

function TransparentColor(props) {
	return (
		<motion.g>
			<path d="M27.242 8.47363C22.767 9.37437 18.4992 11.5596 15.0295 15.0293C11.5597 18.4991 9.37449 22.7669 8.47375 27.2419L27.242 8.47363Z" />
			<path d="M9.89909 41.3729C9.30806 39.978 8.85499 38.5385 8.53987 37.0753L37.0754 8.53975C38.5386 8.85486 39.9781 9.30794 41.3731 9.89897L9.89909 41.3729Z" />
			<path d="M16.5018 50.3266C15.997 49.8988 15.5057 49.4467 15.0295 48.9705C14.5532 48.4942 14.1012 48.003 13.6733 47.4982L47.4983 13.6732C48.0031 14.1011 48.4944 14.5531 48.9706 15.0293C49.4468 15.5056 49.8989 15.9969 50.3267 16.5016L16.5018 50.3266Z" />
			<path d="M26.9246 55.4601C25.4614 55.145 24.0219 54.6919 22.627 54.1008L54.101 22.6269C54.692 24.0218 55.1451 25.4613 55.4602 26.9245L26.9246 55.4601Z" />
			<path d="M55.5263 36.7579C54.6256 41.2329 52.4403 45.5007 48.9706 48.9705C45.5009 52.4402 41.233 54.6254 36.758 55.5262L55.5263 36.7579Z" />
		</motion.g>
	);
}

// function TransparentColor(props) {
// 	return (
// 		<path
// 			fillRule="evenodd"
// 			clipRule="evenodd"
// 			d="M8.53809 37.0773C8.18559 35.4407 8 33.742 8 32C8 18.7452 18.7452 8 32 8C33.742 8 35.4407 8.1856 37.0773 8.53809C38.5651 8.85861 40.0022 9.31647 41.3735 9.8988C43.6089 10.8481 45.6704 12.127 47.4978 13.674C48.517 14.5368 49.4635 15.483 50.3263 16.5023C53.8658 20.6836 56 26.0926 56 32C56 45.2548 45.2548 56 32 56C22.0709 56 13.55 49.9704 9.89923 41.373C9.3169 40.0018 8.85861 38.5651 8.53809 37.0773ZM30.4445 51.9404C30.9578 51.9799 31.4766 52 32 52C43.0457 52 52 43.0457 52 32C52 31.4766 51.9799 30.9578 51.9404 30.4445L30.4445 51.9404ZM25.7305 50.9976L50.9976 25.7305C50.2216 23.3778 49.0208 21.2182 47.486 19.3426L19.3426 47.486C21.2182 49.0208 23.3778 50.2216 25.7305 50.9976ZM16.5142 44.6576L44.6576 16.5142C42.782 14.9793 40.6224 13.7785 38.2698 13.0025L13.0025 38.2698C13.7785 40.6224 14.9793 42.782 16.5142 44.6576ZM12.0596 33.5558L33.5558 12.0596C33.0424 12.0201 32.5235 12 32 12C20.9543 12 12 20.9543 12 32C12 32.5235 12.0201 33.0424 12.0596 33.5558Z"
// 		/>
// 	);
// }

function Line(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14 29L50 29C51.6569 29 53 30.3431 53 32C53 33.6569 51.6569 35 50 35L14 35C12.3431 35 11 33.6569 11 32C11 30.3431 12.3431 29 14 29Z"
		/>
	);
}

function LineSize(props) {
	return (
		<motion.g>
			<path d="M17.5999 49.5998C17.5999 50.4835 18.3162 51.1998 19.1999 51.1998C20.0835 51.1998 20.7999 50.4835 20.7999 49.5998V14.3998C20.7999 13.5162 20.0835 12.7998 19.1999 12.7998C18.3162 12.7998 17.5999 13.5162 17.5999 14.3998V49.5998Z" />
			<path d="M38 47.5998C38 49.588 39.6118 51.1998 41.6 51.1998C43.5882 51.1998 45.2 49.588 45.2 47.5998V16.3998C45.2 14.4116 43.5882 12.7998 41.6 12.7998C39.6118 12.7998 38 14.4116 38 16.3998V47.5998Z" />
		</motion.g>
	);
}

function LineSizeAlt(props) {
	return (
		<motion.g>
			<path
				d="M50 21L14 21C13.1716 21 12.5 21.6716 12.5 22.5C12.5 23.3284 13.1716 24 14 24L50 24C50.8284 24 51.5 23.3284 51.5 22.5C51.5 21.6716 50.8284 21 50 21Z"
				fillOpacity={0.85}
			/>
			<path d="M48 36L16 36C14.067 36 12.5 37.567 12.5 39.5C12.5 41.433 14.067 43 16 43L48 43C49.933 43 51.5 41.433 51.5 39.5C51.5 37.567 49.933 36 48 36Z" />
		</motion.g>
	);
}

function LineSizeHairline(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 30.4004L48 30.4004C48.8837 30.4004 49.6 31.1167 49.6 32.0004C49.6 32.884 48.8837 33.6004 48 33.6004L16 33.6004C15.1163 33.6004 14.4 32.884 14.4 32.0004C14.4 31.1167 15.1163 30.4004 16 30.4004Z"
		/>
	);
}

function LineSizeThin(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 28.7998L48 28.7998C49.7673 28.7998 51.2 30.2325 51.2 31.9998C51.2 33.7671 49.7673 35.1998 48 35.1998L16 35.1998C14.2327 35.1998 12.8 33.7671 12.8 31.9998C12.8 30.2325 14.2327 28.7998 16 28.7998Z"
		/>
	);
}

function LineSizeThick(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.2 25.5996L44.8 25.5996C48.3346 25.5996 51.2 28.465 51.2 31.9996C51.2 35.5342 48.3346 38.3996 44.8 38.3996L19.2 38.3996C15.6654 38.3996 12.8 35.5342 12.8 31.9996C12.8 28.465 15.6654 25.5996 19.2 25.5996Z"
		/>
	);
}

function LineCap(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M35.0294 10.7869L54.1213 29.8788C55.2929 31.0503 55.2929 32.9498 54.1213 34.1214L35.0294 53.2133C33.8579 54.3849 31.9584 54.3849 30.7868 53.2133C29.6152 52.0417 29.6152 50.1422 30.7868 48.9706L44.7574 35.0001L12 35.0001C10.3431 35.0001 9 33.6569 9 32.0001C9 30.3432 10.3431 29.0001 12 29.0001L44.7574 29.0001L30.7868 15.0295C29.6152 13.858 29.6152 11.9585 30.7868 10.7869C31.9584 9.61531 33.8579 9.61531 35.0294 10.7869Z"
		/>
	);
}

function LineCapStartArrow(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.8764 48.9705L11.6028 33.697C10.6656 32.7597 10.6656 31.2401 11.6028 30.3029L26.8764 15.0294C27.8136 14.0921 29.3332 14.0921 30.2705 15.0294C31.2077 15.9666 31.2077 17.4862 30.2705 18.4235L19.094 29.5999L54.8999 29.5999C56.2254 29.5999 57.2999 30.6744 57.2999 31.9999C57.2999 33.3254 56.2254 34.3999 54.8999 34.3999L19.094 34.3999L30.2705 45.5764C31.2077 46.5136 31.2077 48.0332 30.2705 48.9705C29.3332 49.9077 27.8136 49.9077 26.8764 48.9705Z"
		/>
	);
}

function LineCapStartCircle(props) {
	return (
		<path d="M35.3929 34.7999C34.1159 40.5225 29.0075 44.8 22.9001 44.8C15.8309 44.8 10.1001 39.0692 10.1001 32C10.1001 24.9307 15.8309 19.2 22.9001 19.2C29.0075 19.2 34.1159 23.4774 35.3929 29.2L58.1001 29.1999C59.6465 29.1999 60.9001 30.4535 60.9001 32C60.9001 33.5463 59.6465 34.7999 58.1001 34.7999L35.3929 34.7999Z" />
	);
}

function LineCapStartRound(props) {
	return (
		<path d="M45.2999 16.8H26.0999C17.7052 16.8 10.8999 23.6053 10.8999 32C10.8999 40.3948 17.7052 47.2 26.0999 47.2H45.2999V42.4H26.0999C20.3561 42.4 15.6999 37.7438 15.6999 32C15.6999 26.2563 20.3561 21.6 26.0999 21.6H45.2999V16.8Z" />
	);
}

function LineCapStartFlat(props) {
	return <path d="M45.3 16.8H12.5V47.2H45.3V42.4H17.3V21.6H45.3V16.8Z" />;
}

function LineCapEndArrow(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.1235 48.9705L53.397 33.697C54.3343 32.7597 54.3343 31.2401 53.397 30.3029L38.1235 15.0294C37.1862 14.0921 35.6667 14.0921 34.7294 15.0294C33.7921 15.9666 33.7921 17.4862 34.7294 18.4235L45.9058 29.5999L10.1 29.5999C8.77447 29.5999 7.69995 30.6744 7.69995 31.9999C7.69995 33.3254 8.77447 34.3999 10.1 34.3999L45.9058 34.3999L34.7294 45.5764C33.7921 46.5136 33.7921 48.0332 34.7294 48.9705C35.6666 49.9077 37.1862 49.9077 38.1235 48.9705Z"
		/>
	);
}

function LineCapEndCircle(props) {
	return (
		<path d="M29.6073 34.7999C30.8843 40.5225 35.9927 44.8 42.1001 44.8C49.1693 44.8 54.9001 39.0692 54.9001 32C54.9001 24.9307 49.1693 19.2 42.1001 19.2C35.9927 19.2 30.8843 23.4774 29.6073 29.1999L6.9001 29.1999C5.3537 29.1999 4.1001 30.4535 4.1001 32C4.1001 33.5463 5.3537 34.7999 6.9001 34.7999L29.6073 34.7999Z" />
	);
}

function LineCapEndRound(props) {
	return (
		<path d="M19.7 16.8H38.9C47.2947 16.8 54.1 23.6053 54.1 32C54.1 40.3948 47.2947 47.2 38.9 47.2H19.7V42.4H38.9C44.6437 42.4 49.3 37.7438 49.3 32C49.3 26.2563 44.6437 21.6 38.9 21.6H19.7V16.8Z" />
	);
}

function LineCapEndFlat(props) {
	return <path d="M19.7 16.8H52.4999V47.2H19.7V42.4H47.6999V21.6H19.7V16.8Z" />;
}

function Download(props) {
	return (
		<motion.g>
			<path d="M34 12C34 10.8954 33.1046 10 32 10C30.8954 10 30 10.8954 30 12V35.1716L23.4142 28.5858C22.6332 27.8047 21.3668 27.8047 20.5858 28.5858C19.8047 29.3668 19.8047 30.6332 20.5858 31.4142L30.5858 41.4142C31.3668 42.1953 32.6332 42.1953 33.4142 41.4142L43.4142 31.4142C44.1953 30.6332 44.1953 29.3668 43.4142 28.5858C42.6332 27.8047 41.3668 27.8047 40.5858 28.5858L34 35.1716V12Z" />
			<path d="M14 50C12.8954 50 12 50.8954 12 52C12 53.1046 12.8954 54 14 54H50C51.1046 54 52 53.1046 52 52C52 50.8954 51.1046 50 50 50H14Z" />
		</motion.g>
	);
}

function Search(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38.3358 43.0775C35.5086 44.9256 32.1297 46 28.5 46C18.5589 46 10.5 37.9411 10.5 28C10.5 18.0589 18.5589 10 28.5 10C38.4411 10 46.5 18.0589 46.5 28C46.5 32.1441 45.0996 35.9611 42.7462 39.0035L52.6213 48.8787C53.7929 50.0503 53.7929 51.9497 52.6213 53.1213C51.4497 54.2929 49.5503 54.2929 48.3787 53.1213L38.3787 43.1213C38.3642 43.1068 38.3499 43.0922 38.3358 43.0775ZM42.5 28C42.5 35.732 36.232 42 28.5 42C20.768 42 14.5 35.732 14.5 28C14.5 20.268 20.768 14 28.5 14C36.232 14 42.5 20.268 42.5 28Z"
			/>
		</motion.g>
	);
}

function Globe(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M37.2503 46.7287C35.5017 50.5757 33.4949 52 32 52C30.5051 52 28.4983 50.5757 26.7497 46.7287C25.2754 43.4854 24.2577 39.0376 24.0425 34H39.9575C39.7423 39.0376 38.7246 43.4854 37.2503 46.7287ZM39.9575 30H24.0425C24.2577 24.9624 25.2754 20.5146 26.7497 17.2713C28.4983 13.4243 30.5051 12 32 12C33.4949 12 35.5017 13.4243 37.2503 17.2713C38.7246 20.5146 39.7423 24.9624 39.9575 30ZM43.9608 34C43.7439 39.5152 42.6358 44.5472 40.8918 48.384C40.5761 49.0784 40.2285 49.7553 39.8494 50.4009C46.4095 47.5989 51.1674 41.3913 51.9012 34H43.9608ZM51.9012 30H43.9608C43.7439 24.4848 42.6358 19.4528 40.8918 15.616C40.5761 14.9216 40.2285 14.2447 39.8494 13.5991C46.4095 16.4011 51.1674 22.6087 51.9012 30ZM20.0392 30C20.2562 24.4848 21.3642 19.4528 23.1082 15.616C23.4239 14.9216 23.7715 14.2447 24.1506 13.5991C17.5905 16.4011 12.8326 22.6087 12.0988 30H20.0392ZM12.0988 34C12.8326 41.3913 17.5905 47.5989 24.1506 50.4009C23.7715 49.7553 23.4239 49.0784 23.1082 48.384C21.3642 44.5472 20.2562 39.5152 20.0392 34H12.0988ZM32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z"
			/>
		</motion.g>
	);
}

function DuplicateSquare(props) {
	return (
		<motion.g>
			<path d="M37 27C35.8954 27 35 27.8954 35 29V35H29C27.8954 35 27 35.8954 27 37C27 38.1046 27.8954 39 29 39H35V45C35 46.1046 35.8954 47 37 47C38.1046 47 39 46.1046 39 45V39H45C46.1046 39 47 38.1046 47 37C47 35.8954 46.1046 35 45 35H39V29C39 27.8954 38.1046 27 37 27Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 9C11.6863 9 9 11.6863 9 15V39C9 42.3137 11.6863 45 15 45H19V49C19 52.3137 21.6863 55 25 55H49C52.3137 55 55 52.3137 55 49V25C55 21.6863 52.3137 19 49 19H45V15C45 11.6863 42.3137 9 39 9H15ZM41 19V15C41 13.8954 40.1046 13 39 13H15C13.8954 13 13 13.8954 13 15V39C13 40.1046 13.8954 41 15 41H19V25C19 21.6863 21.6863 19 25 19H41ZM25 23C23.8954 23 23 23.8954 23 25V49C23 50.1046 23.8954 51 25 51H49C50.1046 51 51 50.1046 51 49V25C51 23.8954 50.1046 23 49 23H25Z"
			/>
		</motion.g>
	);
}

function DuplicateLandscape(props) {
	return (
		<motion.g>
			<path d="M37 30C35.8954 30 35 30.8954 35 32V35H32C30.8954 35 30 35.8954 30 37C30 38.1046 30.8954 39 32 39H35V42C35 43.1046 35.8954 44 37 44C38.1046 44 39 43.1046 39 42V39H42C43.1046 39 44 38.1046 44 37C44 35.8954 43.1046 35 42 35H39V32C39 30.8954 38.1046 30 37 30Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 13C10.6863 13 8 15.6863 8 19V35C8 38.3137 10.6863 41 14 41H18V45C18 48.3137 20.6863 51 24 51H50C53.3137 51 56 48.3137 56 45V29C56 25.6863 53.3137 23 50 23H46V19C46 15.6863 43.3137 13 40 13H14ZM42 23V19C42 17.8954 41.1046 17 40 17H14C12.8954 17 12 17.8954 12 19V35C12 36.1046 12.8954 37 14 37H18V29C18 25.6863 20.6863 23 24 23H42ZM24 27C22.8954 27 22 27.8954 22 29V45C22 46.1046 22.8954 47 24 47H50C51.1046 47 52 46.1046 52 45V29C52 27.8954 51.1046 27 50 27H24Z"
			/>
		</motion.g>
	);
}

function Rename(props) {
	return (
		<motion.g>
			<path d="M39 10C38.4477 10 38 10.4477 38 11C38 11.5523 38.4477 12 39 12H44V52H39C38.4477 52 38 52.4477 38 53C38 53.5523 38.4477 54 39 54H51C51.5523 54 52 53.5523 52 53C52 52.4477 51.5523 52 51 52H46V12H51C51.5523 12 52 11.5523 52 11C52 10.4477 51.5523 10 51 10H39Z" />
			<path d="M12 19C12 17.8954 12.8954 17 14 17H34C35.1046 17 36 17.8954 36 19C36 20.1046 35.1046 21 34 21H26V45C26 46.1046 25.1046 47 24 47C22.8954 47 22 46.1046 22 45V21H14C12.8954 21 12 20.1046 12 19Z" />
		</motion.g>
	);
}

function Book(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29.15 50.8534H29.15C25.5124 48.9537 21.4637 47.9768 17.36 48.0086C15.0346 48.0303 12.7213 48.3468 10.4755 48.9503C9.88645 49.1406 9.25462 48.8174 9.0643 48.2283C9.02788 48.1156 9.00955 47.9978 9.01002 47.8793V15.2635V15.2634C9.00986 14.7935 9.30188 14.3729 9.7423 14.2089H9.7423C12.211 13.4467 14.7765 13.0433 17.36 13.011H17.36C21.981 12.9558 26.5228 14.2131 30.4575 16.6367C30.8049 16.8684 31.0126 17.2592 31.01 17.6767V49.7836V49.7836C31.0051 50.47 30.4447 51.0224 29.7584 51.0175C29.5449 51.016 29.3353 50.9595 29.15 50.8534H29.15ZM55.01 15.2634V47.8793V47.8793C55.0124 48.4984 54.5126 49.0022 53.8935 49.0046C53.775 49.0051 53.6572 48.9867 53.5445 48.9503C51.2987 48.3468 48.9854 48.0303 46.66 48.0086C42.5563 47.9768 38.5076 48.9537 34.87 50.8534C34.2743 51.1943 33.515 50.9877 33.1741 50.392C33.068 50.2066 33.0115 49.997 33.01 49.7834V17.6767V17.6767C33.0075 17.2592 33.2151 16.8684 33.5625 16.6367H33.5625C37.4973 14.2131 42.039 12.9558 46.66 13.011H46.66C49.2436 13.0433 51.8092 13.4467 54.278 14.2089C54.7183 14.3731 55.0102 14.7936 55.01 15.2635V15.2634Z"
		/>
	);
}

function PlusSquareOutline(props) {
	return (
		<motion.g>
			<path d="M30 20C30 18.8954 30.8954 18 32 18C33.1046 18 34 18.8954 34 20V30H44C45.1046 30 46 30.8954 46 32C46 33.1046 45.1046 34 44 34H34V44C34 45.1046 33.1046 46 32 46C30.8954 46 30 45.1046 30 44V34H20C18.8954 34 18 33.1046 18 32C18 30.8954 18.8954 30 20 30H30V20Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 18C10 13.5817 13.5817 10 18 10H46C50.4183 10 54 13.5817 54 18V46C54 50.4183 50.4183 54 46 54H18C13.5817 54 10 50.4183 10 46V18ZM14 18C14 15.7909 15.7909 14 18 14H46C48.2091 14 50 15.7909 50 18V46C50 48.2091 48.2091 50 46 50H18C15.7909 50 14 48.2091 14 46V18Z"
			/>
		</motion.g>
	);
}

function PlusSmall(props) {
	return (
		<path d="M30 17C30 15.8954 30.8954 15 32 15C33.1046 15 34 15.8954 34 17V30H47C48.1046 30 49 30.8954 49 32C49 33.1046 48.1046 34 47 34H34V47C34 48.1046 33.1046 49 32 49C30.8954 49 30 48.1046 30 47V34H17C15.8954 34 15 33.1046 15 32C15 30.8954 15.8954 30 17 30H30V17Z" />
	);
}

function Delete(props) {
	return (
		<motion.g>
			<path d="M38.0001 26C38.0001 24.8954 37.1046 24 36.0001 24C34.8955 24 34.0001 24.8954 34.0001 26V46C34.0001 47.1046 34.8955 48 36.0001 48C37.1046 48 38.0001 47.1046 38.0001 46V26Z" />
			<path d="M28.0001 24C29.1046 24 30.0001 24.8954 30.0001 26V46C30.0001 47.1046 29.1046 48 28.0001 48C26.8955 48 26.0001 47.1046 26.0001 46V26C26.0001 24.8954 26.8955 24 28.0001 24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25 8C22.7909 8 21 9.79086 21 12V15.5C21 15.7761 20.7761 16 20.5 16H14C12.8954 16 12 16.8954 12 18C12 19.1046 12.8954 20 14 20H16L17.7901 52.2219C17.9079 54.3415 19.661 56 21.7839 56H42.2161C44.339 56 46.0921 54.3415 46.2099 52.2219L48 20H50C51.1046 20 52 19.1046 52 18C52 16.8954 51.1046 16 50 16H43.5C43.2239 16 43 15.7761 43 15.5V12C43 9.79086 41.2091 8 39 8H25ZM42.9355 20H21.0645C20.4876 20 20.0304 20.4867 20.0664 21.0624L21.9414 51.0624C21.9743 51.5894 22.4114 52 22.9395 52H41.0605C41.5886 52 42.0257 51.5894 42.0586 51.0624L43.9336 21.0624C43.9696 20.4867 43.5124 20 42.9355 20ZM38.75 16H25.25C25.1119 16 25 15.8881 25 15.75V13C25 12.4477 25.4477 12 26 12H38C38.5523 12 39 12.4477 39 13V15.75C39 15.8881 38.8881 16 38.75 16Z"
			/>
		</motion.g>
	);
}

function Checkmark(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.6257 30.8353L26.4175 44.8488L47.3744 14.8566C48.0067 13.9503 49.2546 13.7278 50.1617 14.3595C50.2557 14.425 50.3439 14.4983 50.4253 14.5789C51.1212 15.3103 51.1934 16.4345 50.5967 17.2488L28.4527 48.94C27.6673 50.063 26.1194 50.3373 24.9953 49.5526C24.7565 49.3859 24.549 49.1785 24.3822 48.94L13.4034 33.2278C12.8066 32.4134 12.8788 31.289 13.5748 30.5574C14.3607 29.7803 15.6284 29.7868 16.4062 30.572C16.4868 30.6534 16.5602 30.7414 16.6257 30.8353H16.6257Z"
		/>
	);
}

function ListBullet(props) {
	return (
		<motion.g>
			<path d="M16 22C16 24.2091 14.2091 26 12 26C9.79086 26 8 24.2091 8 22C8 19.7909 9.79086 18 12 18C14.2091 18 16 19.7909 16 22Z" />
			<path d="M26 20C24.8954 20 24 20.8954 24 22C24 23.1046 24.8954 24 26 24H54C55.1046 24 56 23.1046 56 22C56 20.8954 55.1046 20 54 20H26Z" />
			<path d="M26 40C24.8954 40 24 40.8954 24 42C24 43.1046 24.8954 44 26 44H54C55.1046 44 56 43.1046 56 42C56 40.8954 55.1046 40 54 40H26Z" />
			<path d="M12 46C14.2091 46 16 44.2091 16 42C16 39.7909 14.2091 38 12 38C9.79086 38 8 39.7909 8 42C8 44.2091 9.79086 46 12 46Z" />
		</motion.g>
	);
}

function ListNumber(props) {
	return (
		<motion.g>
			<path d="M13.7343 15.9089C14.8389 15.9089 15.7343 16.8044 15.7343 17.9089V27.2229C15.7343 28.2043 14.9387 28.9998 13.9573 28.9998C12.9759 28.9998 12.1803 28.2043 12.1803 27.2229V19.1817H12.1036L11.2044 19.7196C10.3392 20.2372 9.23997 19.6139 9.23997 18.6057C9.23997 18.1535 9.4753 17.7339 9.86114 17.4981L11.9814 16.2024C12.2954 16.0105 12.6563 15.9089 13.0243 15.9089H13.7343Z" />
			<path d="M26.0001 19.9999C24.8955 19.9999 24.0001 20.8954 24.0001 21.9999C24.0001 23.1045 24.8955 23.9999 26.0001 23.9999H54.0001C55.1046 23.9999 56.0001 23.1045 56.0001 21.9999C56.0001 20.8954 55.1046 19.9999 54.0001 19.9999H26.0001Z" />
			<path d="M26.0001 39.9999C24.8955 39.9999 24.0001 40.8954 24.0001 41.9999C24.0001 43.1045 24.8955 43.9999 26.0001 43.9999H54.0001C55.1046 43.9999 56.0001 43.1045 56.0001 41.9999C56.0001 40.8954 55.1046 39.9999 54.0001 39.9999H26.0001Z" />
			<path d="M8.05141 47.9998C8.05141 48.5521 8.49913 48.9998 9.05141 48.9998H16.6807C17.4644 48.9998 18.0997 48.3645 18.0997 47.5808C18.0997 46.7971 17.4644 46.1617 16.6807 46.1617H12.9861V46.085L14.2133 45.0623C15.2105 44.2313 15.9797 43.5154 16.5209 42.9146C17.0621 42.3137 17.4371 41.7661 17.6459 41.2718C17.8547 40.7733 17.9591 40.2725 17.9591 39.7697C17.9591 38.9558 17.7481 38.2463 17.3263 37.6411C16.9087 37.036 16.3142 36.5673 15.5429 36.2349C14.7758 35.8983 13.8682 35.7299 12.8199 35.7299C11.8057 35.7299 10.9214 35.9089 10.1672 36.2669C9.41292 36.6248 8.82911 37.1362 8.41576 37.8009C8.27551 38.0265 8.15905 38.2668 8.06639 38.5218C7.74808 39.3977 8.55125 40.1788 9.48323 40.1788H10.2057C10.7387 40.1788 11.1245 39.7158 11.3753 39.2456C11.5116 38.9899 11.7034 38.796 11.9506 38.6639C12.202 38.5318 12.4918 38.4657 12.8199 38.4657C13.148 38.4657 13.4378 38.5318 13.6892 38.6639C13.9406 38.7917 14.1366 38.975 14.2773 39.2136C14.4222 39.4522 14.4946 39.7399 14.4946 40.0765C14.4946 40.3833 14.4307 40.6625 14.3028 40.9139C14.1793 41.1653 14.0003 41.4103 13.7659 41.649C13.5358 41.8833 13.2588 42.1348 12.9349 42.4032L8.77661 45.8431C8.3173 46.223 8.05141 46.7881 8.05141 47.3842V47.9998Z" />
		</motion.g>
	);
}

function Dropdown(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M54.2671 18.7125C56.3037 20.4096 56.5788 23.4363 54.8817 25.4729L38.6334 44.9708C35.1794 49.1157 28.8133 49.1157 25.3592 44.9708L9.11095 25.4729C7.41384 23.4363 7.689 20.4096 9.72553 18.7125C11.7621 17.0154 14.7888 17.2906 16.4859 19.3271L31.9963 37.9396L47.5068 19.3271C49.2039 17.2906 52.2306 17.0154 54.2671 18.7125Z"
		/>
	);
}

function CaretDown(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.8643 26.9562C21.8826 26.1077 23.396 26.2453 24.2445 27.2635L31.9998 36.5698L39.755 27.2635C40.6035 26.2453 42.1169 26.1077 43.1352 26.9562C44.1534 27.8048 44.291 29.3181 43.4424 30.3364L35.3183 40.0854C33.5913 42.1578 30.4082 42.1578 28.6812 40.0854L20.5571 30.3364C19.7085 29.3181 19.8461 27.8048 20.8643 26.9562Z"
		/>
	);
}

function ArrowLeft(props) {
	return (
		<path
			d="M52.01 34.0209H16.8385L28.4256 45.5938C29.2109 46.3718 29.2168 47.6392 28.4388 48.4245C27.6607 49.2098 26.3934 49.2157 25.6081 48.4376C25.6031 48.4327 25.5982 48.4277 25.5932 48.4227L10.5707 33.4183C9.7895 32.6388 9.7881 31.3736 10.5676 30.5924C10.5686 30.5914 10.5697 30.5903 10.5707 30.5893L25.5932 15.5848C26.3708 14.799 27.6382 14.7924 28.424 15.57C29.2098 16.3476 29.2164 17.615 28.4388 18.4008C28.4344 18.4052 28.43 18.4096 28.4256 18.414L16.8046 30.0209H52.01C53.1146 30.0209 54.01 30.9163 54.01 32.0209C54.01 33.1255 53.1146 34.0209 52.01 34.0209V34.0209Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}
function ArrowRight(props) {
	return (
		<path
			d="M38.4276 48.4568C37.6464 49.239 36.3791 49.2398 35.5969 48.4585C34.8148 47.6773 34.814 46.41 35.5952 45.6278L47.2162 34.0209H12.01C10.9054 34.0209 10.01 33.1255 10.01 32.0209C10.01 30.9164 10.9054 30.0209 12.01 30.0209H47.1823L35.5952 18.4478C34.814 17.6657 34.8148 16.3984 35.5969 15.6171C36.3791 14.8359 37.6464 14.8367 38.4276 15.6188L53.45 30.6233C54.2312 31.403 54.2326 32.6683 53.4529 33.4495C53.452 33.4505 53.451 33.4515 53.45 33.4524L38.4276 48.4568Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function ArrowUp(props) {
	return (
		<path
			d="M30.5858 10.5858C31.3668 9.80474 32.6332 9.80474 33.4142 10.5858L48.4142 25.5858C49.1953 26.3668 49.1953 27.6332 48.4142 28.4142C47.6332 29.1953 46.3668 29.1953 45.5858 28.4142L34 16.8284V52C34 53.1046 33.1046 54 32 54C30.8954 54 30 53.1046 30 52V16.8284L18.4142 28.4142C17.6332 29.1953 16.3668 29.1953 15.5858 28.4142C14.8047 27.6332 14.8047 26.3668 15.5858 25.5858L30.5858 10.5858Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function ArrowTopRight(props) {
	return (
		<path
			d="M23 18C23 16.8954 23.8954 16 25 16H46C47.1046 16 48 16.8954 48 18V39C48 40.1046 47.1046 41 46 41C44.8954 41 44 40.1046 44 39V22.8284L19.4142 47.4142C18.6332 48.1953 17.3668 48.1953 16.5858 47.4142C15.8047 46.6332 15.8047 45.3668 16.5858 44.5858L41.1716 20H25C23.8954 20 23 19.1046 23 18Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function ArrowLeftRightOut(props) {
	return (
		<path
			d="M21.4142 20.5858C22.1953 21.3668 22.1953 22.6332 21.4142 23.4142L14.8284 30H49.1716L42.5858 23.4142C41.8047 22.6332 41.8047 21.3668 42.5858 20.5858C43.3668 19.8047 44.6332 19.8047 45.4142 20.5858L55.4142 30.5858C56.1953 31.3668 56.1953 32.6332 55.4142 33.4142L45.4142 43.4142C44.6332 44.1953 43.3668 44.1953 42.5858 43.4142C41.8047 42.6332 41.8047 41.3668 42.5858 40.5858L49.1716 34H14.8284L21.4142 40.5858C22.1953 41.3668 22.1953 42.6332 21.4142 43.4142C20.6332 44.1953 19.3668 44.1953 18.5858 43.4142L8.58579 33.4142C7.80474 32.6332 7.80474 31.3668 8.58579 30.5858L18.5858 20.5858C19.3668 19.8047 20.6332 19.8047 21.4142 20.5858Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function ArrowUpDown(props) {
	return (
		<path
			d="M30.5858 8.58579C31.3668 7.80474 32.6332 7.80474 33.4142 8.58579L43.4142 18.5858C44.1953 19.3668 44.1953 20.6332 43.4142 21.4142C42.6332 22.1953 41.3668 22.1953 40.5858 21.4142L34 14.8284V49.1716L40.5858 42.5858C41.3668 41.8047 42.6332 41.8047 43.4142 42.5858C44.1953 43.3668 44.1953 44.6332 43.4142 45.4142L33.4142 55.4142C32.6332 56.1953 31.3668 56.1953 30.5858 55.4142L20.5858 45.4142C19.8047 44.6332 19.8047 43.3668 20.5858 42.5858C21.3668 41.8047 22.6332 41.8047 23.4142 42.5858L30 49.1716V14.8284L23.4142 21.4142C22.6332 22.1953 21.3668 22.1953 20.5858 21.4142C19.8047 20.6332 19.8047 19.3668 20.5858 18.5858L30.5858 8.58579Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	);
}

function Theme(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32C56 45.2548 45.2548 56 32 56ZM32 52C43.0457 52 52 43.0457 52 32C52 20.9543 43.0457 12 32 12V52Z"
		/>
	);
}

function Compose(props) {
	return (
		<g>
			<path d="M30.6338 30.4809L50.5899 10.5248C51.371 9.74376 52.6373 9.74376 53.4184 10.5248C54.1994 11.3059 54.1994 12.5722 53.4184 13.3532L33.4622 33.3094C33.0445 33.7271 32.5818 34.0973 32.0825 34.4131L27.012 37.621C26.5613 37.9061 26.037 37.3818 26.3222 36.9311L29.53 31.8607C29.8459 31.3614 30.2161 30.8987 30.6338 30.4809Z" />
			<path d="M52.01 46.0209V28.02C52.01 26.9154 51.1146 26.02 50.01 26.02C48.9054 26.02 48.01 26.9154 48.01 28.02V46.0209C48.0089 47.1251 47.1142 48.02 46.01 48.0215H18.01C16.9057 48.0202 16.011 47.1252 16.01 46.0209V18.0146C16.011 16.9103 16.9057 16.0153 18.01 16.014H36.01C37.115 16.014 38.0107 15.1183 38.0107 14.0133C38.0107 12.9083 37.115 12.0126 36.01 12.0126H18.01C14.6973 12.0169 12.0132 14.7019 12.0101 18.0146V46.0209C12.0132 49.3337 14.6974 52.0188 18.0101 52.023H46.0101C49.3229 52.0187 52.007 49.3337 52.01 46.0209Z" />
		</g>
	);
}

function ChevronDown(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M33.4079 43.4299C32.6276 44.2111 31.3618 44.2119 30.5806 43.4316C30.58 43.4311 30.5794 43.4305 30.5789 43.4299L15.5744 28.4177V28.4177C14.7825 27.6469 14.7654 26.3802 15.5362 25.5883C16.307 24.7964 17.5738 24.7794 18.3657 25.5501C18.3784 25.5625 18.3909 25.575 18.4033 25.5877L31.9933 39.1845L45.5833 25.5877C46.3535 24.7953 47.6204 24.7773 48.4128 25.5476C49.2053 26.3179 49.2233 27.5847 48.453 28.3772C48.4396 28.3909 48.4261 28.4044 48.4124 28.4177L33.4079 43.4299Z"
		/>
	);
}

function ChevronLeft(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.4256 48.4227H38.4256C37.6432 49.2043 36.3755 49.2043 35.5932 48.4227L20.5707 33.4183C19.7894 32.6387 19.7881 31.3734 20.5677 30.5921C20.5687 30.5911 20.5697 30.5902 20.5707 30.5892L35.5932 15.5848C36.3744 14.8026 37.6417 14.8019 38.4239 15.5831C39.206 16.3643 39.2068 17.6316 38.4256 18.4138L24.8192 32.0038L38.4256 45.5938C39.2068 46.3732 39.2082 47.6383 38.4287 48.4195C38.4277 48.4206 38.4266 48.4216 38.4256 48.4227V48.4227Z"
		/>
	);
}

function ChevronRight(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.4276 48.4568C27.6464 49.239 26.379 49.2398 25.5969 48.4585C24.8147 47.6773 24.814 46.41 25.5952 45.6278L39.2016 32.0378L25.5952 18.4478C24.814 17.6657 24.8147 16.3984 25.5969 15.6171C26.379 14.8359 27.6464 14.8367 28.4276 15.6188L43.45 30.6233C44.2312 31.403 44.2325 32.6683 43.4529 33.4495C43.4519 33.4505 43.451 33.4515 43.45 33.4524L28.4276 48.4568Z"
		/>
	);
}

function Return(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 12C32 10.8954 32.8954 10 34 10H46C50.4183 10 54 13.5817 54 18V31C54 35.4183 50.4183 39 46 39H16.8284L24.4142 46.5858C25.1953 47.3668 25.1953 48.6332 24.4142 49.4142C23.6332 50.1953 22.3668 50.1953 21.5858 49.4142L10.5858 38.4142C9.80474 37.6332 9.80474 36.3668 10.5858 35.5858L21.5858 24.5858C22.3668 23.8047 23.6332 23.8047 24.4142 24.5858C25.1953 25.3668 25.1953 26.6332 24.4142 27.4142L16.8284 35H46C48.2091 35 50 33.2091 50 31V18C50 15.7909 48.2091 14 46 14H34C32.8954 14 32 13.1046 32 12Z"
		/>
	);
}

function CircleRemove(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 32C8 45.2548 18.7452 56 32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32ZM11.9996 32.0005C11.9993 20.9543 20.9538 11.9994 32 11.9991C36.8027 11.9991 41.2102 13.6919 44.6582 16.5134L16.5137 44.6578C13.6924 41.2101 11.9997 36.803 11.9996 32.0005ZM19.3421 47.4863C22.7902 50.3081 27.1979 52.001 32.001 52.0009C43.047 52.0006 52.0014 43.046 52.0014 32C52.0014 27.1971 50.3084 22.7896 47.4867 19.3417L19.3421 47.4863Z"
		/>
	);
}

function HelpFill(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0021 55.9843H32.0021C18.7473 55.9843 8.00208 45.2391 8.00208 31.9843C8.00208 18.7295 18.7473 7.98425 32.0021 7.98425C45.2569 7.98425 56.0021 18.7295 56.0021 31.9843V31.9843C56.0021 45.2391 45.2569 55.9843 32.0021 55.9843H32.0021ZM34.2521 35.9843C34.2521 36.5365 33.8044 36.9843 33.2521 36.9843H31.0021C30.4498 36.9843 30.0021 36.5365 30.0021 35.9843C30.0021 29.3398 35.6271 29.966 35.6271 24.9843C35.6271 23.3274 33.7471 21.9843 31.8146 21.9843C29.8821 21.9843 27.971 23.3274 27.971 24.9843V24.9843C27.9643 25.5534 28.0521 26.1196 28.231 26.66C28.4126 27.1789 28.1392 27.7468 27.6203 27.9285C27.5144 27.9655 27.4031 27.9844 27.291 27.9844H25.26C24.809 27.9855 24.4126 27.6858 24.2907 27.2517C24.0914 26.5126 23.9943 25.7497 24.0024 24.9843C24.0024 21.1183 27.5841 17.9843 32.0024 17.9843C36.4207 17.9843 40.0024 21.1182 40.0024 24.9843C40.0021 31.4012 34.2521 31.1512 34.2521 35.9844L34.2521 35.9843ZM32.0021 39.9843H32.0021C33.6589 39.9843 35.0021 41.3274 35.0021 42.9843C35.0021 44.6411 33.6589 45.9843 32.0021 45.9843C30.3452 45.9843 29.0021 44.6411 29.0021 42.9843V42.9844C29.0021 41.3275 30.3452 39.9844 32.002 39.9844L32.0021 39.9843Z"
		/>
	);
}

function PlayFilled(props) {
	return (
		<path d="M20 46.6907V17.3096C20 14.6432 22.8944 12.9836 25.1956 14.3306L50.292 29.0212C52.5693 30.3543 52.5693 33.646 50.292 34.9791L25.1956 49.6697C22.8944 51.0167 20 49.3571 20 46.6907Z" />
	);
}

function PlaybackPlay(props) {
	return (
		<path d="M20 46.6906V17.3094C20 14.643 22.8944 12.9835 25.1956 14.3305L50.292 29.021C52.5693 30.3541 52.5693 33.6459 50.292 34.979L25.1956 49.6695C22.8944 51.0165 20 49.357 20 46.6906Z" />
	);
}

function PlaybackPlayButton(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56ZM25 22.7434V41.0127C25 42.6707 26.7998 43.7026 28.2306 42.865L43.8356 33.7304C45.2517 32.9015 45.2517 30.8546 43.8356 30.0257L28.2306 20.8911C26.7998 20.0535 25 21.0854 25 22.7434Z"
		/>
	);
}

function PlaybackPause(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.01 50.0208H19.01C17.3532 50.0208 16.01 48.6776 16.01 47.0208V17.0208C16.01 15.3639 17.3532 14.0208 19.01 14.0208H25.01C26.6669 14.0208 28.01 15.3639 28.01 17.0208V47.0208C28.01 48.6776 26.6669 50.0208 25.01 50.0208ZM39.01 50.0208C37.3532 50.0208 36.01 48.6776 36.01 47.0208V17.0208C36.01 15.3639 37.3532 14.0208 39.01 14.0208H45.01C46.6669 14.0208 48.01 15.3639 48.01 17.0208V47.0208C48.01 48.6776 46.6669 50.0208 45.01 50.0208H39.01Z"
		/>
	);
}

function Trim(props) {
	return (
		<g>
			<path d="M18 10C14.6863 10 12 12.6863 12 16V48C12 51.3137 14.6863 54 18 54H24C25.1046 54 26 53.1046 26 52C26 50.8954 25.1046 50 24 50H18C16.8954 50 16 49.1046 16 48V16C16 14.8954 16.8954 14 18 14H24C25.1046 14 26 13.1046 26 12C26 10.8954 25.1046 10 24 10H18Z" />
			<path d="M46 10C49.3137 10 52 12.6863 52 16V48C52 51.3137 49.3137 54 46 54H40C38.8954 54 38 53.1046 38 52C38 50.8954 38.8954 50 40 50H46C47.1046 50 48 49.1046 48 48V16C48 14.8954 47.1046 14 46 14H40C38.8954 14 38 13.1046 38 12C38 10.8954 38.8954 10 40 10H46Z" />
		</g>
	);
}

function VolumeHigh(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M44.5379 50.3322C43.8013 49.5178 43.8642 48.2603 44.6784 47.5235C44.6843 47.5182 44.6902 47.5129 44.6961 47.5077H44.6961C53.2614 40.4445 54.4803 27.7736 47.4187 19.2063C46.6004 18.2136 45.6887 17.3016 44.6961 16.4831C43.8731 15.756 43.7953 14.4992 44.5223 13.676C44.5274 13.6702 44.5326 13.6643 44.5379 13.6585C45.28 12.8537 46.5269 12.7836 47.3546 13.5001C57.567 22.0372 58.9267 37.2385 50.3915 47.4533C49.4716 48.5542 48.4553 49.5708 47.3546 50.4909C46.5269 51.2074 45.2799 51.1372 44.5379 50.3323V50.3322ZM40.016 45.7512C39.0609 46.2871 37.8532 45.9752 37.2769 45.0437C36.7075 44.1152 36.9985 42.9007 37.9268 42.3312C37.9453 42.3199 37.9639 42.3088 37.9828 42.2981C43.6717 39.089 45.6826 31.8748 42.4742 26.1845C41.4147 24.3054 39.8615 22.7518 37.9828 21.6921C37.0362 21.1535 36.7053 19.9493 37.2438 19.0025C37.2545 18.9836 37.2656 18.9649 37.2769 18.9464V18.9464C37.8532 18.0149 39.0609 17.703 40.016 18.239C47.6116 22.5778 50.2525 32.2539 45.9146 39.8512C44.5109 42.3098 42.474 44.3471 40.016 45.7512L40.016 45.7512ZM8 26.0016V26.0014C8.00057 24.3438 9.3444 23.0005 11.0016 23.0009H16.5022C17.5631 23.0009 18.5805 22.5797 19.331 21.8299L27.5832 13.5854C28.3654 12.8041 29.6326 12.805 30.4137 13.5873C30.7882 13.9624 30.9986 14.4707 30.9989 15.0008V48.9984V48.9983C30.9984 50.1044 30.1015 51.0005 28.9957 51C28.4654 50.9997 27.9569 50.7891 27.5817 50.4142L19.3379 42.1775C18.5873 41.4276 17.5698 41.0065 16.5089 41.0066H11.0015H11.0015C9.34425 41.007 8.00045 39.6636 8.00001 38.0059L8 26.0016Z"
		/>
	);
}

function VolumeMid(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.509 41.0067H11.0017C9.34439 41.0071 8.0005 39.6637 8 38.0061V26.0019V26.0017C8.00057 24.3441 9.34452 23.0007 11.0018 23.0012H16.5018C17.5627 23.0013 18.5801 22.5801 19.3306 21.8303L27.5828 13.5859C28.3647 12.8044 29.6319 12.8048 30.4132 13.5868C30.7882 13.962 30.9989 14.4708 30.999 15.0013V48.9983V48.9983C30.9986 50.1042 30.102 51.0004 28.9963 51C28.4659 50.9998 27.9573 50.7891 27.5821 50.4142L19.3381 42.178C18.5875 41.428 17.57 41.0067 16.509 41.0067H16.509ZM37.9828 21.6927C37.0363 21.1541 36.7055 19.95 37.2439 19.0032C37.2547 18.9843 37.2657 18.9656 37.2771 18.9471C37.8532 18.0156 39.061 17.7036 40.016 18.2396C47.6116 22.5783 50.2526 32.2542 45.9148 39.8513C44.5111 42.31 42.4741 44.3473 40.016 45.7514C39.061 46.2874 37.8533 45.9755 37.2771 45.044C36.7076 44.1155 36.9985 42.9012 37.9267 42.3316C37.9452 42.3202 37.9639 42.3091 37.9828 42.2984C43.6717 39.0895 45.6827 31.8754 42.4744 26.1852C41.4149 24.306 39.8616 22.7525 37.9828 21.6927V21.6927Z"
		/>
	);
}

function VolumeOff(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M39.0073 15.0142V31.0871V31.0871C39.0068 31.6088 38.5834 32.0313 38.0617 32.0307C37.8116 32.0305 37.5718 31.931 37.3949 31.7542L28.4372 22.8047C27.8658 22.2343 27.865 21.3086 28.4354 20.7372C28.4363 20.7364 28.4371 20.7355 28.438 20.7347L35.59 13.5987C36.3727 12.8173 37.6406 12.8184 38.422 13.601C38.7964 13.9761 39.0069 14.4842 39.0073 15.0142L39.0073 15.0142ZM18.8472 24.5301L37.8352 43.501C38.5856 44.2504 39.0073 45.2673 39.0073 46.3278V48.9878C39.006 50.0942 38.1081 50.9901 37.0017 50.9888C36.4719 50.9882 35.9638 50.7777 35.5888 50.4034L27.3388 42.1719C26.5874 41.4225 25.5694 41.0017 24.5082 41.0019H18.9972C17.3394 41.0028 15.9946 39.6597 15.9936 38.0019V26.0079V26.0078C15.9933 25.7056 16.0393 25.4051 16.1302 25.1169C16.4382 24.2651 17.3783 23.8243 18.2301 24.1322C18.4632 24.2165 18.6742 24.3525 18.8472 24.5301L18.8472 24.5301ZM10.5672 10.5971C11.3488 9.81594 12.6156 9.81594 13.3972 10.5971L53.4312 50.6025C54.2124 51.3842 54.212 52.651 53.4303 53.4322C52.6487 54.2133 51.3818 54.213 50.6006 53.4313L10.5676 13.4263C9.78648 12.6461 9.78572 11.3804 10.5659 10.5993C10.5665 10.5987 10.567 10.5982 10.5676 10.5976L10.5672 10.5971Z"
		/>
	);
}

function Waveform(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.6402 37.3423C13.1763 37.3423 13.6205 37.1584 13.9729 36.7908C14.3405 36.4232 14.5243 35.9866 14.5243 35.4811V28.5189C14.5243 28.0134 14.3405 27.5768 13.9729 27.2092C13.6205 26.8262 13.1763 26.6348 12.6402 26.6348C12.1347 26.6348 11.7058 26.8262 11.3534 27.2092C11.0011 27.5768 10.825 28.0134 10.825 28.5189V35.4811C10.825 35.9866 11.0011 36.4232 11.3534 36.7908C11.7058 37.1584 12.1347 37.3423 12.6402 37.3423ZM20.3836 46.7401C20.9197 46.7401 21.364 46.5639 21.7163 46.2116C22.0686 45.8439 22.2448 45.3997 22.2448 44.8789V19.1211C22.2448 18.6003 22.0686 18.1561 21.7163 17.7884C21.364 17.4208 20.9197 17.237 20.3836 17.237C19.8628 17.237 19.4262 17.4208 19.0739 17.7884C18.7216 18.1561 18.5454 18.6003 18.5454 19.1211V44.8789C18.5454 45.3997 18.7216 45.8439 19.0739 46.2116C19.4262 46.5639 19.8628 46.7401 20.3836 46.7401ZM28.104 56C28.6402 56 29.0844 55.8162 29.4367 55.4485C29.8044 55.0962 29.9882 54.6596 29.9882 54.1388V9.86118C29.9882 9.34035 29.8044 8.90378 29.4367 8.55146C29.0844 8.18382 28.6402 8 28.104 8C27.5832 8 27.1466 8.18382 26.7943 8.55146C26.4573 8.90378 26.2888 9.34035 26.2888 9.86118V54.1388C26.2888 54.6596 26.4573 55.0962 26.7943 55.4485C27.1466 55.8162 27.5832 56 28.104 56ZM35.8475 43.9368C36.3683 43.9368 36.8048 43.7607 37.1572 43.4083C37.5248 43.056 37.7086 42.6194 37.7086 42.0986V21.9014C37.7086 21.3806 37.5248 20.944 37.1572 20.5917C36.8048 20.224 36.3683 20.0402 35.8475 20.0402C35.3266 20.0402 34.8901 20.224 34.5377 20.5917C34.1854 20.944 34.0093 21.3806 34.0093 21.9014V42.0986C34.0093 42.6194 34.1854 43.056 34.5377 43.4083C34.8901 43.7607 35.3266 43.9368 35.8475 43.9368ZM43.5909 50.899C44.1117 50.899 44.5483 50.7152 44.9006 50.3475C45.2529 49.9952 45.4291 49.5663 45.4291 49.0608V14.9392C45.4291 14.4337 45.2529 13.9971 44.9006 13.6295C44.5483 13.2618 44.1117 13.078 43.5909 13.078C43.0547 13.078 42.6105 13.2618 42.2582 13.6295C41.9059 13.9971 41.7297 14.4337 41.7297 14.9392V49.0608C41.7297 49.5663 41.9059 49.9952 42.2582 50.3475C42.6105 50.7152 43.0547 50.899 43.5909 50.899ZM51.3113 39.3183C51.8321 39.3183 52.2687 39.1422 52.621 38.7899C52.9887 38.4222 53.1725 37.9856 53.1725 37.4801V26.5199C53.1725 26.0144 52.9887 25.5778 52.621 25.2101C52.2687 24.8425 51.8321 24.6587 51.3113 24.6587C50.7752 24.6587 50.3309 24.8425 49.9786 25.2101C49.6416 25.5778 49.4731 26.0144 49.4731 26.5199V37.4801C49.4731 37.9856 49.6416 38.4222 49.9786 38.7899C50.3309 39.1422 50.7752 39.3183 51.3113 39.3183Z"
		/>
	);
}

function Comment(props) {
	return (
		<g>
			<path d="M19 26C19 24.8954 19.8954 24 21 24H43C44.1046 24 45 24.8954 45 26C45 27.1046 44.1046 28 43 28H21C19.8954 28 19 27.1046 19 26Z" />
			<path d="M21 32C19.8954 32 19 32.8954 19 34C19 35.1046 19.8954 36 21 36H37C38.1046 36 39 35.1046 39 34C39 32.8954 38.1046 32 37 32H21Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 22V38.4706C10 42.629 13.371 46 17.5294 46C17.7893 46 18 46.2107 18 46.4706V51.7299C18 53.4256 19.9777 54.3519 21.2804 53.2664L29.4437 46.4636C29.8032 46.164 30.2562 46 30.7241 46H46C50.4183 46 54 42.4183 54 38V22C54 17.5817 50.4183 14 46 14H18C13.5817 14 10 17.5817 10 22ZM14 22V38C14 40.2091 15.7909 42 18 42H21C21.5523 42 22 42.4477 22 43V46.9129C22 47.3401 22.5011 47.5705 22.8254 47.2925L28.4383 42.4815C28.8008 42.1708 29.2624 42 29.7398 42H46C48.2091 42 50 40.2091 50 38V22C50 19.7909 48.2091 18 46 18H18C15.7909 18 14 19.7909 14 22Z"
			/>
		</g>
	);
}

function CommentFill(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 38.4706V22C10 17.5817 13.5817 14 18 14H46C50.4183 14 54 17.5817 54 22V38C54 42.4183 50.4183 46 46 46H30.7241C30.2562 46 29.8032 46.164 29.4437 46.4636L21.2804 53.2664C19.9777 54.3519 18 53.4256 18 51.7299V46.4706C18 46.2107 17.7893 46 17.5294 46C13.371 46 10 42.629 10 38.4706ZM19 26C19 24.8954 19.8954 24 21 24H43C44.1046 24 45 24.8954 45 26C45 27.1046 44.1046 28 43 28H21C19.8954 28 19 27.1046 19 26ZM21 32C19.8954 32 19 32.8954 19 34C19 35.1046 19.8954 36 21 36H37C38.1046 36 39 35.1046 39 34C39 32.8954 38.1046 32 37 32H21Z"
		/>
	);
}

function Close(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M47.4142 47.4355C46.6328 48.2172 45.3658 48.2174 44.5841 47.4361C44.5839 47.4359 44.5837 47.4357 44.5835 47.4355L31.9835 34.8355L19.3951 47.4246C18.6093 48.2021 17.342 48.1953 16.5645 47.4095C15.7928 46.6296 15.7928 45.3738 16.5645 44.5939L29.1533 32.0052L16.5668 19.4187C15.7965 18.6258 15.8148 17.3587 16.6077 16.5884C17.3843 15.8339 18.6201 15.8338 19.3968 16.5882L31.9838 29.1746L44.5813 16.5772C45.3526 15.7853 46.6198 15.7687 47.4116 16.54C48.2034 17.3113 48.2201 18.5784 47.4488 19.3703C47.4365 19.3829 47.424 19.3954 47.4113 19.4078L34.8145 32.0052L47.4145 44.6052C48.196 45.3866 48.1961 46.6535 47.4147 47.435C47.4145 47.4352 47.4144 47.4353 47.4142 47.4355L47.4142 47.4355Z"
		/>
	);
}

function Clear(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.01 8.02002H32.01C45.2654 8.01947 56.0114 18.7646 56.012 32.02C56.0126 45.2754 45.2674 56.0214 32.012 56.022C18.7566 56.0226 8.01061 45.2774 8.01001 32.022C8.01001 32.0216 8.01001 32.0212 8.01001 32.0208V32.0209C8.01001 18.766 18.755 8.02062 32.0099 8.02002L32.01 8.02002ZM21.5957 39.594C20.8254 40.3869 20.8437 41.6541 21.6366 42.4244C22.4135 43.1792 23.6498 43.179 24.4265 42.424L31.9995 34.8509L39.5837 42.435C40.3757 43.2061 41.6429 43.1892 42.414 42.3972C43.1707 41.62 43.1706 40.3815 42.4137 39.6044L34.83 32.0207L42.4432 24.4077C43.2093 23.6108 43.1844 22.3438 42.3875 21.5777C41.6127 20.8329 40.388 20.8329 39.6132 21.5777L31.9995 29.19L24.3976 21.588C23.616 20.8063 22.3486 20.8062 21.5669 21.5879C20.7851 22.3695 20.7851 23.6369 21.5667 24.4186L29.1689 32.0206L21.5957 39.594Z"
		/>
	);
}

function Photo(props) {
	return (
		<g>
			<path d="M28 27C28 29.7614 25.7614 32 23 32C20.2386 32 18 29.7614 18 27C18 24.2386 20.2386 22 23 22C25.7614 22 28 24.2386 28 27Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 12C11.5817 12 8 15.5817 8 20V44C8 48.4183 11.5817 52 16 52H48C52.4183 52 56 48.4183 56 44V20C56 15.5817 52.4183 12 48 12H16ZM48 16H16C13.7909 16 12 17.7909 12 20V44C12 46.2091 13.7909 48 16 48H20.1414L36.1548 31.1437C38.2151 28.975 41.5581 28.6551 43.9923 30.3938L52 36.1136V20C52 17.7909 50.2091 16 48 16ZM52 41.0292L41.6673 33.6487C40.8559 33.0692 39.7416 33.1758 39.0548 33.8987L25.6586 48H48C50.2091 48 52 46.2091 52 44V41.0292Z"
			/>
		</g>
	);
}

function Add(props) {
	return (
		<path d="M34.4999 14.0001C34.4999 12.6193 33.3807 11.5001 31.9999 11.5001C30.6192 11.5001 29.4999 12.6193 29.4999 14.0001V29.5H14C12.6193 29.5 11.5 30.6193 11.5 32C11.5 33.3807 12.6193 34.5 14 34.5H29.4999V50.0001C29.4999 51.3808 30.6192 52.5001 31.9999 52.5001C33.3807 52.5001 34.4999 51.3808 34.4999 50.0001V34.5H50C51.3807 34.5 52.5 33.3807 52.5 32C52.5 30.6193 51.3807 29.5 50 29.5H34.4999V14.0001Z" />
	);
}

function Record(props) {
	return (
		<g>
			<path d="M32 42C37.5228 42 42 37.5228 42 32C42 26.4772 37.5228 22 32 22C26.4772 22 22 26.4772 22 32C22 37.5228 26.4772 42 32 42Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM52 32C52 43.0457 43.0457 52 32 52C20.9543 52 12 43.0457 12 32C12 20.9543 20.9543 12 32 12C43.0457 12 52 20.9543 52 32Z"
			/>
		</g>
	);
}

function Up(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.0858 26.9142C13.8668 27.6953 15.1332 27.6953 15.9142 26.9142L23.5 19.3284V41C23.5 49.0081 29.9919 55.5 38 55.5C46.0081 55.5 52.5 49.0081 52.5 41V36.5C52.5 35.3954 51.6046 34.5 50.5 34.5C49.3954 34.5 48.5 35.3954 48.5 36.5V41C48.5 46.799 43.799 51.5 38 51.5C32.201 51.5 27.5 46.799 27.5 41V19.3284L35.0858 26.9142C35.8668 27.6953 37.1332 27.6953 37.9142 26.9142C38.6953 26.1332 38.6953 24.8668 37.9142 24.0858L26.9142 13.0858C26.1332 12.3047 24.8668 12.3047 24.0858 13.0858L13.0858 24.0858C12.3047 24.8668 12.3047 26.1332 13.0858 26.9142Z"
		/>
	);
}

function MagicWand(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.4645 54.5368C12.4159 56.4891 15.5806 56.4898 17.5329 54.5384C17.5334 54.5379 17.534 54.5373 17.5345 54.5368L44.5345 27.5368C46.4872 25.5849 46.4878 22.4196 44.5359 20.467C44.5354 20.4665 44.535 20.466 44.5345 20.4656L43.5345 19.4656C41.5824 17.5132 38.4172 17.5131 36.4649 19.4652C36.4647 19.4653 36.4646 19.4655 36.4645 19.4656L9.46451 46.4656C7.51218 48.4174 7.51178 51.5823 9.4636 53.5347C9.4639 53.535 9.46421 53.5353 9.46451 53.5356L10.4645 54.5368ZM32.2927 29.2946L39.2927 22.2946C39.6829 21.9041 40.3158 21.9039 40.7062 22.2941C40.7064 22.2942 40.7065 22.2944 40.7067 22.2946L41.7067 23.2946C42.0971 23.6846 42.0975 24.3174 41.7074 24.7078C41.7072 24.708 41.7069 24.7082 41.7067 24.7085L34.7067 31.7085C34.3165 32.0989 33.6837 32.0992 33.2932 31.709C33.293 31.7088 33.2929 31.7086 33.2927 31.7085L32.2927 30.7085V30.7085C31.9023 30.3183 31.902 29.6855 32.2922 29.2951C32.2924 29.2949 32.2925 29.2948 32.2927 29.2946H32.2927ZM31.1356 14.4561C30.3296 14.3024 29.6993 13.672 29.5456 12.8661L29.0933 10.4928C29.0309 10.165 28.7146 9.94979 28.3868 10.0122C28.1432 10.0585 27.9526 10.2491 27.9062 10.4928L27.454 12.8657C27.3003 13.6716 26.67 14.302 25.864 14.4557L23.4911 14.9077C23.1633 14.9701 22.9481 15.2864 23.0105 15.6142C23.0569 15.8578 23.2474 16.0484 23.4911 16.0948L25.864 16.5468C26.67 16.7005 27.3003 17.3308 27.454 18.1368L27.9062 20.5098C27.9686 20.8376 28.2849 21.0528 28.6127 20.9904C28.8564 20.944 29.0469 20.7534 29.0933 20.5098L29.5452 18.1369C29.6989 17.3309 30.3292 16.7006 31.1352 16.5469L33.508 16.0949C33.8358 16.0325 34.051 15.7162 33.9886 15.3884C33.9423 15.1447 33.7517 14.9541 33.508 14.9078L31.1356 14.4561ZM55.1356 30.4561C54.3296 30.3024 53.6993 29.672 53.5456 28.8661L53.0937 26.4932C53.0313 26.1654 52.715 25.9502 52.3872 26.0126C52.1435 26.0589 51.953 26.2495 51.9066 26.4932L51.4545 28.8662C51.3008 29.6721 50.6705 30.3025 49.8645 30.4562L47.4916 30.9082C47.1638 30.9706 46.9486 31.2869 47.011 31.6147C47.0574 31.8583 47.2479 32.0489 47.4916 32.0953L49.8645 32.5473C50.6705 32.701 51.3008 33.3313 51.4545 34.1373L51.9066 36.5102C51.969 36.838 52.2853 37.0532 52.6131 36.9908C52.8568 36.9444 53.0473 36.7538 53.0937 36.5102L53.5456 34.1373C53.6993 33.3313 54.3296 32.701 55.1356 32.5473L57.5086 32.0953C57.8364 32.0329 58.0516 31.7166 57.9892 31.3888C57.9429 31.1451 57.7523 30.9545 57.5086 30.9082L55.1356 30.4561ZM51.6475 9.88787L51.082 6.49478C51.0294 6.17321 50.726 5.9552 50.4044 6.00784C50.1544 6.04877 49.9584 6.24475 49.9175 6.49478L49.352 9.88787C49.1413 11.1524 48.1504 12.1433 46.8859 12.354L43.4928 12.9194C43.1713 12.9722 42.9534 13.2757 43.0062 13.5972C43.0472 13.847 43.243 14.0428 43.4928 14.0838L46.8859 14.6494C48.1504 14.8601 49.1413 15.8509 49.352 17.1154L49.9175 20.5085C49.9701 20.83 50.2735 21.0481 50.5951 20.9954C50.8451 20.9545 51.0411 20.7585 51.082 20.5085L51.6475 17.1154C51.8582 15.851 52.849 14.8602 54.1133 14.6494L57.5065 14.0838C57.828 14.031 58.0459 13.7275 57.9931 13.406C57.9521 13.1562 57.7563 12.9604 57.5065 12.9194L54.1133 12.354V12.354C52.8489 12.1432 51.8582 11.1523 51.6475 9.88787Z"
		/>
	);
}

function ArrowCursor(props) {
	return (
		<path d="M30.3393 37.6163C30.1846 37.2537 29.7207 37.1483 29.4245 37.4084L23.137 42.9303C22.3219 43.6462 21.0391 43.0713 21.0379 41.9896L21.0024 12.2608C21.0011 11.1502 22.3422 10.5839 23.1442 11.3563L44.6135 32.033C45.3947 32.7853 44.9192 34.1027 43.8355 34.1888L35.4793 34.8526C35.0847 34.884 34.8372 35.2931 34.9925 35.6571L42.08 52.2697C42.3526 52.9086 42.053 53.6464 41.4108 53.9176L39.0853 54.8998C38.4431 55.171 37.7015 54.8729 37.4289 54.234L30.3393 37.6163Z" />
	);
}

function Annotate(props) {
	return (
		<motion.g>
			<path d="M12 20C12 15.5817 15.5817 12 20 12H44C48.4183 12 52 15.5817 52 20V29.5C52 29.7761 51.7761 30 51.5 30H38C33.5817 30 30 33.5817 30 38V51.5C30 51.7761 29.7761 52 29.5 52H20C15.5817 52 12 48.4183 12 44V20Z" />
			<path d="M47.7929 34H38C35.7909 34 34 35.7909 34 38V47.7929C34 48.2383 34.5386 48.4614 34.8536 48.1464L48.1464 34.8536C48.4614 34.5386 48.2383 34 47.7929 34Z" />
		</motion.g>
	);
}

function Scribble(props) {
	return (
		<path d="M4.799 39.2754C5.85145 40.4049 7.51998 40.3792 8.5981 39.2754L13.116 34.7576C29.9809 17.8926 37.5278 10.6024 39.9151 12.964C41.7119 14.7353 37.0401 19.9975 30.0323 28.2375C23.0501 36.4774 14.9128 45.5388 20.6115 51.2888C25.6941 56.3971 33.6773 49.8257 40.3771 43.3826C46.1015 37.8636 49.0535 35.1683 49.7979 35.887C50.4653 36.5545 49.0021 38.1716 47.0512 41.5857C44.5869 45.8212 41.3269 51.0835 44.741 54.4975C47.3593 57.1158 51.6204 55.7297 56.7287 50.5701C57.9608 49.3123 58.0378 47.6437 56.934 46.5656C55.8559 45.5132 54.2387 45.5132 53.1349 46.5399C50.3113 49.1839 48.5401 50.6471 48.232 50.3647C47.9497 50.108 49.3102 48.0031 51.4151 44.512C55.1885 38.2743 56.241 34.7319 53.674 32.1906C50.3369 28.8536 45.203 31.3178 36.5523 39.5065C29.4162 46.2319 25.7198 48.7219 24.4106 47.4384C22.9218 45.9495 25.7968 41.2777 34.0881 31.7542C44.7666 19.4328 48.155 13.5801 43.7142 9.16494C38.1952 3.64597 32.3939 7.90713 9.31685 30.9585L4.799 35.4763C3.72087 36.5545 3.74654 38.1973 4.799 39.2754Z" />
	);
}

function Flashlight(props) {
	return (
		<path d="M20.4785 13.6465H43.0801V12.4004C43.0801 9.45703 41.5547 7.95312 38.7188 7.95312H24.8398C22.0039 7.95312 20.4785 9.45703 20.4785 12.4004V13.6465ZM29.2227 56.8945H34.3359C37.1719 56.8945 38.6758 55.4121 38.6758 52.4473V30.2109C38.6758 28.041 39.1699 26.4727 39.9863 25.248L41.3398 23.207C42.4141 21.5527 43.0801 20.0488 43.0801 18.1797V16.4609H20.4785V18.1797C20.4785 20.0488 21.123 21.5527 22.1973 23.207L23.5723 25.248C24.3672 26.4727 24.8613 28.041 24.8613 30.2109V52.4473C24.8613 55.4121 26.3867 56.8945 29.2227 56.8945ZM31.7793 28.2559C33.627 28.2559 34.8301 29.5879 34.8301 31.5V37.4297C34.8301 39.2988 33.627 40.5879 31.7793 40.6094C29.9316 40.6523 28.7285 39.3418 28.7285 37.4297V31.5C28.7285 29.5879 29.9316 28.2559 31.7793 28.2559ZM31.7793 29.8672C30.7695 29.8672 29.9102 30.7051 29.9102 31.7148C29.9102 32.7246 30.7695 33.584 31.7793 33.584C32.7891 33.584 33.6484 32.7246 33.6484 31.7148C33.6484 30.7051 32.7891 29.8672 31.7793 29.8672Z" />
	);
}

function Lightbulb(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M39.268 40.5977C38.6861 42.5877 38.2125 44.0192 36.198 44.0192H27.8468C25.832 44.0192 25.3583 42.5875 24.7768 40.5977C22.8344 33.9552 17.1026 31.7516 17.0268 23.1716V23.1716C16.9468 14.8894 23.5959 8.1105 31.8781 8.0305C40.1602 7.95048 46.9392 14.5996 47.0192 22.8818C47.0201 22.9784 47.0201 23.075 47.0192 23.1716C46.9423 31.7516 41.21 33.9552 39.268 40.5977V40.5977ZM27.0188 46.0194H37.0257C38.1305 46.0194 39.0261 46.915 39.0261 48.0198C39.0261 49.1246 38.1305 50.0202 37.0257 50.0202H27.0188C25.914 50.0202 25.0184 49.1246 25.0184 48.0198C25.0184 46.915 25.914 46.0194 27.0188 46.0194ZM28.19 52.0199H35.8548C36.5017 52.0201 37.026 52.5447 37.0259 53.1916V53.1917C37.0259 53.7223 36.8152 54.2311 36.4401 54.6063L35.6124 55.4348C35.2376 55.8098 34.7292 56.0206 34.199 56.0206H29.8455H29.8455C29.3153 56.0206 28.8069 55.8098 28.4321 55.4348L27.6044 54.6063V54.6063C27.2295 54.231 27.0188 53.7222 27.0188 53.1917V53.1917C27.0186 52.5448 27.5428 52.0201 28.1898 52.0199C28.1898 52.0199 28.1899 52.0199 28.19 52.0199V52.0199Z"
		/>
	);
}

function History(props) {
	return (
		<path d="M30.9003 18.4354C30.3784 18.4354 29.9277 18.6129 29.5481 18.9678C29.1843 19.3227 29.0024 19.7548 29.0024 20.264V33.1795C29.0024 33.4573 29.0499 33.7196 29.1448 33.9665C29.2397 34.198 29.382 34.4372 29.5718 34.684L35.4315 42.2297C35.8269 42.7235 36.2777 43.0167 36.7838 43.1093C37.3057 43.1864 37.8039 43.063 38.2784 42.7389C38.7212 42.4457 38.9585 42.0522 38.9901 41.5585C39.0376 41.0492 38.8794 40.5632 38.5156 40.1003L30.6156 29.7076L32.7745 36.1885V20.264C32.7745 19.7548 32.5926 19.3227 32.2289 18.9678C31.8651 18.6129 31.4222 18.4354 30.9003 18.4354ZM31.8018 55.6082C35.1073 55.6082 38.2151 54.991 41.1252 53.7565C44.0512 52.522 46.6291 50.8169 48.8592 48.6412C51.0892 46.4655 52.8368 43.9579 54.1021 41.1187C55.3674 38.264 56 35.2241 56 31.9991C56 28.7741 55.3674 25.7419 54.1021 22.9026C52.8368 20.048 51.0892 17.5327 48.8592 15.357C46.6291 13.1813 44.0512 11.4762 41.1252 10.2417C38.2151 9.00723 35.1073 8.39 31.8018 8.39C28.4963 8.39 25.3806 9.00723 22.4547 10.2417C19.5446 11.4762 16.9745 13.1813 14.7445 15.357C12.5145 17.5173 10.7668 20.0248 9.50154 22.8795C8.23628 25.7188 7.60365 28.7509 7.60365 31.9759H11.6367C11.6367 29.2447 12.1507 26.6909 13.1787 24.3146C14.2226 21.9382 15.6697 19.8551 17.5202 18.0651C19.3706 16.2751 21.5136 14.8786 23.9493 13.8756C26.3849 12.8572 29.0024 12.348 31.8018 12.348C34.6012 12.348 37.2187 12.8572 39.6544 13.8756C42.09 14.8786 44.2251 16.2828 46.0598 18.0882C47.9102 19.8782 49.3574 21.9614 50.4012 24.3377C51.445 26.7141 51.967 29.2678 51.967 31.9991C51.967 34.7303 51.445 37.2919 50.4012 39.6836C49.3574 42.06 47.9102 44.1508 46.0598 45.9562C44.2251 47.7462 42.09 49.1504 39.6544 50.1688C37.2187 51.1873 34.6012 51.6888 31.8018 51.6733C29.5402 51.6579 27.3971 51.3107 25.3727 50.6318C23.3483 49.9682 21.4899 49.027 19.7976 47.8079C18.1212 46.5889 16.6819 45.1615 15.4799 43.5259C15.1162 43.0475 14.6733 42.7466 14.1514 42.6232C13.6453 42.4843 13.1392 42.5615 12.6331 42.8546C12.1586 43.1478 11.866 43.5722 11.7553 44.1277C11.6604 44.6832 11.8186 45.2156 12.2298 45.7248C13.7323 47.6845 15.4957 49.405 17.5202 50.8864C19.5446 52.3832 21.7667 53.5405 24.1865 54.3583C26.6063 55.1916 29.1448 55.6082 31.8018 55.6082ZM4.68563 27.5319C4.11626 27.5319 3.68924 27.6476 3.40455 27.8791C3.11987 28.0951 2.98543 28.3883 3.00125 28.7586C3.01706 29.129 3.17522 29.5302 3.47572 29.9622L8.78983 37.3227C9.18523 37.8628 9.63598 38.1328 10.1421 38.1328C10.6482 38.1174 11.091 37.8474 11.4706 37.3227L16.7847 29.9391C17.0852 29.507 17.2355 29.1135 17.2355 28.7586C17.2513 28.3883 17.1169 28.0951 16.8322 27.8791C16.5475 27.6476 16.1284 27.5319 15.5748 27.5319H4.68563Z" />
	);
}

function RectSelect(props) {
	return (
		<motion.g>
			<path d="M11.2857 9C10.0233 9 9 10.0233 9 11.2857V16.4286C9 17.6909 10.0233 18.7143 11.2857 18.7143C12.5481 18.7143 13.5714 17.6909 13.5714 16.4286V13.5714H16.4286C17.6909 13.5714 18.7143 12.5481 18.7143 11.2857C18.7143 10.0233 17.6909 9 16.4286 9H11.2857Z" />
			<path d="M47.2857 9C46.0234 9 45 10.0233 45 11.2857C45 12.5481 46.0234 13.5714 47.2857 13.5714H50.1429V16.4286C50.1429 17.6909 51.1662 18.7143 52.4286 18.7143C53.6909 18.7143 54.7143 17.6909 54.7143 16.4286V11.2857C54.7143 10.0233 53.6909 9 52.4286 9H47.2857Z" />
			<path d="M24.4286 11.2857C24.4286 10.0233 25.4519 9 26.7143 9H37C38.2624 9 39.2857 10.0233 39.2857 11.2857C39.2857 12.5481 38.2624 13.5714 37 13.5714H26.7143C25.4519 13.5714 24.4286 12.5481 24.4286 11.2857Z" />
			<path d="M13.5714 47.2857C13.5714 46.0234 12.5481 45 11.2857 45C10.0233 45 9 46.0234 9 47.2857V52.4286C9 53.6909 10.0233 54.7143 11.2857 54.7143H16.4286C17.6909 54.7143 18.7143 53.6909 18.7143 52.4286C18.7143 51.1662 17.6909 50.1429 16.4286 50.1429H13.5714V47.2857Z" />
			<path d="M24.4286 52.4286C24.4286 51.1662 25.4519 50.1429 26.7143 50.1429H37C38.2624 50.1429 39.2857 51.1662 39.2857 52.4286C39.2857 53.6909 38.2624 54.7143 37 54.7143H26.7143C25.4519 54.7143 24.4286 53.6909 24.4286 52.4286Z" />
			<path d="M54.7143 47.2857C54.7143 46.0234 53.6909 45 52.4286 45C51.1662 45 50.1429 46.0234 50.1429 47.2857V50.1429H47.2857C46.0234 50.1429 45 51.1662 45 52.4286C45 53.6909 46.0234 54.7143 47.2857 54.7143H52.4286C53.6909 54.7143 54.7143 53.6909 54.7143 52.4286V47.2857Z" />
			<path d="M52.4286 24.4286C53.6909 24.4286 54.7143 25.4519 54.7143 26.7143V37C54.7143 38.2624 53.6909 39.2857 52.4286 39.2857C51.1662 39.2857 50.1429 38.2624 50.1429 37V26.7143C50.1429 25.4519 51.1662 24.4286 52.4286 24.4286Z" />
			<path d="M13.5714 26.7143C13.5714 25.4519 12.5481 24.4286 11.2857 24.4286C10.0233 24.4286 9 25.4519 9 26.7143V37C9 38.2624 10.0233 39.2857 11.2857 39.2857C12.5481 39.2857 13.5714 38.2624 13.5714 37V26.7143Z" />
		</motion.g>
	);
}

function Help(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0209 56.0208C18.7661 56.0208 8.02087 45.2756 8.02087 32.0208C8.02087 18.766 18.7661 8.02075 32.0209 8.02075C45.2757 8.02075 56.0209 18.766 56.0209 32.0208C56.0209 45.2756 45.2757 56.0208 32.0209 56.0208ZM32.0209 12.0208C20.9752 12.0208 12.0209 20.9751 12.0209 32.0208C12.0209 43.0665 20.9752 52.0208 32.0209 52.0208C43.0666 52.0208 52.0209 43.0664 52.0209 32.0208V32.021C52.0209 20.9754 43.0667 12.0211 32.0211 12.021L32.0209 12.0208ZM34.2709 36.0208C34.2709 36.573 33.8232 37.0208 33.2709 37.0208H31.0209C30.4686 37.0208 30.0209 36.573 30.0209 36.0208C30.0209 29.3763 35.6459 30.0025 35.6459 25.0208C35.6459 23.3639 33.7659 22.0208 31.8335 22.0208C29.9011 22.0208 27.9897 23.3639 27.9897 25.0208V25.0208C27.9829 25.5899 28.0708 26.1561 28.2497 26.6965C28.4313 27.2154 28.1579 27.7833 27.639 27.965C27.5331 28.002 27.4218 28.0209 27.3097 28.0209H25.2785C24.8274 28.022 24.431 27.7224 24.309 27.2882C24.1097 26.5491 24.0127 25.7862 24.0209 25.0208C24.0209 21.1548 27.6024 18.0208 32.0209 18.0208C36.4394 18.0208 40.0209 21.1547 40.0209 25.0208C40.0208 31.4377 34.2707 31.1877 34.2707 36.0209L34.2709 36.0208ZM32.0209 40.0208C33.6777 40.0208 35.0209 41.3639 35.0209 43.0208C35.0209 44.6776 33.6777 46.0208 32.0209 46.0208C30.364 46.0208 29.0209 44.6776 29.0209 43.0208V43.0209C29.0209 41.364 30.364 40.0209 32.0208 40.0209L32.0209 40.0208Z"
		/>
	);
}

function LineHairline(props) {
	return <path fillRule="evenodd" clipRule="evenodd" d="M56 32.6667H8V31.3333H56V32.6667Z" />;
}

function LineWavy(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.3266 29.3331C14.2203 30.3093 13.0469 31.8373 11.8267 33.9907L9.50659 32.676C10.8049 30.3849 12.15 28.5796 13.5622 27.3336C14.9827 26.0802 16.5428 25.3333 18.2222 25.3333C19.9016 25.3333 21.4617 26.0802 22.8821 27.3336C24.2943 28.5796 25.6395 30.3849 26.9378 32.676C28.158 34.8293 29.3314 36.3574 30.4377 37.3336C31.5357 38.3024 32.4942 38.6667 33.3333 38.6667C34.1724 38.6667 35.1308 38.3024 36.2289 37.3336C37.3352 36.3574 38.5086 34.8293 39.7288 32.676C41.0271 30.3849 42.3722 28.5796 43.7845 27.3336C45.2049 26.0802 46.765 25.3333 48.4444 25.3333C50.1238 25.3333 51.6839 26.0802 53.1043 27.3336C54.5166 28.5796 55.8617 30.3849 57.16 32.676L54.8399 33.9907C53.6197 31.8373 52.4463 30.3093 51.34 29.3331C50.2419 28.3642 49.2835 28 48.4444 28C47.6053 28 46.6469 28.3642 45.5488 29.3331C44.4425 30.3093 43.2691 31.8373 42.0489 33.9907C40.7506 36.2818 39.4054 38.087 37.9932 39.3331C36.5728 40.5864 35.0127 41.3333 33.3333 41.3333C31.6539 41.3333 30.0938 40.5864 28.6733 39.3331C27.2611 38.087 25.916 36.2818 24.6177 33.9907C23.3975 31.8373 22.2241 30.3093 21.1178 29.3331C20.0197 28.3642 19.0613 28 18.2222 28C17.383 28 16.4246 28.3642 15.3266 29.3331Z"
		/>
	);
}

function Wavy(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.3508 29.3899C17.7021 27.3291 14.5447 27.4016 12.9924 29.536L9.61761 34.1763C8.96794 35.0697 7.7171 35.2672 6.8238 34.6175C5.93049 33.9678 5.73299 32.717 6.38267 31.8237L9.75746 27.1833C12.862 22.9145 19.1769 22.7695 22.4743 26.8911L28.8767 34.8941C30.478 36.8957 33.5223 36.8957 35.1236 34.8941L41.526 26.8911C44.8233 22.7695 51.1383 22.9145 54.2428 27.1833L57.6176 31.8237C58.2673 32.717 58.0698 33.9678 57.1765 34.6175C56.2832 35.2672 55.0323 35.0697 54.3827 34.1763L51.0079 29.536C49.4556 27.4016 46.2981 27.3291 44.6495 29.3899L38.2471 37.3929C35.0445 41.3961 28.9558 41.3961 25.7532 37.3929L19.3508 29.3899Z"
		/>
	);
}

function ShowOnClick(props) {
	return (
		<path d="M33.4509 16.4508C33.4509 15.6671 32.7877 15 31.9917 15C31.2123 15 30.5491 15.6671 30.5491 16.4508V21.3203C30.5491 22.1041 31.2123 22.7712 31.9917 22.7712C32.7877 22.7712 33.4509 22.1041 33.4509 21.3203V16.4508ZM22.5564 25.6728C23.1202 26.2398 24.0488 26.2398 24.596 25.6728C25.1598 25.1225 25.1598 24.1886 24.596 23.6216L21.1967 20.1863C20.6495 19.636 19.7209 19.6193 19.1571 20.1697C18.6099 20.72 18.6099 21.6538 19.1571 22.2208L22.5564 25.6728ZM39.205 23.7884C38.6578 24.3554 38.6578 25.2893 39.205 25.8396C39.7688 26.4066 40.714 26.4066 41.2612 25.8396L44.6771 22.4043C45.2409 21.8373 45.2409 20.9034 44.6771 20.3364C44.1299 19.7861 43.2013 19.7861 42.6541 20.3364L39.205 23.7884ZM30.6817 44.6838C30.6651 45.3342 31.4279 45.5343 31.8425 45.1174L34.363 42.5659L37.1985 49.62C37.3312 49.9202 37.6794 50.0869 37.9779 49.9535L39.6195 49.3031C39.918 49.153 40.0341 48.8028 39.8848 48.5027L36.9 41.5653L40.4818 41.4152C41.1119 41.3819 41.4104 40.7815 40.9627 40.2979L31.9088 30.9425C31.4777 30.509 30.8475 30.7424 30.831 31.3594L30.6817 44.6838ZM15.4427 31.6429C14.6633 31.6429 14 32.31 14 33.0938C14 33.8776 14.6633 34.5446 15.4427 34.5446H20.3012C21.0972 34.5446 21.7605 33.8776 21.7605 33.0938C21.7605 32.31 21.0972 31.6429 20.3012 31.6429H15.4427ZM48.5408 34.5446C49.3367 34.5446 50 33.8776 50 33.0938C50 32.31 49.3367 31.6429 48.5408 31.6429H43.6988C42.9194 31.6429 42.2561 32.31 42.2561 33.0938C42.2561 33.8776 42.9194 34.5446 43.6988 34.5446H48.5408ZM19.3063 43.7833C18.7591 44.3336 18.7591 45.2841 19.2897 45.8345C19.8369 46.3848 20.7821 46.4015 21.3459 45.8511L24.7619 42.4158C25.3257 41.8655 25.3257 40.9316 24.7619 40.3646C24.2312 39.8143 23.286 39.8143 22.7222 40.3646L19.3063 43.7833Z" />
	);
}

function ShowAlways(props) {
	return (
		<path d="M32.423 42C42.7214 42 49.8333 33.6184 49.8333 31C49.8333 28.3687 42.7086 20 32.423 20C22.2649 20 15 28.3687 15 31C15 33.6184 22.2522 42 32.423 42ZM32.423 39.972C24.0238 39.972 17.2305 32.8098 17.2305 31C17.2305 29.4726 24.0238 22.028 32.423 22.028C40.7841 22.028 47.6029 29.4726 47.6029 31C47.6029 32.8098 40.7841 39.972 32.423 39.972ZM32.423 38.1879C36.3869 38.1879 39.5732 34.9148 39.5732 31C39.5732 26.9825 36.3869 23.8121 32.423 23.8121C28.4337 23.8121 25.2346 26.9825 25.2473 31C25.2728 34.9148 28.4337 38.1879 32.423 38.1879ZM32.423 33.3874C31.0975 33.3874 30.0269 32.3092 30.0269 31C30.0269 29.6779 31.0975 28.6126 32.423 28.6126C33.7358 28.6126 34.8064 29.6779 34.8064 31C34.8064 32.3092 33.7358 33.3874 32.423 33.3874Z" />
	);
}

function LightMode(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M57 34H53C52.4696 34 51.9609 33.7893 51.5858 33.4142C51.2107 33.0391 51 32.5304 51 32C51 31.4696 51.2107 30.9609 51.5858 30.5858C51.9609 30.2107 52.4696 30 53 30H57C57.5304 30 58.0391 30.2107 58.4142 30.5858C58.7893 30.9609 59 31.4696 59 32C59 32.5304 58.7893 33.0391 58.4142 33.4142C58.0391 33.7893 57.5304 34 57 34ZM13 32C13 32.5304 12.7893 33.0391 12.4142 33.4142C12.0391 33.7893 11.5304 34 11 34H7C6.46957 34 5.96086 33.7893 5.58579 33.4142C5.21071 33.0391 5 32.5304 5 32C5 31.4696 5.21071 30.9609 5.58579 30.5858C5.96086 30.2107 6.46957 30 7 30H11C11.5304 30 12.0391 30.2107 12.4142 30.5858C12.7893 30.9609 13 31.4696 13 32ZM51.2213 51.2212C50.8462 51.5962 50.3376 51.8069 49.8072 51.8069C49.2767 51.8069 48.7681 51.5962 48.393 51.2212L45.5643 48.3928C45.3786 48.2071 45.2313 47.9866 45.1308 47.7439C45.0303 47.5013 44.9785 47.2412 44.9785 46.9786C44.9785 46.7159 45.0303 46.4558 45.1308 46.2132C45.2313 45.9705 45.3786 45.7501 45.5644 45.5644C45.7501 45.3786 45.9706 45.2313 46.2132 45.1308C46.4559 45.0303 46.7159 44.9786 46.9786 44.9786C47.2412 44.9786 47.5013 45.0303 47.744 45.1308C47.9866 45.2314 48.2071 45.3787 48.3928 45.5644L51.2213 48.3928C51.5964 48.7679 51.8071 49.2766 51.8071 49.807C51.8071 50.3374 51.5964 50.8461 51.2213 51.2212ZM48.42 12.7518C48.7966 12.3846 49.3028 12.1805 49.8288 12.1839C50.3549 12.1872 50.8584 12.3976 51.2304 12.7696C51.6024 13.1416 51.8128 13.6451 51.8161 14.1711C51.8195 14.6972 51.6154 15.2033 51.2482 15.58L48.42 18.4087C48.0449 18.7838 47.5361 18.9945 47.0057 18.9945C46.4752 18.9945 45.9664 18.7838 45.5914 18.4086C45.2163 18.0335 45.0055 17.5248 45.0055 16.9943C45.0056 16.4638 45.2163 15.9551 45.5914 15.58L48.42 12.7518ZM30 57V53C30 52.4696 30.2107 51.9609 30.5858 51.5858C30.9609 51.2107 31.4696 51 32 51C32.5304 51 33.0391 51.2107 33.4142 51.5858C33.7893 51.9609 34 52.4696 34 53V57C34 57.5304 33.7893 58.0391 33.4142 58.4142C33.0391 58.7893 32.5304 59 32 59C31.4696 59 30.9609 58.7893 30.5858 58.4142C30.2107 58.0391 30 57.5304 30 57ZM18.4358 45.5643C18.8109 45.9394 19.0216 46.4481 19.0216 46.9785C19.0216 47.5089 18.8109 48.0176 18.4358 48.3927L15.6073 51.2527C15.2322 51.6278 14.7235 51.8385 14.1931 51.8385C13.6626 51.8385 13.1539 51.6278 12.7788 51.2528C12.4038 50.8777 12.193 50.369 12.193 49.8385C12.193 49.3081 12.4037 48.7994 12.7788 48.4243L15.6073 45.5643C15.793 45.3786 16.0135 45.2312 16.2562 45.1307C16.4988 45.0302 16.7589 44.9785 17.0215 44.9785C17.2842 44.9785 17.5443 45.0302 17.7869 45.1307C18.0296 45.2312 18.2501 45.3786 18.4358 45.5643ZM12.7519 12.7519C12.9376 12.5662 13.1581 12.4188 13.4008 12.3183C13.6434 12.2178 13.9035 12.1661 14.1662 12.1661C14.4288 12.1661 14.6889 12.2178 14.9315 12.3183C15.1742 12.4188 15.3947 12.5662 15.5804 12.7519L18.4087 15.58C18.7838 15.9551 18.9946 16.4639 18.9946 16.9944C18.9946 17.5249 18.7839 18.0336 18.4088 18.4088C18.0336 18.7839 17.5249 18.9946 16.9944 18.9946C16.4639 18.9946 15.9551 18.7839 15.58 18.4088L12.7519 15.58C12.3769 15.2049 12.1663 14.6963 12.1663 14.1659C12.1663 13.6356 12.3769 13.127 12.7519 12.7519ZM30 11V7C30 6.46957 30.2107 5.96086 30.5858 5.58579C30.9609 5.21071 31.4696 5 32 5C32.5304 5 33.0391 5.21071 33.4142 5.58579C33.7893 5.96086 34 6.46957 34 7V11C34 11.5304 33.7893 12.0391 33.4142 12.4142C33.0391 12.7893 32.5304 13 32 13C31.4696 13 30.9609 12.7893 30.5858 12.4142C30.2107 12.0391 30 11.5304 30 11ZM48 32C48 35.1645 47.0616 38.2579 45.3035 40.8891C43.5454 43.5203 41.0466 45.5711 38.1229 46.7821C35.1993 47.9931 31.9823 48.3099 28.8786 47.6926C25.7749 47.0752 22.9239 45.5513 20.6863 43.3137C18.4487 41.0761 16.9248 38.2251 16.3074 35.1214C15.6901 32.0177 16.0069 28.8007 17.2179 25.8771C18.4289 22.9534 20.4797 20.4546 23.1109 18.6965C25.7421 16.9384 28.8355 16 32 16C36.2435 16 40.3131 17.6857 43.3137 20.6863C46.3143 23.6869 48 27.7565 48 32ZM32 20C29.6267 20.0001 27.3066 20.704 25.3333 22.0227C23.3601 23.3414 21.8221 25.2156 20.9139 27.4083C20.0058 29.601 19.7683 32.0138 20.2314 34.3415C20.6945 36.6692 21.8374 38.8074 23.5157 40.4855C25.1939 42.1637 27.3321 43.3065 29.6599 43.7695C31.9876 44.2324 34.4004 43.9948 36.5931 43.0865C38.7857 42.1782 40.6598 40.6401 41.9784 38.6668C43.2969 36.6934 44.0007 34.3733 44.0007 32C44.0008 30.424 43.6904 28.8635 43.0873 27.4075C42.4843 25.9515 41.6003 24.6285 40.4859 23.5141C39.3715 22.3998 38.0486 21.5158 36.5925 20.9128C35.1365 20.3097 33.576 19.9999 32 20Z"
		/>
	);
}

function DarkMode(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24.9996 18.004C24.9986 20.7615 25.5408 23.4922 26.5951 26.0402C27.6494 28.5882 29.1953 30.9035 31.1445 32.854C33.0937 34.8046 35.4079 36.3521 37.9552 37.4082C40.5024 38.4643 43.2327 39.0084 45.9902 39.0093C47.9195 38.9706 49.8337 38.6609 51.6768 38.0893C52.0131 37.994 52.3698 37.9978 52.704 38.1002C53.0382 38.2025 53.3358 38.3992 53.561 38.6666C53.7862 38.9339 53.9295 39.2605 53.9736 39.6073C54.0177 39.9541 53.9609 40.3062 53.8098 40.6214C52.2655 43.9862 49.9299 46.9273 47.0025 49.1938C44.0751 51.4603 40.6427 52.9849 36.9984 53.6373C33.3541 54.2898 29.606 54.0508 26.0741 52.9407C22.5422 51.8307 19.3313 49.8825 16.7154 47.2625C14.0996 44.6426 12.1566 41.4286 11.0521 37.8949C9.94763 34.3612 9.71456 30.6128 10.3728 26.9695C11.031 23.3262 12.561 19.8963 14.8321 16.9725C17.1032 14.0486 20.0481 11.7177 23.4153 10.1787C23.7308 10.0276 24.0832 9.97063 24.4302 10.0148C24.7773 10.0589 25.1042 10.2022 25.3718 10.4276C25.6394 10.6529 25.8363 10.9506 25.9389 11.2851C26.0415 11.6195 26.0454 11.9765 25.9502 12.3131C25.3682 14.1562 25.0482 16.0719 24.9996 18.004Z"
		/>
	);
}

function Expand(props) {
	return (
		<motion.g>
			<path d="M12 14C12 12.8954 12.8954 12 14 12H26C27.1046 12 28 12.8954 28 14C28 15.1046 27.1046 16 26 16H18.8284L29.4142 26.5858C30.1953 27.3668 30.1953 28.6332 29.4142 29.4142C28.6332 30.1953 27.3668 30.1953 26.5858 29.4142L16 18.8284V26C16 27.1046 15.1046 28 14 28C12.8954 28 12 27.1046 12 26V14Z" />
			<path d="M34.5858 34.5858C35.3668 33.8047 36.6332 33.8047 37.4142 34.5858L48 45.1716V38C48 36.8954 48.8954 36 50 36C51.1046 36 52 36.8954 52 38V50C52 51.1046 51.1046 52 50 52H38C36.8954 52 36 51.1046 36 50C36 48.8954 36.8954 48 38 48H45.1716L34.5858 37.4142C33.8047 36.6332 33.8047 35.3668 34.5858 34.5858Z" />
		</motion.g>
	);
}

function ExpandTile(props) {
	return (
		<motion.g>
			<path d="M6 8.4C6 7.07452 7.07452 6 8.4 6H22.8C24.1255 6 25.2 7.07452 25.2 8.4C25.2 9.72548 24.1255 10.8 22.8 10.8H14.1941L28.8971 25.5029C29.8343 26.4402 29.8343 27.9598 28.8971 28.8971C27.9598 29.8343 26.4402 29.8343 25.5029 28.8971L10.8 14.1941V22.8C10.8 24.1255 9.72548 25.2 8.4 25.2C7.07452 25.2 6 24.1255 6 22.8V8.4Z" />
			<path d="M35.1029 35.1029C36.0402 34.1657 37.5598 34.1657 38.4971 35.1029L53.2 49.8059V41.2C53.2 39.8745 54.2745 38.8 55.6 38.8C56.9255 38.8 58 39.8745 58 41.2V55.6C58 56.9255 56.9255 58 55.6 58H41.2C39.8745 58 38.8 56.9255 38.8 55.6C38.8 54.2745 39.8745 53.2 41.2 53.2H49.8059L35.1029 38.4971C34.1657 37.5598 34.1657 36.0402 35.1029 35.1029Z" />
		</motion.g>
	);
}

function CollapseTile(props) {
	return (
		<motion.g>
			<path d="M57.2971 57.2971C56.3598 58.2343 54.8402 58.2343 53.9029 57.2971L39.2 42.5941V51.2C39.2 52.5255 38.1255 53.6 36.8 53.6C35.4745 53.6 34.4 52.5255 34.4 51.2V36.8C34.4 35.4745 35.4745 34.4 36.8 34.4H51.2C52.5255 34.4 53.6 35.4745 53.6 36.8C53.6 38.1255 52.5255 39.2 51.2 39.2H42.5941L57.2971 53.9029C58.2343 54.8402 58.2343 56.3598 57.2971 57.2971Z" />
			<path d="M29.6 27.2C29.6 28.5255 28.5255 29.6 27.2 29.6H12.8C11.4745 29.6 10.4 28.5255 10.4 27.2C10.4 25.8745 11.4745 24.8 12.8 24.8H21.4059L6.70295 10.097C5.76569 9.15977 5.76569 7.64018 6.70295 6.70292C7.6402 5.76566 9.1598 5.76566 10.0971 6.70292L24.8 21.4059V12.8C24.8 11.4745 25.8745 10.4 27.2 10.4C28.5255 10.4 29.6 11.4745 29.6 12.8V27.2Z" />
		</motion.g>
	);
}

function ExpandFlipped(props) {
	return (
		<motion.g>
			<path d="M52 14C52 12.8954 51.1046 12 50 12H38C36.8954 12 36 12.8954 36 14C36 15.1046 36.8954 16 38 16H45.1716L34.5858 26.5858C33.8047 27.3668 33.8047 28.6332 34.5858 29.4142C35.3668 30.1953 36.6332 30.1953 37.4142 29.4142L48 18.8284V26C48 27.1046 48.8954 28 50 28C51.1046 28 52 27.1046 52 26V14Z" />
			<path d="M29.4142 34.5858C28.6332 33.8047 27.3668 33.8047 26.5858 34.5858L16 45.1716V38C16 36.8954 15.1046 36 14 36C12.8954 36 12 36.8954 12 38V50C12 51.1046 12.8954 52 14 52H26C27.1046 52 28 51.1046 28 50C28 48.8954 27.1046 48 26 48H18.8284L29.4142 37.4142C30.1953 36.6332 30.1953 35.3668 29.4142 34.5858Z" />
		</motion.g>
	);
}

function CollapseFlipped(props) {
	return (
		<motion.g>
			<path d="M34 28C34 29.1046 34.8954 30 36 30H48C49.1046 30 50 29.1046 50 28C50 26.8954 49.1046 26 48 26H40.8284L51.4142 15.4142C52.1953 14.6332 52.1953 13.3668 51.4142 12.5858C50.6332 11.8047 49.3668 11.8047 48.5858 12.5858L38 23.1716V16C38 14.8954 37.1046 14 36 14C34.8954 14 34 14.8954 34 16V28Z" />
			<path d="M23.1716 38L12.5858 48.5858C11.8047 49.3668 11.8047 50.6332 12.5858 51.4142C13.3668 52.1953 14.6332 52.1953 15.4142 51.4142L26 40.8284V48C26 49.1046 26.8954 50 28 50C29.1046 50 30 49.1046 30 48V36C30 34.8954 29.1046 34 28 34H16C14.8954 34 14 34.8954 14 36C14 37.1046 14.8954 38 16 38H23.1716Z" />
		</motion.g>
	);
}

function Fullscreen(props) {
	return (
		<motion.g>
			<path d="M14 21C14 19.8954 14.8954 19 16 19H24C25.1046 19 26 18.1046 26 17C26 15.8954 25.1046 15 24 15H16C12.6863 15 10 17.6863 10 21V27C10 28.1046 10.8954 29 12 29C13.1046 29 14 28.1046 14 27V21Z" />
			<path d="M50 21C50 19.8954 49.1046 19 48 19H40C38.8954 19 38 18.1046 38 17C38 15.8954 38.8954 15 40 15H48C51.3137 15 54 17.6863 54 21V27C54 28.1046 53.1046 29 52 29C50.8954 29 50 28.1046 50 27V21Z" />
			<path d="M16 45C14.8954 45 14 44.1046 14 43V37C14 35.8954 13.1046 35 12 35C10.8954 35 10 35.8954 10 37V43C10 46.3137 12.6863 49 16 49H24C25.1046 49 26 48.1046 26 47C26 45.8954 25.1046 45 24 45H16Z" />
			<path d="M50 43C50 44.1046 49.1046 45 48 45H40C38.8954 45 38 45.8954 38 47C38 48.1046 38.8954 49 40 49H48C51.3137 49 54 46.3137 54 43V37C54 35.8954 53.1046 35 52 35C50.8954 35 50 35.8954 50 37V43Z" />
		</motion.g>
	);
}

function FullscreenAlt1(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38 20C38 18.8954 38.8954 18 40 18H48C49.1046 18 50 18.8954 50 20V28C50 29.1046 49.1046 30 48 30C46.8954 30 46 29.1046 46 28V22H40C38.8954 22 38 21.1046 38 20Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 34C17.1046 34 18 34.8954 18 36V42H24C25.1046 42 26 42.8954 26 44C26 45.1046 25.1046 46 24 46H16C14.8954 46 14 45.1046 14 44V36C14 34.8954 14.8954 34 16 34Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 14C6 11.7909 7.79086 10 10 10H54C56.2091 10 58 11.7909 58 14V50C58 52.2091 56.2091 54 54 54H10C7.79086 54 6 52.2091 6 50V14ZM54 14H10V50H54V14Z"
			/>
		</motion.g>
	);
}

function FullscreenAlt2(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M58 52H52C51.4696 52 50.9609 51.7893 50.5858 51.4142C50.2107 51.0391 50 50.5304 50 50C50 49.4696 50.2107 48.9609 50.5858 48.5858C50.9609 48.2107 51.4696 48 52 48H56V44C56 43.4696 56.2107 42.9609 56.5858 42.5858C56.9609 42.2107 57.4696 42 58 42C58.5304 42 59.0391 42.2107 59.4142 42.5858C59.7893 42.9609 60 43.4696 60 44V50C60 50.5304 59.7893 51.0391 59.4142 51.4142C59.0391 51.7893 58.5304 52 58 52ZM58 22C57.4696 22 56.9609 21.7893 56.5858 21.4142C56.2107 21.0391 56 20.5304 56 20V16H52C51.4696 16 50.9609 15.7893 50.5858 15.4142C50.2107 15.0391 50 14.5304 50 14C50 13.4696 50.2107 12.9609 50.5858 12.5858C50.9609 12.2107 51.4696 12 52 12H58C58.5304 12 59.0391 12.2107 59.4142 12.5858C59.7893 12.9609 60 13.4696 60 14V20C60 20.5304 59.7893 21.0391 59.4142 21.4142C59.0391 21.7893 58.5304 22 58 22ZM14 14C14 14.5304 13.7893 15.0391 13.4142 15.4142C13.0391 15.7893 12.5304 16 12 16H8V20C8 20.5304 7.78929 21.0391 7.41421 21.4142C7.03914 21.7893 6.53043 22 6 22C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V14C4 13.4696 4.21071 12.9609 4.58579 12.5858C4.96086 12.2107 5.46957 12 6 12H12C12.5304 12 13.0391 12.2107 13.4142 12.5858C13.7893 12.9609 14 13.4696 14 14ZM11 43.5V20.5C11 20.1022 11.158 19.7206 11.4393 19.4393C11.7206 19.158 12.1022 19 12.5 19H51.5C51.8978 19 52.2794 19.158 52.5607 19.4393C52.842 19.7206 53 20.1022 53 20.5V43.5C53 43.8978 52.842 44.2794 52.5607 44.5607C52.2794 44.842 51.8978 45 51.5 45H12.5C12.1022 45 11.7206 44.842 11.4393 44.5607C11.158 44.2794 11 43.8978 11 43.5ZM6 42C6.53043 42 7.03914 42.2107 7.41421 42.5858C7.78929 42.9609 8 43.4696 8 44V48H12C12.5304 48 13.0391 48.2107 13.4142 48.5858C13.7893 48.9609 14 49.4696 14 50C14 50.5304 13.7893 51.0391 13.4142 51.4142C13.0391 51.7893 12.5304 52 12 52H6C5.46957 52 4.96086 51.7893 4.58579 51.4142C4.21071 51.0391 4 50.5304 4 50V44C4 43.4696 4.21071 42.9609 4.58579 42.5858C4.96086 42.2107 5.46957 42 6 42V42Z"
		/>
	);
}

function Preferences(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 30C23.7277 30 26.8599 27.4505 27.748 24H46C47.1046 24 48 23.1046 48 22C48 20.8954 47.1046 20 46 20H27.748C26.8599 16.5495 23.7277 14 20 14C15.5817 14 12 17.5817 12 22C12 26.4183 15.5817 30 20 30ZM20 26C17.7909 26 16 24.2091 16 22C16 19.7909 17.7909 18 20 18C22.2091 18 24 19.7909 24 22C24 24.2091 22.2091 26 20 26Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M44 50C40.2723 50 37.1401 47.4505 36.252 44H18C16.8954 44 16 43.1046 16 42C16 40.8954 16.8954 40 18 40H36.252C37.1401 36.5495 40.2723 34 44 34C48.4183 34 52 37.5817 52 42C52 46.4183 48.4183 50 44 50ZM44 46C46.2091 46 48 44.2091 48 42C48 39.7909 46.2091 38 44 38C41.7909 38 40 39.7909 40 42C40 44.2091 41.7909 46 44 46Z"
			/>
		</motion.g>
	);
}

function MoreCircleOutline(props) {
	return (
		<motion.g>
			<path d="M22 35C23.6569 35 25 33.6569 25 32C25 30.3431 23.6569 29 22 29C20.3431 29 19 30.3431 19 32C19 33.6569 20.3431 35 22 35Z" />
			<path d="M32 35C33.6569 35 35 33.6569 35 32C35 30.3431 33.6569 29 32 29C30.3431 29 29 30.3431 29 32C29 33.6569 30.3431 35 32 35Z" />
			<path d="M45 32C45 33.6569 43.6569 35 42 35C40.3431 35 39 33.6569 39 32C39 30.3431 40.3431 29 42 29C43.6569 29 45 30.3431 45 32Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 32C8 45.2548 18.7452 56 32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32ZM11.9996 32.0005C11.9993 20.9543 20.9538 11.9994 32 11.9991C43.0462 11.9991 52.0014 20.9538 52.0014 32C52.0014 43.046 43.047 52.0006 32.001 52.0009C20.9548 52.0012 11.9999 43.0467 11.9996 32.0005Z"
			/>
		</motion.g>
	);
}

function OpenLink(props) {
	return (
		<motion.g>
			<path d="M37.5 11C36.3954 11 35.5 11.8954 35.5 13C35.5 14.1046 36.3954 15 37.5 15H46.6716L30.5858 31.0858C29.8047 31.8668 29.8047 33.1332 30.5858 33.9142C31.3668 34.6953 32.6332 34.6953 33.4142 33.9142L49.5 17.8284V27C49.5 28.1046 50.3954 29 51.5 29C52.6046 29 53.5 28.1046 53.5 27V13C53.5 11.8954 52.6046 11 51.5 11H37.5Z" />
			<path d="M16 22C16 20.8954 16.8954 20 18 20H22C23.1046 20 24 19.1046 24 18C24 16.8954 23.1046 16 22 16H18C14.6863 16 12 18.6863 12 22V47C12 50.3137 14.6863 53 18 53H43C46.3137 53 49 50.3137 49 47V43C49 41.8954 48.1046 41 47 41C45.8954 41 45 41.8954 45 43V47C45 48.1046 44.1046 49 43 49H18C16.8954 49 16 48.1046 16 47V22Z" />
		</motion.g>
	);
}

function Unsplash(props) {
	return (
		<motion.g>
			<path d="M24.1538 22.8464V11.0771H39.8461V22.8464H24.1538ZM39.8461 29.3848H52.9231V52.9233H11.0769V29.3848H24.1538V41.1541H39.8461V29.3848Z" />
		</motion.g>
	);
}

function Link(props) {
	return (
		<motion.g>
			<path d="M50.2254 13.7746C45.1926 8.7418 37.0328 8.7418 32 13.7746L27.2092 18.5654C22.4995 23.2751 22.4995 30.9112 27.2092 35.621L27.7941 36.2059C28.5684 36.9801 29.8238 36.9801 30.598 36.2059C31.3723 35.4316 31.3723 34.1762 30.598 33.402L30.0132 32.8171C26.8519 29.6558 26.8519 24.5305 30.0132 21.3693L34.8039 16.5785C38.2882 13.0943 43.9372 13.0943 47.4215 16.5785C50.9057 20.0628 50.9057 25.7118 47.4215 29.1961L43.9166 32.701C43.1423 33.4753 43.1423 34.7306 43.9166 35.5049C44.6909 36.2792 45.9462 36.2792 46.7205 35.5049L50.2254 32C55.2582 26.9672 55.2582 18.8074 50.2254 13.7746Z" />
			<path d="M13.7746 50.2254C18.8074 55.2582 26.9672 55.2582 32 50.2254L36.7908 45.4346C41.5005 40.7249 41.5005 33.0888 36.7908 28.379L36.2059 27.7941C35.4316 27.0199 34.1762 27.0199 33.402 27.7941C32.6277 28.5684 32.6277 29.8238 33.402 30.598L33.9868 31.1829C37.1481 34.3442 37.1481 39.4695 33.9868 42.6307L29.1961 47.4215C25.7118 50.9057 20.0628 50.9057 16.5785 47.4215C13.0943 43.9372 13.0943 38.2882 16.5785 34.8039L20.0834 31.299C20.8577 30.5247 20.8577 29.2694 20.0834 28.4951C19.3091 27.7208 18.0538 27.7208 17.2795 28.4951L13.7746 32C8.7418 37.0328 8.7418 45.1926 13.7746 50.2254Z" />
		</motion.g>
	);
}

function More(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M53.0208 32.0208C53.0208 34.7822 50.7822 37.0208 48.0208 37.0208C45.2594 37.0208 43.0208 34.7822 43.0208 32.0208C43.0208 29.2593 45.2594 27.0208 48.0208 27.0208C50.7822 27.0208 53.0208 29.2593 53.0208 32.0208ZM37.0208 32.0208C37.0208 34.7822 34.7822 37.0208 32.0208 37.0208C29.2594 37.0208 27.0208 34.7822 27.0208 32.0208C27.0208 29.2593 29.2594 27.0208 32.0208 27.0208C34.7822 27.0207 37.0209 29.2592 37.0209 32.0207C37.0209 32.0207 37.0209 32.0207 37.0209 32.0208H37.0208ZM16.0208 27.0208C18.7822 27.0208 21.0208 29.2593 21.0208 32.0208C21.0208 34.7822 18.7822 37.0208 16.0208 37.0208C13.2594 37.0208 11.0208 34.7822 11.0208 32.0208V32.0209C11.0208 29.2595 13.2593 27.021 16.0206 27.0209L16.0208 27.0208Z"
		/>
	);
}

function HeartEmpty(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.0002 26C13.7011 26 5.00042 20.2731 5.00042 12.5386L5.00042 12.5385C4.96091 8.97471 7.7207 6.05005 11.1703 6V6C13.0643 6.00815 14.8479 6.92206 16.0002 8.47491H16.0002C17.1526 6.92202 18.9362 6.00809 20.8302 6V6C24.2798 6.04998 27.0396 8.97468 27.0001 12.5385C27.0001 20.2731 18.2995 26 16.0002 26V26ZM20.8302 7.8182C17.978 7.8182 17.0104 10.5455 16.0002 10.5455C14.9901 10.5455 14.0225 7.8182 11.1703 7.8182V7.8182C8.69229 7.86731 6.71996 9.97849 6.76039 12.5386C6.76039 19.4025 14.849 24.1676 16.0002 24.1818C17.1515 24.1676 25.2401 19.4025 25.2401 12.5386V12.5385C25.2805 9.97847 23.3082 7.86728 20.8302 7.81819V7.8182Z"
		/>
	);
}

function AddPage(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14 14C9.58172 14 6 17.5817 6 22V42C6 46.4183 9.58172 50 14 50H50C54.4183 50 58 46.4183 58 42V22C58 17.5817 54.4183 14 50 14H14ZM30 24C30 22.8954 30.8954 22 32 22C33.1046 22 34 22.8954 34 24V30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H34V40C34 41.1046 33.1046 42 32 42C30.8954 42 30 41.1046 30 40V34H24C22.8954 34 22 33.1046 22 32C22 30.8954 22.8954 30 24 30H30V24Z"
		/>
	);
}

function GridFilled(props) {
	return (
		<motion.g>
			<path d="M16 12C13.7909 12 12 13.7909 12 16V25C12 27.2091 13.7909 29 16 29H25C27.2091 29 29 27.2091 29 25V16C29 13.7909 27.2091 12 25 12H16Z" />
			<path d="M16 35C13.7909 35 12 36.7909 12 39V48C12 50.2091 13.7909 52 16 52H25C27.2091 52 29 50.2091 29 48V39C29 36.7909 27.2091 35 25 35H16Z" />
			<path d="M35 16C35 13.7909 36.7909 12 39 12H48C50.2091 12 52 13.7909 52 16V25C52 27.2091 50.2091 29 48 29H39C36.7909 29 35 27.2091 35 25V16Z" />
			<path d="M39 35C36.7909 35 35 36.7909 35 39V48C35 50.2091 36.7909 52 39 52H48C50.2091 52 52 50.2091 52 48V39C52 36.7909 50.2091 35 48 35H39Z" />
		</motion.g>
	);
}

function Grid(props) {
	return (
		<motion.g>
			<path d="M16 12C13.7909 12 12 13.7909 12 16V26C12 28.2091 13.7909 30 16 30H26C28.2091 30 30 28.2091 30 26V16C30 13.7909 28.2091 12 26 12H16Z" />
			<path d="M38 12C35.7909 12 34 13.7909 34 16V26C34 28.2091 35.7909 30 38 30H48C50.2091 30 52 28.2091 52 26V16C52 13.7909 50.2091 12 48 12H38Z" />
			<path d="M34 38C34 35.7909 35.7909 34 38 34H48C50.2091 34 52 35.7909 52 38V48C52 50.2091 50.2091 52 48 52H38C35.7909 52 34 50.2091 34 48V38Z" />
			<path d="M16 34C13.7909 34 12 35.7909 12 38V48C12 50.2091 13.7909 52 16 52H26C28.2091 52 30 50.2091 30 48V38C30 35.7909 28.2091 34 26 34H16Z" />
		</motion.g>
	);
}

function GridOutline(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 16C12 13.7909 13.7909 12 16 12H25C27.2091 12 29 13.7909 29 16V25C29 27.2091 27.2091 29 25 29H16C13.7909 29 12 27.2091 12 25V16ZM16 17C16 16.4477 16.4477 16 17 16H24C24.5523 16 25 16.4477 25 17V24C25 24.5523 24.5523 25 24 25H17C16.4477 25 16 24.5523 16 24V17Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 39C12 36.7909 13.7909 35 16 35H25C27.2091 35 29 36.7909 29 39V48C29 50.2091 27.2091 52 25 52H16C13.7909 52 12 50.2091 12 48V39ZM16 40C16 39.4477 16.4477 39 17 39H24C24.5523 39 25 39.4477 25 40V47C25 47.5523 24.5523 48 24 48H17C16.4477 48 16 47.5523 16 47V40Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M39 12C36.7909 12 35 13.7909 35 16V25C35 27.2091 36.7909 29 39 29H48C50.2091 29 52 27.2091 52 25V16C52 13.7909 50.2091 12 48 12H39ZM40 16C39.4477 16 39 16.4477 39 17V24C39 24.5523 39.4477 25 40 25H47C47.5523 25 48 24.5523 48 24V17C48 16.4477 47.5523 16 47 16H40Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M35 39C35 36.7909 36.7909 35 39 35H48C50.2091 35 52 36.7909 52 39V48C52 50.2091 50.2091 52 48 52H39C36.7909 52 35 50.2091 35 48V39ZM39 40C39 39.4477 39.4477 39 40 39H47C47.5523 39 48 39.4477 48 40V47C48 47.5523 47.5523 48 47 48H40C39.4477 48 39 47.5523 39 47V40Z"
			/>
		</motion.g>
	);
}

function View(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.006 48.0208C17.33 48.0208 10.0405 36.3485 8.22604 32.943C7.91814 32.3667 7.91814 31.6748 8.22604 31.0986C10.0405 27.6931 17.33 16.0208 32.006 16.0208C46.682 16.0208 53.9715 27.6931 55.786 31.0986C56.0941 31.6748 56.0941 32.3668 55.786 32.943C53.9715 36.3485 46.682 48.0208 32.006 48.0208ZM32.0211 21.0208C25.946 21.021 21.0213 25.9461 21.0216 32.0213C21.0219 38.0964 25.947 43.0211 32.0221 43.0208C38.0971 43.0205 43.0216 38.0957 43.0216 32.0208V32.02C43.0216 25.9448 38.0968 21.02 32.0216 21.02C32.0212 21.02 32.0208 21.02 32.0203 21.02L32.0211 21.0208ZM32.0211 39.0215C28.1551 39.0215 25.0211 35.8874 25.0211 32.0215C25.0211 28.1555 28.1551 25.0215 32.0211 25.0215C35.8871 25.0215 39.0211 28.1555 39.0211 32.0215V32.0211C39.0211 35.8869 35.8874 39.0208 32.0215 39.0211L32.0211 39.0215Z"
		/>
	);
}

function ViewOff(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M48.6913 41.7478C48.2939 42.0904 47.6996 42.0688 47.328 41.6983L42.5467 36.9152C42.2701 36.6379 42.1813 36.2244 42.3196 35.858V35.858C44.4442 30.1734 41.5582 23.8429 35.8736 21.7183C33.3943 20.7917 30.6637 20.7911 28.184 21.7168C27.8175 21.8549 27.4041 21.766 27.1269 21.4894L23.9324 18.2936C23.6879 18.0498 23.6872 17.654 23.931 17.4094C23.9999 17.3403 24.084 17.2883 24.1766 17.2575H24.1766C26.7037 16.4336 29.346 16.0175 32.004 16.0248C46.674 16.0248 53.9599 27.6935 55.774 31.0979V31.0979C56.0819 31.674 56.0819 32.3657 55.774 32.9418C53.9582 36.2767 51.5594 39.2592 48.6913 41.7478L48.6913 41.7478ZM13.4328 10.6158L53.4252 50.628C54.2065 51.4088 54.2068 52.6752 53.426 53.4564C52.6451 54.2377 51.3788 54.238 50.5975 53.4572L10.6051 13.4451C9.82382 12.6642 9.82346 11.3979 10.6043 10.6166C11.3852 9.83531 12.6515 9.83495 13.4328 10.6158ZM16.6769 22.3439L21.4808 27.1499C21.7567 27.4266 21.8457 27.8388 21.7088 28.2047C19.5979 33.8954 22.4999 40.2199 28.1906 42.3308C30.6551 43.245 33.3657 43.2456 35.8306 42.3324C36.1965 42.1955 36.6087 42.2847 36.8852 42.5607L40.0705 45.7475C40.315 45.9913 40.3157 46.3871 40.0719 46.6317C40.003 46.7008 39.9188 46.7528 39.8262 46.7836C37.3006 47.6064 34.6602 48.0219 32.004 48.0147C17.334 48.0147 10.0481 36.3461 8.23401 32.9418C7.9259 32.3658 7.9259 31.6739 8.23401 31.0979L8.23401 31.0979C10.0488 27.7641 12.4464 24.7825 15.313 22.2945C15.7106 21.9517 16.3052 21.9733 16.6769 22.3439V22.3439Z"
		/>
	);
}

function ProgressRing(props) {
	return (
		<g>
			<path
				opacity="0.25"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32 17C23.7157 17 17 23.7157 17 32C17 40.2843 23.7157 47 32 47C40.2843 47 47 40.2843 47 32C47 23.7157 40.2843 17 32 17ZM11 32C11 20.402 20.402 11 32 11C43.598 11 53 20.402 53 32C53 43.598 43.598 53 32 53C20.402 53 11 43.598 11 32Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29 14C29 12.3431 30.3431 11 32 11C43.598 11 53 20.402 53 32C53 43.598 43.598 53 32 53C23.8399 53 16.7722 48.3451 13.2978 41.5598C11.8279 38.689 11 35.4368 11 32C11 30.3431 12.3431 29 14 29C15.6569 29 17 30.3431 17 32C17 34.4641 17.5918 36.7812 18.6384 38.8252C21.1267 43.6846 26.1787 47 32 47C40.2843 47 47 40.2843 47 32C47 23.7157 40.2843 17 32 17C30.3431 17 29 15.6569 29 14Z"
			/>
		</g>
	);
}

function Title(props) {
	return (
		<path d="M19.5 13C18.1193 13 17 14.1193 17 15.5C17 16.8807 18.1193 18 19.5 18H29.5V48.5C29.5 49.8807 30.6193 51 32 51C33.3807 51 34.5 49.8807 34.5 48.5V18H44.5C45.8807 18 47 16.8807 47 15.5C47 14.1193 45.8807 13 44.5 13H19.5Z" />
	);
}

function TitleOff(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29.5 38.0061V48.5C29.5 49.8807 30.6193 51 32 51C33.3807 51 34.5 49.8807 34.5 48.5V43.0212L29.5 38.0061ZM34.5 25.9528V18H44.5C45.8807 18 47 16.8807 47 15.5C47 14.1193 45.8807 13 44.5 13H21.568C23.0484 14.4778 24.742 16.1718 26.5677 18H29.5V20.9379C31.1197 22.5615 32.8021 24.249 34.5 25.9528Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M53.403 50.5808L13.4106 10.5765C12.6351 9.78981 11.3688 9.78071 10.5822 10.5561C9.79556 11.3315 9.78646 12.5978 10.5619 13.3845C10.5688 13.3915 10.5757 13.3984 10.5828 13.4053L50.5755 53.4092C51.343 54.2036 52.6091 54.2254 53.4035 53.4579C54.1978 52.6904 54.2196 51.4243 53.4521 50.6299C53.436 50.6132 53.4196 50.5969 53.403 50.5808Z"
			/>
		</motion.g>
	);
}

function Text(props) {
	return (
		<motion.g>
			<path d="M8.58031 48C9.60321 48 10.5138 47.352 10.849 46.3856L13.1683 39.6993C13.2032 39.5987 13.298 39.5312 13.4045 39.5312H25.5484C25.655 39.5312 25.7499 39.5989 25.7847 39.6997L28.0905 46.3828C28.4244 47.3506 29.3354 48 30.3592 48C32.0213 48 33.1801 46.3513 32.6174 44.7874L23.2022 18.6243C22.6356 17.0498 21.1421 16 19.4688 16C17.7954 16 16.3019 17.0498 15.7353 18.6243L6.32082 44.7856C5.75771 46.3504 6.91726 48 8.58031 48ZM14.9837 35.4688C14.8119 35.4688 14.6913 35.2995 14.7474 35.1371L19.3107 21.9306C19.3352 21.8599 19.4018 21.8125 19.4766 21.8125C19.5514 21.8125 19.618 21.8599 19.6424 21.9306L24.2057 35.1371C24.2618 35.2995 24.1412 35.4688 23.9694 35.4688H14.9837Z" />
			<path d="M45.0039 48.5312C48.9727 48.5312 51.207 46.5156 52.0977 44.7188H52.2852V45.7188C52.2852 46.9786 53.3065 48 54.5664 48C55.8263 48 56.8477 46.9786 56.8477 45.7188V32.0625C56.8477 25.0781 51.3477 23.6875 47.5352 23.6875C44.0395 23.6875 40.7665 24.8209 38.8073 27.5436C38.0105 28.6509 38.7992 30.0791 40.1293 30.382C41.2187 30.6301 42.2931 30.0012 43.0669 29.1953C44.0216 28.2012 45.4992 27.4688 47.5977 27.4688C50.6133 27.4688 52.1602 29.0469 52.1602 31.7656V31.875C52.1602 33.5781 50.4102 33.5469 46.0977 34.0469C41.5508 34.5781 36.8945 35.7656 36.8945 41.2188C36.8945 45.9375 40.4414 48.5312 45.0039 48.5312ZM46.0195 44.7812C43.3789 44.7812 41.4727 43.5938 41.4727 41.2812C41.4727 38.7812 43.6914 37.8906 46.3945 37.5312C47.9102 37.3281 51.5039 36.9219 52.1758 36.25V39.3438C52.1758 42.1875 49.9102 44.7812 46.0195 44.7812Z" />
		</motion.g>
	);
}

function TextSize(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M57.9023 45.2549C58.4298 46.569 57.4623 48 56.0463 48H55.7607C54.9332 48 54.1911 47.4903 53.894 46.718L50.8533 38.8119C50.779 38.6188 50.5935 38.4914 50.3866 38.4914H36.7191C36.5122 38.4914 36.3267 38.6188 36.2524 38.8119L33.2117 46.718C32.9146 47.4903 32.1725 48 31.345 48H31.2841C29.8691 48 28.9016 46.5709 29.4271 45.2572L40.1956 18.336C40.7599 16.9251 42.1264 16 43.646 16C45.1638 16 46.5291 16.9231 47.0946 18.3318L57.9023 45.2549ZM43.1001 21.0221C42.9498 21.4169 42.7942 21.817 42.6386 22.2171L37.8326 34.6772C37.7694 34.841 37.8903 35.0171 38.0658 35.0171H49.0399C49.2154 35.0171 49.3363 34.841 49.2731 34.6772L44.4671 22.2171C44.3319 21.8693 44.2048 21.5215 44.0789 21.1771C44.0594 21.1235 44.0398 21.07 44.0202 21.0165C43.8625 20.5855 43.2634 20.5932 43.1001 21.0221Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.2811 45.9884C25.6676 46.9513 24.9586 48 23.9209 48C23.3145 48 22.7707 47.6265 22.553 47.0605L20.4617 41.6231C20.4245 41.5266 20.3318 41.4629 20.2283 41.4629H10.7032C10.5997 41.4629 10.507 41.5266 10.4698 41.6231L8.36096 47.1062C8.15385 47.6447 7.63649 48 7.05954 48C6.07309 48 5.39856 47.0037 5.76492 46.0878L13.1576 27.606C13.5456 26.636 14.4851 26 15.5298 26C16.5733 26 17.512 26.6347 17.9007 27.6031L25.2811 45.9884ZM15.2413 29.2232C15.1117 29.5685 14.9744 29.9214 14.8372 30.2743L11.574 38.7343C11.5109 38.8981 11.6317 39.0743 11.8073 39.0743H19.1242C19.2998 39.0743 19.4207 38.8981 19.3575 38.7343L16.0943 30.2743C16.0013 30.0351 15.9139 29.796 15.8274 29.5592C15.7857 29.445 15.7442 29.3314 15.7023 29.2186C15.6225 29.0035 15.3219 29.0083 15.2413 29.2232Z"
			/>
		</motion.g>
	);
}

function TextSizeFlipped(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32.4283 48C33.8442 48 34.8118 46.569 34.2843 45.2549L23.4766 18.3318C22.9111 16.9231 21.5458 16 20.0279 16C18.5084 16 17.1419 16.9251 16.5776 18.336L5.80908 45.2572C5.28359 46.5709 6.25111 48 7.66604 48H7.72694C8.55449 48 9.29656 47.4903 9.59363 46.718L12.6344 38.8119C12.7087 38.6188 12.8942 38.4914 13.1011 38.4914H26.7686C26.9755 38.4914 27.161 38.6188 27.2352 38.8119L30.276 46.718C30.5731 47.4903 31.3152 48 32.1427 48H32.4283ZM19.0205 22.2171C19.1761 21.817 19.3317 21.4169 19.4821 21.0221C19.6454 20.5932 20.2445 20.5855 20.4022 21.0165L20.4609 21.1771C20.5867 21.5215 20.7138 21.8693 20.8491 22.2171L25.6551 34.6772C25.7183 34.841 25.5974 35.0171 25.4219 35.0171H14.4478C14.2722 35.0171 14.1514 34.841 14.2145 34.6772L19.0205 22.2171Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56.6874 48C57.7251 48 58.4341 46.9513 58.0476 45.9884L50.6672 27.6031C50.2784 26.6347 49.3398 26 48.2962 26C47.2515 26 46.3121 26.636 45.9241 27.606L38.5314 46.0878C38.165 47.0037 38.8396 48 39.826 48C40.403 48 40.9203 47.6447 41.1274 47.1062L43.2363 41.6231C43.2734 41.5266 43.3662 41.4629 43.4697 41.4629H52.9948C53.0983 41.4629 53.191 41.5266 53.2282 41.6231L55.3195 47.0605C55.5372 47.6265 56.081 48 56.6874 48ZM47.6037 30.2743C47.7409 29.9214 47.8781 29.5685 48.0078 29.2232C48.0884 29.0083 48.389 29.0035 48.4688 29.2186C48.5107 29.3314 48.5522 29.445 48.5939 29.5592C48.6803 29.7957 48.7679 30.0354 48.8608 30.2743L52.124 38.7343C52.1871 38.8981 52.0663 39.0743 51.8907 39.0743H44.5738C44.3982 39.0743 44.2773 38.8981 44.3405 38.7343L47.6037 30.2743Z"
			/>
		</motion.g>
	);
}

function TextSizeAlt(props) {
	return (
		<motion.g>
			<path d="M9 14C7.89543 14 7 14.8954 7 16C7 17.1046 7.89543 18 9 18H20.5C20.7761 18 21 18.2239 21 18.5V48C21 49.1046 21.8954 50 23 50C24.1046 50 25 49.1046 25 48V18.5C25 18.2239 25.2239 18 25.5 18H37C38.1046 18 39 17.1046 39 16C39 14.8954 38.1046 14 37 14H9Z" />
			<path d="M36 27.6C36 26.7163 36.7089 26 37.5833 26H53.4167C54.2911 26 55 26.7163 55 27.6C55 28.4837 54.2911 29.2 53.4167 29.2H47.0833V48.4C47.0833 49.2837 46.3745 50 45.5 50C44.6255 50 43.9167 49.2837 43.9167 48.4V29.2H37.5833C36.7089 29.2 36 28.4837 36 27.6Z" />
		</motion.g>
	);
}

function LengthenText(props) {
	return (
		<motion.g>
			<path d="M14 15C12.8954 15 12 15.8954 12 17C12 18.1046 12.8954 19 14 19H50C51.1046 19 52 18.1046 52 17C52 15.8954 51.1046 15 50 15H14Z" />
			<path d="M14 25C12.8954 25 12 25.8954 12 27C12 28.1046 12.8954 29 14 29H50C51.1046 29 52 28.1046 52 27C52 25.8954 51.1046 25 50 25H14Z" />
			<path d="M12 37C12 35.8954 12.8954 35 14 35H50C51.1046 35 52 35.8954 52 37C52 38.1046 51.1046 39 50 39H14C12.8954 39 12 38.1046 12 37Z" />
			<path d="M14 45C12.8954 45 12 45.8954 12 47C12 48.1046 12.8954 49 14 49H34C35.1046 49 36 48.1046 36 47C36 45.8954 35.1046 45 34 45H14Z" />
		</motion.g>
	);
}

function ShortenText(props) {
	return (
		<motion.g>
			<path d="M14 25C12.8954 25 12 25.8954 12 27C12 28.1046 12.8954 29 14 29H50C51.1046 29 52 28.1046 52 27C52 25.8954 51.1046 25 50 25H14Z" />
			<path d="M14 35C12.8954 35 12 35.8954 12 37C12 38.1046 12.8954 39 14 39H34C35.1046 39 36 38.1046 36 37C36 35.8954 35.1046 35 34 35H14Z" />
		</motion.g>
	);
}

function TextSizeIncrease(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5586 46.4014C10.2341 47.3571 9.33696 48 8.32766 48C6.7028 48 5.5657 46.394 6.10548 44.8614L15.3636 18.5746C15.9069 17.032 17.3645 16 19.0001 16C20.6356 16 22.0932 17.032 22.6365 18.5746L31.8953 44.8632C32.4347 46.3949 31.2983 48 29.6744 48C28.6642 48 27.7667 47.3557 27.4435 46.3987L25.182 39.7013C25.1477 39.5997 25.0524 39.5312 24.9451 39.5312H13.07C12.9629 39.5312 12.8677 39.5995 12.8332 39.7009L10.5586 46.4014ZM14.3788 35.1387C14.3239 35.3007 14.4445 35.4688 14.6156 35.4688H23.3998C23.5709 35.4688 23.6915 35.3007 23.6367 35.1387L19.1692 21.9284C19.1458 21.8591 19.0808 21.8125 19.0077 21.8125C18.9346 21.8125 18.8696 21.8591 18.8462 21.9284L14.3788 35.1387Z"
			/>
			<path d="M50.4143 20.5858C49.6332 19.8047 48.3669 19.8047 47.5858 20.5858L39.5858 28.5858C38.8048 29.3668 38.8048 30.6332 39.5858 31.4142C40.3669 32.1953 41.6332 32.1953 42.4143 31.4142L47.0001 26.8284V42C47.0001 43.1046 47.8955 44 49.0001 44C50.1046 44 51.0001 43.1046 51.0001 42V26.8284L55.5858 31.4142C56.3669 32.1953 57.6332 32.1953 58.4143 31.4142C59.1953 30.6332 59.1953 29.3668 58.4143 28.5858L50.4143 20.5858Z" />
		</motion.g>
	);
}

function TextSizeDecrease(props) {
	return (
		<motion.g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5586 46.4014C10.2341 47.3571 9.33696 48 8.32766 48C6.7028 48 5.5657 46.394 6.10548 44.8614L15.3636 18.5746C15.9069 17.032 17.3645 16 19.0001 16C20.6356 16 22.0932 17.032 22.6365 18.5746L31.8953 44.8632C32.4347 46.3949 31.2983 48 29.6744 48C28.6642 48 27.7667 47.3557 27.4435 46.3987L25.182 39.7013C25.1477 39.5997 25.0524 39.5312 24.9451 39.5312H13.07C12.9629 39.5312 12.8677 39.5995 12.8332 39.7009L10.5586 46.4014ZM14.3788 35.1387C14.3239 35.3007 14.4445 35.4688 14.6156 35.4688H23.3998C23.5709 35.4688 23.6915 35.3007 23.6367 35.1387L19.1692 21.9284C19.1458 21.8591 19.0808 21.8125 19.0077 21.8125C18.9346 21.8125 18.8696 21.8591 18.8462 21.9284L14.3788 35.1387Z"
			/>
			<path d="M58.4143 35.4142L50.4143 43.4142C49.6332 44.1953 48.3669 44.1953 47.5858 43.4142L39.5858 35.4142C38.8048 34.6332 38.8048 33.3668 39.5858 32.5858C40.3669 31.8047 41.6332 31.8047 42.4143 32.5858L47.0001 37.1716V22C47.0001 20.8954 47.8955 20 49.0001 20C50.1046 20 51.0001 20.8954 51.0001 22V37.1716L55.5858 32.5858C56.3669 31.8047 57.6332 31.8047 58.4143 32.5858C59.1953 33.3668 59.1953 34.6332 58.4143 35.4142Z" />
		</motion.g>
	);
}

function FitLandscape(props) {
	return (
		<motion.g>
			<path d="M34.865 8C35.7128 8 36.176 8.98886 35.6332 9.64018L32.7682 13.0781C32.3684 13.5579 31.6316 13.5579 31.2318 13.0781L28.3668 9.64018C27.824 8.98886 28.2872 8 29.135 8H34.865Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 18C14.6863 18 12 20.6863 12 24V40C12 43.3137 14.6863 46 18 46H46C49.3137 46 52 43.3137 52 40V24C52 20.6863 49.3137 18 46 18H18ZM46 22H18C16.8954 22 16 22.8954 16 24V40C16 41.1046 16.8954 42 18 42H46C47.1046 42 48 41.1046 48 40V24C48 22.8954 47.1046 22 46 22Z"
			/>
			<path d="M29.135 56C28.2872 56 27.824 55.0111 28.3668 54.3598L31.2318 50.9219C31.6316 50.4421 32.3684 50.4421 32.7682 50.9219L35.6332 54.3598C36.176 55.0111 35.7128 56 34.865 56H29.135Z" />
		</motion.g>
	);
}

function FillLandscape(props) {
	return (
		<motion.g>
			<path d="M34.865 14C35.7128 14 36.176 13.0111 35.6332 12.3598L32.7682 8.92183C32.3684 8.44207 31.6316 8.44207 31.2318 8.92183L28.3668 12.3598C27.824 13.0111 28.2872 14 29.135 14H34.865Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 18C14.6863 18 12 20.6863 12 24V40C12 43.3137 14.6863 46 18 46H46C49.3137 46 52 43.3137 52 40V24C52 20.6863 49.3137 18 46 18H18ZM46 22H18C16.8954 22 16 22.8954 16 24V40C16 41.1045 16.8954 42 18 42H46C47.1046 42 48 41.1045 48 40V24C48 22.8954 47.1046 22 46 22Z"
			/>
			<path d="M29.135 50C28.2872 50 27.824 50.9888 28.3668 51.6401L31.2318 55.0781C31.6316 55.5578 32.3684 55.5578 32.7682 55.0781L35.6332 51.6401C36.176 50.9888 35.7128 50 34.865 50H29.135Z" />
		</motion.g>
	);
}

function Crop(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 10C16 8.89543 16.8954 8 18 8C19.1046 8 20 8.89543 20 10V16H42C45.3137 16 48 18.6863 48 22V44H54C55.1046 44 56 44.8954 56 46C56 47.1046 55.1046 48 54 48H48V54C48 55.1046 47.1046 56 46 56C44.8954 56 44 55.1046 44 54V48H22C18.6863 48 16 45.3137 16 42V20H10C8.89543 20 8 19.1046 8 18C8 16.8954 8.89543 16 10 16H16V10ZM21 20C20.4477 20 20 20.4477 20 21V42C20 43.1046 20.8954 44 22 44H43C43.5523 44 44 43.5523 44 43V22C44 20.8954 43.1046 20 42 20H21Z"
		/>
	);
}

function Cut(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.945 36.5209L39.3183 33.8277C39.9614 33.4318 40.7727 33.4318 41.4159 33.8277L55.5438 42.5277C55.981 42.7964 56.1439 43.3524 55.9207 43.8146C55.0956 45.531 52.62 48.9765 46.9649 45.4952C45.3012 44.4706 40.494 41.5652 34.9549 38.2302C34.4812 37.9455 34.3279 37.3308 34.6126 36.8571C34.6949 36.7201 34.8089 36.6048 34.945 36.5209H34.945ZM19.6985 51.7609C15.7298 54.0418 10.8872 53.0887 8.88247 49.6315C6.87777 46.1743 8.46957 41.5228 12.4381 39.2415C13.9848 38.3526 18.9081 35.4166 24.5964 32.0073C18.9081 28.5979 13.9848 25.6621 12.4381 24.7732C8.46957 22.492 6.87807 17.8404 8.88247 14.3832C10.8869 10.926 15.7298 9.97315 19.6985 12.2539C22.5303 13.7701 24.2163 16.8 24.0121 20.0057C23.881 21.6622 24.598 23.2725 25.9169 24.2835L31.6163 27.7935C38.48 23.667 44.9735 19.7463 46.9649 18.5204C52.6237 15.0367 55.0989 18.4888 55.9223 20.2041H55.9223C56.1447 20.6656 55.981 21.2205 55.5438 21.4875L25.9169 39.7311C24.598 40.742 23.881 42.3523 24.0121 44.0089C24.2163 47.2146 22.5303 50.2444 19.6985 51.7607V51.7609ZM19.5973 20.4083C20.5948 18.8029 19.8028 16.6426 17.8287 15.5834C15.8546 14.5242 13.446 14.9667 12.4487 16.5723C11.4514 18.1779 12.2433 20.3378 14.2174 21.3971C16.1915 22.4564 18.6002 22.0136 19.5973 20.4081V20.4083ZM17.8059 48.3956C19.7721 47.3316 20.561 45.1618 19.5674 43.5492C18.5738 41.9366 16.1748 41.4919 14.2086 42.556C12.2424 43.6201 11.4535 45.7898 12.4469 47.4024C13.4403 49.015 15.8397 49.4597 17.8059 48.3956Z"
		/>
	);
}

function Copy(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24 19.2171V11C24 7.68629 26.6863 5 30 5H36.4006C38.0591 5 39.6435 5.68645 40.7778 6.89635L52.3772 19.269C52.5923 19.4985 52.7877 19.743 52.9624 20H53V20.056C53.6481 21.0331 54 22.1856 54 23.3727V39C54 42.3137 51.3137 45 48 45H40V53C40 56.3137 37.3137 59 34 59H16C12.6863 59 10 56.3137 10 53V25C10 21.6863 12.6863 19 16 19H22.4006C22.9462 19 23.4838 19.0743 24 19.2171ZM50 39C50 40.1046 49.1046 41 48 41H40V37.3727C40 36.1856 39.6481 35.0331 39 34.056V34H38.9624C38.7877 33.743 38.5923 33.4985 38.3772 33.269L28 22.2V11C28 9.89543 28.8954 9 30 9H35V18C35 21.3137 37.6863 24 41 24H50V39ZM47.5796 20H41C39.8954 20 39 19.1046 39 18V10.8485L47.5796 20ZM34 55C35.1046 55 36 54.1046 36 53V38H27C23.6863 38 21 35.3137 21 32V23H16C14.8954 23 14 23.8954 14 25V53C14 54.1046 14.8954 55 16 55H34ZM27 34H33.5796L25 24.8485V32C25 33.1046 25.8954 34 27 34Z"
		/>
	);
}

function Paste(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 6C35.866 6 39 9.13401 39 13H42C46.4183 13 50 16.5817 50 21V46C50 50.4183 46.4183 54 42 54H22C17.5817 54 14 50.4183 14 46V21C14 16.5817 17.5817 13 22 13H25C25 9.13401 28.134 6 32 6ZM40 17H42C44.2091 17 46 18.7909 46 21V46C46 48.2091 44.2091 50 42 50H22C19.7909 50 18 48.2091 18 46V21C18 18.7909 19.7909 17 22 17H24V21C24 22.1046 24.8954 23 26 23H38C39.1046 23 40 22.1046 40 21V17ZM32 16C33.6569 16 35 14.6569 35 13C35 11.3431 33.6569 10 32 10C30.3431 10 29 11.3431 29 13C29 14.6569 30.3431 16 32 16Z"
		/>
	);
}

function Share(props) {
	return (
		<motion.g>
			<path d="M33.4142 9.58579C32.6332 8.80474 31.3668 8.80474 30.5858 9.58579L24.5858 15.5858C23.8047 16.3668 23.8047 17.6332 24.5858 18.4142C25.3668 19.1953 26.6332 19.1953 27.4142 18.4142L30 15.8284V36C30 37.1046 30.8954 38 32 38C33.1046 38 34 37.1046 34 36V15.8284L36.5858 18.4142C37.3668 19.1953 38.6332 19.1953 39.4142 18.4142C40.1953 17.6332 40.1953 16.3668 39.4142 15.5858L33.4142 9.58579Z" />
			<path d="M14 30C14 25.5817 17.5817 22 22 22H24C25.1046 22 26 22.8954 26 24C26 25.1046 25.1046 26 24 26H22C19.7909 26 18 27.7909 18 30V46C18 48.2091 19.7909 50 22 50H42C44.2091 50 46 48.2091 46 46V30C46 27.7909 44.2091 26 42 26H40C38.8954 26 38 25.1046 38 24C38 22.8954 38.8954 22 40 22H42C46.4183 22 50 25.5817 50 30V46C50 50.4183 46.4183 54 42 54H22C17.5817 54 14 50.4183 14 46V30Z" />
		</motion.g>
	);
}

function Code(props) {
	return (
		<motion.g>
			<path d="M25.4142 19.4142C26.1953 18.6332 26.1953 17.3668 25.4142 16.5858C24.6332 15.8047 23.3668 15.8047 22.5858 16.5858L8.58579 30.5858C7.80474 31.3668 7.80474 32.6332 8.58579 33.4142L22.5858 47.4142C23.3668 48.1953 24.6332 48.1953 25.4142 47.4142C26.1953 46.6332 26.1953 45.3668 25.4142 44.5858L12.8284 32L25.4142 19.4142Z" />
			<path d="M38.5858 19.4142C37.8047 18.6332 37.8047 17.3668 38.5858 16.5858C39.3668 15.8047 40.6332 15.8047 41.4142 16.5858L55.4142 30.5858C56.1953 31.3668 56.1953 32.6332 55.4142 33.4142L41.4142 47.4142C40.6332 48.1953 39.3668 48.1953 38.5858 47.4142C37.8047 46.6332 37.8047 45.3668 38.5858 44.5858L51.1716 32L38.5858 19.4142Z" />{" "}
		</motion.g>
	);
}

function Image(props) {
	return (
		<g>
			<path d="M22 30C24.2091 30 26 28.2091 26 26C26 23.7909 24.2091 22 22 22C19.7909 22 18 23.7909 18 26C18 28.2091 19.7909 30 22 30Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 12C11.5817 12 8 15.5817 8 20V44C8 48.4183 11.5817 52 16 52H48C52.4183 52 56 48.4183 56 44V20C56 15.5817 52.4183 12 48 12H16ZM16 16C13.7909 16 12 17.7909 12 20V44L18.2131 37.7869C19.2456 36.7544 20.8716 36.6152 22.0645 37.4573L28.1796 41.7738C28.3677 41.9066 28.6222 41.8937 28.796 41.7426L37.8886 33.836C39.0777 32.802 40.8642 32.8642 41.9785 33.9785L52 44V20C52 17.7909 50.2091 16 48 16H16Z"
			/>
		</g>
	);
}

function Background(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 17C16 13.6863 18.6863 11 22 11H52C55.3137 11 58 13.6863 58 17V37C58 40.3137 55.3137 43 52 43V23C52 19.6863 49.3137 17 46 17H16ZM12 25H42C43.1046 25 44 25.8954 44 27V47C44 48.1046 43.1046 49 42 49H12C10.8954 49 10 48.1046 10 47V27C10 25.8954 10.8954 25 12 25ZM6 27C6 23.6863 8.68629 21 12 21H42C45.3137 21 48 23.6863 48 27V47C48 50.3137 45.3137 53 42 53H12C8.68629 53 6 50.3137 6 47V27Z"
		/>
	);
}

function MoveIndicator(props) {
	return (
		<g>
			<circle cx="15.2731" cy="24.0001" r="3.63636" />
			<circle cx="31.2731" cy="24.0001" r="3.63636" />
			<circle cx="47.2731" cy="24.0001" r="3.63636" />
			<circle cx="15.2731" cy="40.0001" r="3.63636" />
			<circle cx="31.2731" cy="40.0001" r="3.63636" />
			<circle cx="47.2731" cy="40.0001" r="3.63636" />
		</g>
	);
}

function MoveIndicator4Dots(props) {
	return (
		<g>
			<circle cx="21" cy="23" r="4" />
			<circle cx="42.8182" cy="23" r="4" />
			<circle cx="21" cy="41.9091" r="4" />
			<circle cx="42.8182" cy="41.9091" r="4" />
		</g>
	);
}

function VideoCamera(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M56.7661 45.8477C56.0186 46.1574 55.1582 45.9863 54.5861 45.4141L44.5861 35.4141C44.211 35.0391 44.0002 34.5304 44.0001 34V30V30.0003C44.0001 29.4699 44.2108 28.9612 44.5859 28.5861L54.5859 18.5861H54.5859C55.367 17.8052 56.6334 17.8054 57.4143 18.5866C57.7892 18.9615 57.9998 19.47 57.9999 20.0002V44.0002V44.0003C57.9999 44.8089 57.513 45.538 56.766 45.8477L56.7661 45.8477ZM12 16H36C39.3137 16 42 18.6863 42 22V42C42 45.3137 39.3137 48 36 48H12C8.68629 48 6 45.3137 6 42V22C6 18.6863 8.68629 16 12 16H12Z"
		/>
	);
}

function Microphone(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.0208 47.8686V52.0068H42.0208C43.1254 52.0068 44.0208 52.9023 44.0208 54.0068C44.0208 55.1114 43.1254 56.0068 42.0208 56.0068H22.0208C20.9162 56.0068 20.0208 55.1114 20.0208 54.0068C20.0208 52.9023 20.9162 52.0068 22.0208 52.0068H30.0208V47.8686C22.0241 46.8643 16.0241 40.0664 16.0208 32.0068V28.0068C16.0208 26.9023 16.9162 26.0068 18.0208 26.0068C19.1254 26.0068 20.0208 26.9023 20.0208 28.0068V32.0068C20.0208 38.6343 25.3934 44.0068 32.0208 44.0068C38.6482 44.0068 44.0208 38.6343 44.0208 32.0068V28.0068C44.0208 26.9023 44.9162 26.0068 46.0208 26.0068C47.1254 26.0068 48.0208 26.9023 48.0208 28.0068V32.0068V32.0058C48.018 40.0654 42.0185 46.8636 34.0218 47.8685L34.0208 47.8686ZM32.0208 40.0068C27.6025 40.0068 24.0208 36.4251 24.0208 32.0068V16.0068V16.0068C24.0208 11.5886 27.6025 8.00684 32.0208 8.00684C36.4391 8.00684 40.0208 11.5886 40.0208 16.0068V32.0068C40.0208 36.4251 36.4391 40.0068 32.0208 40.0068C32.0208 40.0068 32.0208 40.0068 32.0208 40.0068H32.0208Z"
		/>
	);
}

function Video(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 16C8 12.6863 10.6863 10 14 10H50C53.3137 10 56 12.6863 56 16V48C56 51.3137 53.3137 54 50 54H14C10.6863 54 8 51.3137 8 48V16ZM12 16C12 14.8954 12.8954 14 14 14H16C17.1046 14 18 14.8954 18 16V18C18 19.1046 17.1046 20 16 20H14C12.8954 20 12 19.1046 12 18V16ZM48 14C46.8954 14 46 14.8954 46 16V18C46 19.1046 46.8954 20 48 20H50C51.1046 20 52 19.1046 52 18V16C52 14.8954 51.1046 14 50 14H48ZM12 26C12 24.8954 12.8954 24 14 24H16C17.1046 24 18 24.8954 18 26V28C18 29.1046 17.1046 30 16 30H14C12.8954 30 12 29.1046 12 28V26ZM48 24C46.8954 24 46 24.8954 46 26V28C46 29.1046 46.8954 30 48 30H50C51.1046 30 52 29.1046 52 28V26C52 24.8954 51.1046 24 50 24H48ZM12 36C12 34.8954 12.8954 34 14 34H16C17.1046 34 18 34.8954 18 36V38C18 39.1046 17.1046 40 16 40H14C12.8954 40 12 39.1046 12 38V36ZM48 34C46.8954 34 46 34.8954 46 36V38C46 39.1046 46.8954 40 48 40H50C51.1046 40 52 39.1046 52 38V36C52 34.8954 51.1046 34 50 34H48ZM12 46C12 44.8954 12.8954 44 14 44H16C17.1046 44 18 44.8954 18 46V48C18 49.1046 17.1046 50 16 50H14C12.8954 50 12 49.1046 12 48V46ZM48 44C46.8954 44 46 44.8954 46 46V48C46 49.1046 46.8954 50 48 50H50C51.1046 50 52 49.1046 52 48V46C52 44.8954 51.1046 44 50 44H48ZM22 16C22 14.8954 22.8954 14 24 14H40C41.1046 14 42 14.8954 42 16V28C42 29.1046 41.1046 30 40 30H24C22.8954 30 22 29.1046 22 28V16ZM24 34C22.8954 34 22 34.8954 22 36V48C22 49.1046 22.8954 50 24 50H40C41.1046 50 42 49.1046 42 48V36C42 34.8954 41.1046 34 40 34H24Z"
		/>
	);
}

function Web(props) {
	return (
		<g>
			<path d="M18.9165 36.5962C16.5734 38.9394 16.5734 42.7384 18.9165 45.0815C21.2597 47.4246 25.0587 47.4246 27.4018 45.0815L33.7658 38.7175C36.1089 36.3744 36.1089 32.5754 33.7658 30.2323C32.9847 29.4512 32.9847 28.1849 33.7658 27.4038C34.5468 26.6228 35.8132 26.6228 36.5942 27.4038C40.4995 31.3091 40.4995 37.6407 36.5942 41.546L30.2302 47.9099C26.325 51.8152 19.9934 51.8152 16.0881 47.9099C12.1829 44.0047 12.1829 37.673 16.0881 33.7678L18.2094 31.6465C18.9905 30.8654 20.2568 30.8654 21.0379 31.6465C21.8189 32.4275 21.8189 33.6939 21.0379 34.4749L18.9165 36.5962Z" />
			<path d="M45.0795 27.4038C47.4226 25.0607 47.4226 21.2617 45.0795 18.9186C42.7363 16.5754 38.9374 16.5754 36.5942 18.9186L30.2302 25.2825C27.8871 27.6257 27.8871 31.4247 30.2302 33.7678C31.0113 34.5488 31.0113 35.8152 30.2302 36.5962C29.4492 37.3773 28.1829 37.3773 27.4018 36.5962C23.4966 32.691 23.4966 26.3593 27.4018 22.4541L33.7658 16.0901C37.671 12.1849 44.0027 12.1849 47.9079 16.0901C51.8132 19.9954 51.8132 26.327 47.9079 30.2323L45.7866 32.3536C45.0055 33.1346 43.7392 33.1346 42.9582 32.3536C42.1771 31.5725 42.1771 30.3062 42.9582 29.5252L45.0795 27.4038Z" />
		</g>
	);
}

function Table(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 20C8 15.5817 11.5817 12 16 12H48C52.4183 12 56 15.5817 56 20V44C56 48.4183 52.4183 52 48 52H16C11.5817 52 8 48.4183 8 44V20ZM12 20C12 17.7909 13.7909 16 16 16H29C29.5523 16 30 16.4477 30 17V23C30 23.5523 29.5523 24 29 24H13C12.4477 24 12 23.5523 12 23V20ZM13 28C12.4477 28 12 28.4477 12 29V35C12 35.5523 12.4477 36 13 36H29C29.5523 36 30 35.5523 30 35V29C30 28.4477 29.5523 28 29 28H13ZM12 41C12 40.4477 12.4477 40 13 40H29C29.5523 40 30 40.4477 30 41V47C30 47.5523 29.5523 48 29 48H16C13.7909 48 12 46.2091 12 44V41ZM35 16C34.4477 16 34 16.4477 34 17V23C34 23.5523 34.4477 24 35 24H51C51.5523 24 52 23.5523 52 23V20C52 17.7909 50.2091 16 48 16H35ZM34 29C34 28.4477 34.4477 28 35 28H51C51.5523 28 52 28.4477 52 29V35C52 35.5523 51.5523 36 51 36H35C34.4477 36 34 35.5523 34 35V29ZM35 40C34.4477 40 34 40.4477 34 41V47C34 47.5523 34.4477 48 35 48H48C50.2091 48 52 46.2091 52 44V41C52 40.4477 51.5523 40 51 40H35Z"
		/>
	);
}

function PaintBucket(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.45 12.08L25.0595 6.51097V6.51097C24.7896 5.44078 25.4385 4.35447 26.5086 4.08462C27.5788 3.81478 28.6651 4.46359 28.935 5.53378C28.9356 5.53618 28.9362 5.53858 28.9368 5.54098L30.54 11.9621L49.25 30.6713C50.2203 31.6412 50.2206 33.214 49.2508 34.1843C49.2505 34.1846 49.2502 34.1848 49.25 34.1851L29.2471 54.1873C26.826 56.6078 22.9012 56.6078 20.4801 54.1873L6.8 40.5083C4.37566 38.0841 4.37553 34.1536 6.79971 31.7293C6.79981 31.7292 6.7999 31.7291 6.8 31.729L26.45 12.08ZM33.01 31.0213C34.6668 31.0213 36.01 29.6781 36.01 28.0213C36.01 26.3644 34.6668 25.0213 33.01 25.0213C31.3531 25.0213 30.01 26.3644 30.01 28.0213V28.0209C30.01 29.6776 31.3529 31.0207 33.0096 31.0209L33.01 31.0213ZM51.7332 29.7518L45.7367 23.7553C45.4134 23.4316 45.4134 22.9073 45.7367 22.5837H45.7367C46.5177 21.8026 47.784 21.8025 48.5651 22.5835C48.5652 22.5836 48.5652 22.5836 48.5653 22.5837L54.7447 28.7637C57.3697 31.3887 59.01 39.1437 59.01 44.0217C59.01 46.2308 57.2191 48.0217 55.01 48.0217C52.8008 48.0217 51.01 46.2308 51.01 44.0217C51.01 39.8544 52.5193 36.8896 52.9433 33.0517C53.0584 31.8254 52.6139 30.6127 51.7336 29.7514L51.7332 29.7518Z"
		/>
	);
}
function Color(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.45 12.08L25.0595 6.51097V6.51097C24.7896 5.44078 25.4385 4.35447 26.5086 4.08462C27.5788 3.81478 28.6651 4.46359 28.935 5.53378C28.9356 5.53618 28.9362 5.53858 28.9368 5.54098L30.54 11.9621L49.25 30.6713C50.2203 31.6412 50.2206 33.214 49.2508 34.1843C49.2505 34.1846 49.2502 34.1848 49.25 34.1851L29.2471 54.1873C26.826 56.6078 22.9012 56.6078 20.4801 54.1873L6.8 40.5083C4.37566 38.0841 4.37553 34.1536 6.79971 31.7293C6.79981 31.7292 6.7999 31.7291 6.8 31.729L26.45 12.08ZM33.01 31.0213C34.6668 31.0213 36.01 29.6781 36.01 28.0213C36.01 26.3644 34.6668 25.0213 33.01 25.0213C31.3531 25.0213 30.01 26.3644 30.01 28.0213V28.0209C30.01 29.6776 31.3529 31.0207 33.0096 31.0209L33.01 31.0213ZM51.7332 29.7518L45.7367 23.7553C45.4134 23.4316 45.4134 22.9073 45.7367 22.5837H45.7367C46.5177 21.8026 47.784 21.8025 48.5651 22.5835C48.5652 22.5836 48.5652 22.5836 48.5653 22.5837L54.7447 28.7637C57.3697 31.3887 59.01 39.1437 59.01 44.0217C59.01 46.2308 57.2191 48.0217 55.01 48.0217C52.8008 48.0217 51.01 46.2308 51.01 44.0217C51.01 39.8544 52.5193 36.8896 52.9433 33.0517C53.0584 31.8254 52.6139 30.6127 51.7336 29.7514L51.7332 29.7518Z"
		/>
	);
}

function ColorPalette(props) {
	return (
		<g>
			<path d="M42 34C44.2091 34 46 32.2091 46 30C46 27.7909 44.2091 26 42 26C39.7909 26 38 27.7909 38 30C38 32.2091 39.7909 34 42 34Z" />
			<path d="M36 22C36 24.2091 34.2091 26 32 26C29.7909 26 28 24.2091 28 22C28 19.7909 29.7909 18 32 18C34.2091 18 36 19.7909 36 22Z" />
			<path d="M22 34C24.2091 34 26 32.2091 26 30C26 27.7909 24.2091 26 22 26C19.7909 26 18 27.7909 18 30C18 32.2091 19.7909 34 22 34Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32 8C18.7452 8 8 18.7452 8 32C8 44.1492 17.0255 54.1871 28.7382 55.78C31.7631 56.1913 34 53.6766 34 51V47.6847C34 45.15 36.5038 42.9148 39.499 43.0626C42.7768 43.2245 46.7682 43.0175 50.0166 41.5295C51.6737 40.7704 53.1966 39.6507 54.2987 38.0275C55.4075 36.3942 56 34.3832 56 32C56 18.9043 45.2637 8 32 8ZM12 32C12 20.9543 20.9543 12 32 12C43.0368 12 52 21.0957 52 32C52 33.698 51.5871 34.9001 50.9893 35.7808C50.3845 36.6715 49.4993 37.3668 48.3508 37.8929C45.9879 38.9753 42.7781 39.2196 39.6962 39.0675C34.8941 38.8304 30 42.4125 30 47.6847V51C30 51.285 29.8837 51.5183 29.7355 51.6603C29.5995 51.7907 29.4492 51.8398 29.2772 51.8164C19.5202 50.4896 12 42.1214 12 32Z"
			/>
		</g>
	);
}

function ColorPaletteFill(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32 8H32C45.2548 8 56 18.7452 56 32C56 38.6167 50.0207 43 43 43H38C36.2316 43 34 43.3231 34 46C34 48.6266 36 50.28 36 53C36 54.6164 34.7273 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8H32ZM45.5 35C47.9853 35 50 32.9853 50 30.5C50 28.0147 47.9853 26 45.5 26C43.0147 26 41 28.0147 41 30.5V30.4999C41 32.9849 43.0143 34.9995 45.4993 34.9999L45.5 35ZM38.5005 24C40.9858 24 43.0005 21.9853 43.0005 19.5C43.0005 17.0147 40.9858 15 38.5005 15C36.0152 15 34.0005 17.0147 34.0005 19.5V19.4999C34.0005 21.985 36.0149 23.9996 38.5 23.9999L38.5005 24ZM25.5005 24H25.5005C27.9858 24 30.0005 21.9853 30.0005 19.5C30.0005 17.0147 27.9858 15 25.5005 15C23.0152 15 21.0005 17.0147 21.0005 19.5V19.4999C21.0005 21.9849 23.0148 23.9995 25.4998 23.9999L25.5005 24ZM14.0005 30.5C14.0005 32.9853 16.0152 35 18.5005 35C20.9858 35 23.0005 32.9853 23.0005 30.5C23.0005 28.0147 20.9858 26 18.5005 26C16.0152 25.9994 14 28.0136 13.9994 30.4989C13.9994 30.4992 13.9994 30.4995 13.9994 30.4998L14.0005 30.5Z"
		/>
	);
}

function Twitter(props) {
	return (
		<path
			d="M23.78 49.5408C40.5 49.5408 49.6451 35.6884 49.6451 23.6757C49.6451 23.2823 49.6451 22.8906 49.6185 22.5007C51.3976 21.2138 52.9334 19.6205 54.1538 17.7952C52.4948 18.5303 50.7348 19.0125 48.9326 19.2254C50.8303 18.0894 52.2506 16.3025 52.9292 14.1974C51.1447 15.2563 49.1925 16.0025 47.1568 16.4039C45.7862 14.9465 43.9735 13.9815 41.9991 13.6581C40.0248 13.3347 37.9989 13.6711 36.235 14.6151C34.4711 15.5591 33.0675 17.0582 32.2414 18.8803C31.4153 20.7024 31.2127 22.746 31.665 24.6948C28.0509 24.5136 24.5152 23.5744 21.2875 21.9381C18.0599 20.3019 15.2124 18.0051 12.93 15.197C11.7675 17.1982 11.4115 19.5673 11.9343 21.8218C12.4572 24.0763 13.8197 26.0467 15.7444 27.332C14.2977 27.2891 12.8826 26.8988 11.6185 26.1942C11.6185 26.2314 11.6185 26.2704 11.6185 26.3094C11.619 28.4082 12.3456 30.4421 13.6748 32.0663C15.0041 33.6905 16.8543 34.8049 18.9115 35.2205C17.5732 35.5855 16.169 35.6389 14.8068 35.3765C15.3877 37.1828 16.5187 38.7623 18.0414 39.8942C19.5642 41.0261 21.4027 41.6538 23.2997 41.6894C20.0808 44.2193 16.1043 45.5926 12.0101 45.5885C11.2869 45.5871 10.5643 45.5433 9.84615 45.4574C14.0033 48.1252 18.8405 49.5403 23.78 49.5337"
			fill={props.forceColor ? props.color : "#1DA1F2"}
		/>
	);
}

function Giphy(props) {
	return (
		<g>
			<g clipPath="url(#clip0_2:32)">
				<path
					d="M13.9224 13.6433H19.0865V50.3567H13.9224V13.6433Z"
					fill={props.forceColor ? props.color : "#04FF8E"}
				/>
				<path
					d="M44.9135 23.7721H50.0775V50.3567H44.9135V23.7721Z"
					fill={props.forceColor ? props.color : "#8E2EFF"}
				/>
				<path
					d="M13.9224 49.0895H50.0775V54.1538H13.9224V49.0895Z"
					fill={props.forceColor ? props.color : "#00C5FF"}
				/>
				<path
					d="M13.9225 9.84615H34.5832V14.9105H13.9225V9.84615Z"
					fill={props.forceColor ? props.color : "#FFF152"}
				/>
				<path
					d="M44.9134 19.9727V14.9105H39.7472V9.84615H34.5831V25.037H50.0775V19.9727"
					fill={props.forceColor ? props.color : "#FF5B5B"}
				/>
				<path d="M44.9135 30.1014V25.037H50.0775" fill={props.forceColor ? props.color : "#551C99"} />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M34.5831 9.84615V14.9105H29.4169"
					fill={props.forceColor ? props.color : "#999131"}
				/>
			</g>
			<defs>
				<clipPath id="clip0_2:32">
					<rect width="44.3077" height="44.3077" transform="translate(9.84615 9.84615)" />
				</clipPath>
			</defs>
		</g>
	);
}

function Figma(props) {
	return (
		<g>
			<g clipPath="url(#clip0_2:70)">
				<path
					d="M32 32.4064C32 30.3587 32.8134 28.3949 34.2613 26.947C35.7092 25.4991 37.673 24.6857 39.7207 24.6857C41.7683 24.6857 43.7321 25.4991 45.18 26.947C46.6279 28.3949 47.4413 30.3587 47.4413 32.4064C47.4413 34.454 46.6279 36.4178 45.18 37.8657C43.7321 39.3136 41.7683 40.127 39.7207 40.127C37.673 40.127 35.7092 39.3136 34.2613 37.8657C32.8134 36.4178 32 34.454 32 32.4064V32.4064Z"
					fill={props.forceColor ? props.color : "#1ABCFE"}
				/>
				<path
					d="M16.5588 47.8476C16.5588 45.8 17.3722 43.8362 18.8201 42.3883C20.268 40.9404 22.2317 40.127 24.2794 40.127H32V47.8476C32 49.8953 31.1866 51.859 29.7387 53.3069C28.2908 54.7548 26.327 55.5683 24.2794 55.5683C22.2317 55.5683 20.268 54.7548 18.8201 53.3069C17.3722 51.859 16.5588 49.8953 16.5588 47.8476V47.8476Z"
					fill={props.forceColor ? props.color : "#0ACF83"}
				/>
				<path
					d="M32 9.24445V24.6857H39.7207C41.7683 24.6857 43.7321 23.8723 45.18 22.4244C46.6279 20.9765 47.4413 19.0127 47.4413 16.9651C47.4413 14.9174 46.6279 12.9537 45.18 11.5058C43.7321 10.0579 41.7683 9.24445 39.7207 9.24445H32Z"
					fill={props.forceColor ? props.color : "#FF7262"}
				/>
				<path
					d="M16.5587 16.9651C16.5587 19.0127 17.3722 20.9765 18.8201 22.4244C20.268 23.8723 22.2317 24.6857 24.2794 24.6857H32V9.24442H24.2794C22.2317 9.24442 20.268 10.0578 18.8201 11.5057C17.3722 12.9536 16.5587 14.9174 16.5587 16.9651V16.9651Z"
					fill={props.forceColor ? props.color : "#F24E1E"}
				/>
				<path
					d="M16.5588 32.4064C16.5588 34.454 17.3722 36.4178 18.8201 37.8657C20.268 39.3136 22.2317 40.127 24.2794 40.127H32V24.6857H24.2794C22.2317 24.6857 20.268 25.4991 18.8201 26.947C17.3722 28.3949 16.5588 30.3587 16.5588 32.4064V32.4064Z"
					fill={props.forceColor ? props.color : "#A259FF"}
				/>
			</g>
			<defs>
				<clipPath id="clip0_2:70">
					<rect width="30.8825" height="46.3238" transform="translate(16.5587 9.24442)" />
				</clipPath>
			</defs>
		</g>
	);
}

function Airtable(props) {
	return (
		<g>
			<path
				d="M29.504 12.9536L12.0832 20.16C11.1104 20.5568 11.1232 21.9392 12.096 22.3232L29.5936 29.2608C31.1296 29.8752 32.8448 29.8752 34.3808 29.2608L51.8784 22.3232C52.8512 21.9392 52.864 20.5568 51.8912 20.16L34.4704 12.9536C32.8704 12.288 31.0912 12.288 29.504 12.9536Z"
				fill={props.forceColor ? props.color : "#FFBF00"}
			/>
			<path
				d="M33.536 33.0496V50.3808C33.536 51.2 34.368 51.7632 35.136 51.4688L54.6304 43.904C55.0784 43.7248 55.3728 43.3024 55.3728 42.816V25.4848C55.3728 24.6656 54.5408 24.1024 53.7728 24.3968L34.2784 31.9616C33.8304 32.1408 33.536 32.5632 33.536 33.0496Z"
				fill={props.forceColor ? props.color : "#26B5F8"}
			/>
			<path
				d="M28.9792 33.9456L23.1936 36.736L22.6048 37.0176L10.3936 42.8672C9.62563 43.2384 8.62723 42.6752 8.62723 41.8176V25.5488C8.62723 25.2416 8.78083 24.9728 8.99843 24.768C9.08803 24.6784 9.19043 24.6016 9.29283 24.5504C9.58723 24.3712 9.99683 24.3328 10.3552 24.4736L28.8768 31.808C29.824 32.1792 29.9008 33.4976 28.9792 33.9456Z"
				fill={props.forceColor ? props.color : "#ED3049"}
			/>
			<path
				d="M9.93283 24.3839C9.70243 24.3839 9.48483 24.4479 9.31843 24.5503C9.21603 24.6143 9.11363 24.6783 9.02403 24.7679L23.1936 36.7359L28.9792 33.9456C29.4144 33.728 29.632 33.3184 29.632 32.9088C29.632 32.4608 29.376 31.9999 28.8896 31.8079L10.368 24.4735C10.2272 24.4095 10.0736 24.3839 9.93283 24.3839Z"
				fill={props.forceColor ? props.color : "#B22437"}
			/>
		</g>
	);
}

function Dalle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M55.5083 27.3426C56.8831 23.4934 56.3332 19.3692 54.4086 16.0699C51.3842 10.8459 45.3354 8.0965 39.5616 9.47123C36.2622 5.89695 31.3132 4.24727 26.3642 5.07211C21.4152 6.17189 17.566 9.74617 15.9163 14.4202C12.0671 15.2451 8.76776 17.7196 6.84315 21.0189C3.81876 26.2428 4.36865 32.8415 8.49282 37.2406C7.1181 41.0898 7.66799 45.214 9.5926 48.5134C12.617 53.7373 18.6658 56.4867 24.4396 55.112C27.1891 58.1364 30.7633 59.7861 34.8875 59.7861C40.9363 59.7861 46.1602 55.9369 48.0848 50.163C51.9341 49.3382 55.2334 46.8637 57.158 43.5643C60.1824 38.3404 59.6325 31.7417 55.5083 27.3426ZM34.8875 56.2118C32.413 56.2118 30.2134 55.387 28.2888 53.7373L28.5638 53.4624L39.5616 47.1386C40.1115 46.8637 40.3864 46.3138 40.3864 45.489V30.0921L45.0605 32.8415V45.7639C45.0605 51.5377 40.6613 56.2118 34.8875 56.2118ZM12.617 46.5887C11.5172 44.3892 10.9673 42.1896 11.5172 39.7151L11.7922 39.9901L22.7899 46.3138C23.3398 46.5887 23.8897 46.5887 24.7146 46.3138L38.1868 38.6153V43.8393C38.1868 43.8393 38.1868 43.8393 38.1868 44.1142L27.1891 50.438C21.9651 53.1874 15.6414 51.5377 12.617 46.5887ZM9.86754 22.9435C10.9673 20.7439 12.8919 19.3692 15.3664 18.5444V31.4668C15.3664 32.0167 15.6414 32.5666 16.1913 33.1165L29.3886 40.8149L24.7146 43.5643C24.7146 43.5643 24.7145 43.5643 24.4396 43.5643L13.4418 37.2406C8.76776 33.9413 7.1181 27.6176 9.86754 22.9435ZM47.8099 31.7417L34.6126 24.0433L39.2866 21.2938C39.2866 21.2938 39.2866 21.2938 39.5616 21.2938L50.5593 27.6176C54.1336 29.5422 56.0582 33.3914 55.7833 37.5156C55.5083 41.3648 52.7589 44.9391 49.1846 46.3138V33.3914C48.9097 32.5666 48.3598 32.0167 47.8099 31.7417ZM52.4839 24.8681L52.209 24.5932L41.2112 18.2695C40.6613 17.9945 39.8365 17.9945 39.2866 18.2695L26.0893 25.9679V20.744C26.0893 20.744 26.0893 20.744 26.0893 20.469L37.0871 14.1453C40.6613 12.2207 44.7855 12.2207 48.0848 14.6952C51.3842 16.8947 53.0338 20.744 52.4839 24.8681ZM23.6148 34.2162L18.9407 31.4668V18.5444C18.9407 14.4202 21.1403 10.8459 24.9895 9.19628C28.5638 7.54661 32.9629 8.0965 35.9873 10.571L35.7123 10.846L24.7146 17.1697C24.1647 17.4446 23.8897 17.9945 23.8897 18.8193L23.6148 34.2162ZM26.0893 28.7173L32.1381 25.418L38.1868 28.7173V35.591L32.1381 38.8903L26.0893 35.591V28.7173Z"
		/>
	);
}

function Framer(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.9989 24.7123H46.7682V10.2153H17.502V10.3515L31.9989 24.7123Z"
				fill={props.forceColor ? props.color : "#67DBFF"}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.9997 24.7124H17.2305V39.2094H46.4967V39.0733L31.9997 24.7124Z"
				fill={props.forceColor ? props.color : "#01A3FF"}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2305 39.1411H31.8636V53.7742L17.2305 39.1411Z"
				fill={props.forceColor ? props.color : "#0162FF"}
			/>
		</g>
	);
}

function Miro(props) {
	return (
		<path
			d="M41.4004 11.0771H35.3089L40.7168 19.4583L29.284 11.0771H23.1925L28.6004 22.0594L17.1676 11.0771H11.0762L16.3949 25.2549L11.0762 52.9233H17.1676L28.6004 23.2565L23.1925 52.9233H29.284L40.7168 20.6566L35.3089 52.9233H41.4004L52.9223 17.4789L41.4004 11.0771Z"
			fill={props.forceColor ? props.color : "#FFD02F"}
		/>
	);
}

function Looker(props) {
	return (
		<g>
			<path
				d="M31.9006 7.38477C31.1202 7.38511 30.3546 7.59758 29.6857 7.99946C29.0167 8.40133 28.4696 8.9775 28.1028 9.66632C27.736 10.3551 27.5633 11.1307 27.6033 11.9101C27.6433 12.6895 27.8944 13.4433 28.3297 14.091L30.1683 12.255C30.1075 12.0718 30.0769 11.88 30.0776 11.687C30.0776 11.328 30.184 10.977 30.3835 10.6785C30.583 10.38 30.8665 10.1473 31.1982 10.0099C31.5299 9.87251 31.8949 9.83656 32.247 9.90661C32.5991 9.97665 32.9226 10.1495 33.1765 10.4034C33.4303 10.6573 33.6032 10.9807 33.6733 11.3329C33.7433 11.685 33.7074 12.05 33.57 12.3817C33.4326 12.7134 33.1999 12.9969 32.9014 13.1964C32.6029 13.3959 32.2519 13.5023 31.8928 13.5023C31.7007 13.5027 31.5098 13.4721 31.3275 13.4116L29.4915 15.2476C30.0487 15.6255 30.6869 15.8674 31.3546 15.9537C32.0223 16.0401 32.701 15.9685 33.3361 15.7448C33.9711 15.521 34.5448 15.1514 35.0109 14.6655C35.477 14.1796 35.8226 13.5912 36.0199 12.9474C36.2171 12.3036 36.2605 11.6226 36.1466 10.959C36.0326 10.2954 35.7645 9.66779 35.3638 9.1267C34.9631 8.5856 34.441 8.14611 33.8395 7.84356C33.238 7.54102 32.5739 7.38387 31.9006 7.38477V7.38477Z"
				fill={props.forceColor ? props.color : "#34A853"}
			/>
			<path
				d="M30.1886 19.923C30.1915 18.4697 29.7208 17.055 28.8479 15.8931L26.4621 18.2763C26.8249 18.9399 26.9576 19.705 26.8393 20.452C26.7211 21.199 26.3586 21.8857 25.8086 22.4048L27.1052 25.5738C28.0507 24.9649 28.8284 24.1285 29.3671 23.1413C29.9057 22.1542 30.1882 21.0476 30.1886 19.923V19.923Z"
				fill={props.forceColor ? props.color : "#FBBC04"}
			/>
			<path
				d="M23.5212 23.3438H23.459C22.9255 23.3438 22.3995 23.2192 21.9227 22.9798C21.446 22.7405 21.0318 22.393 20.7132 21.9651C20.3946 21.5373 20.1804 21.0409 20.0877 20.5155C19.995 19.9902 20.0263 19.4505 20.1792 18.9394C20.3321 18.4283 20.6024 17.9601 20.9684 17.572C21.3344 17.1839 21.7861 16.8867 22.2873 16.7042C22.7886 16.5216 23.3256 16.4588 23.8554 16.5206C24.3853 16.5824 24.8934 16.7672 25.3391 17.0603L27.7016 14.6978C26.8655 14.0199 25.8789 13.5526 24.8248 13.3351C23.7706 13.1176 22.6797 13.1562 21.6435 13.4477C20.6074 13.7392 19.6563 14.275 18.8702 15.0103C18.0841 15.7455 17.4859 16.6587 17.1258 17.673C16.7658 18.6874 16.6544 19.7733 16.801 20.8397C16.9476 21.906 17.348 22.9216 17.9685 23.8011C18.589 24.6806 19.4114 25.3984 20.3668 25.8942C21.3222 26.39 22.3826 26.6492 23.459 26.6502C23.9153 26.6505 24.3705 26.6053 24.8179 26.5154L23.5212 23.3438Z"
				fill={props.forceColor ? props.color : "#EA4335"}
			/>
			<path
				d="M31.9912 26.0846C30.498 26.0831 29.0127 26.3007 27.5826 26.7304L29.4732 31.349C30.2961 31.1451 31.1408 31.0423 31.9886 31.043C34.371 31.0437 36.6794 31.8704 38.5206 33.3822C40.3618 34.894 41.6219 36.9975 42.0861 39.3342C42.5504 41.6709 42.1901 44.0962 41.0667 46.1971C39.9432 48.2979 38.1261 49.9442 35.925 50.8556C33.7238 51.7669 31.2747 51.8869 28.9951 51.195C26.7154 50.5032 24.7461 49.0423 23.4227 47.0613C22.0993 45.0803 21.5037 42.7018 21.7374 40.3309C21.971 37.96 23.0195 35.7435 24.7041 34.059C25.429 33.3364 26.2565 32.7247 27.1599 32.2437L25.2902 27.638C21.9236 29.2868 19.2813 32.1166 17.8668 35.5882C16.4523 39.0597 16.3646 42.9304 17.6202 46.4625C18.8759 49.9946 21.3873 52.9413 24.6757 54.741C27.9641 56.5406 31.7997 57.0675 35.4516 56.2212C39.1035 55.3749 42.3164 53.2145 44.478 50.1518C46.6395 47.0891 47.5987 43.3381 47.1727 39.6137C46.7467 35.8893 44.9653 32.4519 42.1679 29.9564C39.3706 27.4609 35.7529 26.0818 32.0042 26.082L31.9912 26.0846Z"
				fill={props.forceColor ? props.color : "#4285F4"}
			/>
		</g>
	);
}

function SquareStack(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15 9C11.6863 9 9 11.6863 9 15V39C9 42.3137 11.6863 45 15 45H19V49C19 52.3137 21.6863 55 25 55H49C52.3137 55 55 52.3137 55 49V25C55 21.6863 52.3137 19 49 19H45V15C45 11.6863 42.3137 9 39 9H15ZM41 19V15C41 13.8954 40.1046 13 39 13H15C13.8954 13 13 13.8954 13 15V39C13 40.1046 13.8954 41 15 41H19V25C19 21.6863 21.6863 19 25 19H41ZM25 23C23.8954 23 23 23.8954 23 25V49C23 50.1046 23.8954 51 25 51H49C50.1046 51 51 50.1046 51 49V25C51 23.8954 50.1046 23 49 23H25Z"
		/>
	);
}

function AIImage(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M33.5302 27.1828L32.7763 22.6595C32.7062 22.2308 32.3018 21.9402 31.8731 22.0103C31.5398 22.0649 31.2785 22.3262 31.2239 22.6595L30.4701 27.1828C30.1892 28.8685 28.8682 30.1895 27.1825 30.4704L22.6592 31.2241C22.2305 31.2945 21.9401 31.699 22.0105 32.1277C22.0652 32.4607 22.3262 32.7217 22.6592 32.7763L27.1825 33.5303C28.8682 33.8112 30.1891 35.1321 30.4701 36.8178L31.2239 41.3411C31.2941 41.7698 31.6985 42.0604 32.1272 41.9902C32.4605 41.9357 32.7218 41.6744 32.7763 41.3411L33.5302 36.8178C33.8111 35.1322 35.1319 33.8114 36.8174 33.5303L41.3408 32.7763C41.7695 32.7059 42.0599 32.3014 41.9895 31.8727C41.9348 31.5398 41.6738 31.2788 41.3408 31.2241L36.8174 30.4704C35.1318 30.1893 33.811 28.8684 33.5302 27.1828Z"
		/>
	);
}

function PlusLandscape(props) {
	return (
		<g>
			<path d="M30 24C30 22.8954 30.8954 22 32 22C33.1046 22 34 22.8954 34 24V30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H34V40C34 41.1046 33.1046 42 32 42C30.8954 42 30 41.1046 30 40V34H24C22.8954 34 22 33.1046 22 32C22 30.8954 22.8954 30 24 30H30V24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 22C8 17.5817 11.5817 14 16 14H48C52.4183 14 56 17.5817 56 22V42C56 46.4183 52.4183 50 48 50H16C11.5817 50 8 46.4183 8 42V22ZM12 22C12 19.7909 13.7909 18 16 18H48C50.2091 18 52 19.7909 52 22V42C52 44.2091 50.2091 46 48 46H16C13.7909 46 12 44.2091 12 42V22Z"
			/>
		</g>
	);
}

function Shapes(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M42 48V38C50.8366 38 58 30.8366 58 22C58 13.1634 50.8366 6 42 6C33.1634 6 26 13.1634 26 22H16C12.6863 22 10 24.6863 10 28V48C10 51.3137 12.6863 54 16 54H36C39.3137 54 42 51.3137 42 48ZM54 22C54 28.6274 48.6274 34 42 34V28C42 24.6863 39.3137 22 36 22H30C30 15.3726 35.3726 10 42 10C48.6274 10 54 15.3726 54 22ZM36 50C37.1046 50 38 49.1046 38 48V28C38 26.8954 37.1046 26 36 26H16C14.8954 26 14 26.8954 14 28V48C14 49.1046 14.8954 50 16 50H36Z"
		/>
	);
}

function Subtract(props) {
	return (
		<path d="M11.5 32C11.5 30.6193 12.6193 29.5 14 29.5H50C51.3807 29.5 52.5 30.6193 52.5 32C52.5 33.3807 51.3807 34.5 50 34.5H14C12.6193 34.5 11.5 33.3807 11.5 32Z" />
	);
}

function FitCanvasToContent(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M34.5 3.5V12.6588C43.2703 13.7812 50.2188 20.7297 51.3412 29.5H60.5V34.5H51.3412C50.2188 43.2703 43.2703 50.2188 34.5 51.3412V60.5H29.5V51.3412C20.7281 50.2186 13.7787 43.2678 12.6582 34.4953L3.49889 34.4912L3.50112 29.4912L12.6594 29.4953C13.7837 20.7272 20.7313 13.781 29.5 12.6588V3.5H34.5ZM32 17.5C23.9919 17.5 17.5 23.9919 17.5 32C17.5 40.0081 23.9919 46.5 32 46.5C40.0081 46.5 46.5 40.0081 46.5 32C46.5 23.9919 40.0081 17.5 32 17.5Z"
			/>
			<path d="M37 32C37 34.7614 34.7614 37 32 37C29.2386 37 27 34.7614 27 32C27 29.2386 29.2386 27 32 27C34.7614 27 37 29.2386 37 32Z" />
		</g>
	);
}

function ColorRing(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32 54C44.1503 54 54 44.1503 54 32C54 19.8497 44.1503 10 32 10C19.8497 10 10 19.8497 10 32C10 44.1503 19.8497 54 32 54ZM32 58C46.3594 58 58 46.3594 58 32C58 17.6406 46.3594 6 32 6C17.6406 6 6 17.6406 6 32C6 46.3594 17.6406 58 32 58Z"
				fill={props.selected ? props.color : "url(#pattern0)"}
			/>
			<circle cx="32" cy="32" r="16" fill={props.color} />
			<defs>
				<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
					<use xlinkHref="#image0" transform="scale(0.00217391)" />
				</pattern>
				<image id="image0" width="460" height="460" xlinkHref={gradient} />
			</defs>
		</g>
	);
}

function DoubleSparkle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M50.7763 6.6595L51.5301 11.1828C51.811 12.8684 53.1318 14.1893 54.8173 14.4704L59.3408 15.2241C59.6737 15.2788 59.9347 15.5398 59.9894 15.8728C60.0598 16.3014 59.7694 16.706 59.3408 16.7764L54.8173 17.5304C53.1318 17.8114 51.811 19.1323 51.5301 20.8178L50.7763 25.3411C50.7217 25.6745 50.4604 25.9357 50.1271 25.9903C49.6985 26.0605 49.2941 25.7698 49.2239 25.3411L48.47 20.8178C48.1891 19.1322 46.8681 17.8113 45.1825 17.5304L40.6591 16.7764C40.3261 16.7217 40.0651 16.4607 40.0105 16.1277C39.9401 15.6991 40.2305 15.2945 40.6591 15.2241L45.1825 14.4704C46.8682 14.1895 48.1891 12.8685 48.47 11.1828L49.2239 6.6595C49.2784 6.32619 49.5397 6.06493 49.873 6.01037C50.3017 5.94019 50.7061 6.23082 50.7763 6.6595ZM29.5533 19.319L31.061 28.3654C31.6226 31.7364 34.2641 34.3781 37.635 34.9402L46.6816 36.4476C47.3476 36.557 47.8695 37.079 47.9789 37.7449C48.1197 38.6021 47.5389 39.4112 46.6816 39.552L37.635 41.06C34.2642 41.622 31.6227 44.2636 31.061 47.6346L29.5533 56.6809C29.4442 57.3475 28.9217 57.87 28.2551 57.9791C27.3978 58.1194 26.589 57.5382 26.4486 56.6809L24.941 47.6346C24.3791 44.2634 21.7373 41.6217 18.3661 41.06L9.31978 39.552C8.65385 39.4426 8.13187 38.9207 8.0225 38.2548C7.88171 37.3975 8.46252 36.5884 9.31978 36.4476L18.3661 34.9402C21.7374 34.3784 24.3792 31.7366 24.941 28.3654L26.4486 19.319C26.5578 18.6524 27.0803 18.1299 27.7468 18.0208C28.6042 17.8805 29.413 18.4617 29.5533 19.319Z"
		/>
	);
}

function SlowAnimation(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M44 18C36.268 18 30 24.268 30 32C30 39.732 36.268 46 44 46C51.732 46 58 39.732 58 32C58 24.268 51.732 18 44 18ZM26 32C26 22.0589 34.0589 14 44 14C53.9411 14 62 22.0589 62 32C62 41.9411 53.9411 50 44 50C34.0589 50 26 41.9411 26 32Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.7495 46.4399C25.2827 47.441 24.0927 47.8741 23.0916 47.4073C20.1679 46.0439 17.6925 43.8769 15.9544 41.1592C14.2164 38.4414 13.2875 35.2853 13.2762 32.0594C13.265 28.8335 14.1718 25.6709 15.8908 22.9412C17.6099 20.2114 20.0701 18.0271 22.9842 16.6434C23.982 16.1696 25.175 16.5944 25.6488 17.5922C26.1226 18.5899 25.6978 19.7829 24.7 20.2567C22.4715 21.3148 20.5902 22.9852 19.2756 25.0727C17.9611 27.1601 17.2676 29.5785 17.2762 32.0454C17.2848 34.5123 17.9951 36.9258 19.3242 39.0041C20.6533 41.0823 22.5463 42.7395 24.7821 43.7821C25.7832 44.2489 26.2163 45.4388 25.7495 46.4399Z"
				opacity={0.75}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.74582 43.2935C8.93799 44.0468 7.67243 44.0026 6.91912 43.1948C5.44898 41.6183 4.30377 39.7676 3.54885 37.7485C2.79394 35.7294 2.44411 33.5814 2.51934 31.427C2.59457 29.2727 3.09339 27.1543 3.98731 25.1928C4.88123 23.2313 6.15275 21.465 7.72928 19.9949C8.53711 19.2416 9.80267 19.2858 10.556 20.0936C11.3093 20.9014 11.2651 22.167 10.4573 22.9203C9.26492 24.0322 8.30324 25.368 7.62715 26.8516C6.95106 28.3351 6.5738 29.9373 6.5169 31.5666C6.46 33.196 6.72459 34.8206 7.29554 36.3477C7.8665 37.8748 8.73264 39.2744 9.84453 40.4668C10.5978 41.2746 10.5537 42.5402 9.74582 43.2935Z"
				opacity={0.5}
			/>
		</g>
	);
}

function Draggable(props) {
	return (
		<g>
			{/* <circle cx="21" cy="23" r="4" />
			<circle cx="42.8181" cy="23" r="4" />
			<circle cx="21" cy="41.9091" r="4" />
			<circle cx="42.8181" cy="41.9091" r="4" /> */}
			<path d="M15.2731 27.6365C17.2814 27.6365 18.9094 26.0084 18.9094 24.0001C18.9094 21.9918 17.2814 20.3638 15.2731 20.3638C13.2648 20.3638 11.6367 21.9918 11.6367 24.0001C11.6367 26.0084 13.2648 27.6365 15.2731 27.6365Z" />
			<path d="M31.2731 27.6365C33.2814 27.6365 34.9094 26.0084 34.9094 24.0001C34.9094 21.9918 33.2814 20.3638 31.2731 20.3638C29.2648 20.3638 27.6367 21.9918 27.6367 24.0001C27.6367 26.0084 29.2648 27.6365 31.2731 27.6365Z" />
			<path d="M50.9094 24.0001C50.9094 26.0084 49.2814 27.6365 47.2731 27.6365C45.2648 27.6365 43.6367 26.0084 43.6367 24.0001C43.6367 21.9918 45.2648 20.3638 47.2731 20.3638C49.2814 20.3638 50.9094 21.9918 50.9094 24.0001Z" />
			<path d="M15.2731 43.6365C17.2814 43.6365 18.9094 42.0084 18.9094 40.0001C18.9094 37.9918 17.2814 36.3638 15.2731 36.3638C13.2648 36.3638 11.6367 37.9918 11.6367 40.0001C11.6367 42.0084 13.2648 43.6365 15.2731 43.6365Z" />
			<path d="M34.9094 40.0001C34.9094 42.0084 33.2814 43.6365 31.2731 43.6365C29.2648 43.6365 27.6367 42.0084 27.6367 40.0001C27.6367 37.9918 29.2648 36.3638 31.2731 36.3638C33.2814 36.3638 34.9094 37.9918 34.9094 40.0001Z" />
			<path d="M47.2731 43.6365C49.2814 43.6365 50.9094 42.0084 50.9094 40.0001C50.9094 37.9918 49.2814 36.3638 47.2731 36.3638C45.2648 36.3638 43.6367 37.9918 43.6367 40.0001C43.6367 42.0084 45.2648 43.6365 47.2731 43.6365Z" />
		</g>
	);
}

function Upload(props) {
	return (
		<g>
			<path d="M34 52C34 53.1046 33.1046 54 32 54C30.8954 54 30 53.1046 30 52V28.8284L23.4142 35.4142C22.6332 36.1953 21.3668 36.1953 20.5858 35.4142C19.8047 34.6332 19.8047 33.3668 20.5858 32.5858L30.5858 22.5858C31.3668 21.8047 32.6332 21.8047 33.4142 22.5858L43.4142 32.5858C44.1953 33.3668 44.1953 34.6332 43.4142 35.4142C42.6332 36.1953 41.3668 36.1953 40.5858 35.4142L34 28.8284V52Z" />
			<path d="M14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10H50C51.1046 10 52 10.8954 52 12C52 13.1046 51.1046 14 50 14H14Z" />
		</g>
	);
}

function Info(props) {
	return (
		<g>
			<path d="M34 22C34 23.6569 32.6569 25 31 25C29.3431 25 28 23.6569 28 22C28 20.3431 29.3431 19 31 19C32.6569 19 34 20.3431 34 22Z" />
			<path d="M26 30C26 28.8954 26.8954 28 28 28H32C33.1046 28 34 28.8954 34 30V39.5C34 39.7761 34.2239 40 34.5 40H37C38.1046 40 39 40.8954 39 42C39 43.1046 38.1046 44 37 44H27C25.8954 44 25 43.1046 25 42C25 40.8954 25.8954 40 27 40H29.5C29.7761 40 30 39.7761 30 39.5V32.5C30 32.2239 29.7761 32 29.5 32H28C26.8954 32 26 31.1046 26 30Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM52 32C52 43.0457 43.0457 52 32 52C20.9543 52 12 43.0457 12 32C12 20.9543 20.9543 12 32 12C43.0457 12 52 20.9543 52 32Z"
			/>
		</g>
	);
}

function Retake(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 12C16 10.8954 15.1046 10 14 10C12.8954 10 12 10.8954 12 12V22C12 23.1046 12.8954 24 14 24H24C25.1046 24 26 23.1046 26 22C26 20.8954 25.1046 20 24 20H18.5836C20.7681 17.5575 23.5854 15.7502 26.7373 14.7865C30.3725 13.6751 34.2661 13.7431 37.8603 14.9807C41.4544 16.2182 44.5645 18.5618 46.7448 21.6756C48.9251 24.7894 50.0636 28.5135 49.9973 32.3142C49.9309 36.1148 48.6631 39.7969 46.3755 42.8327C44.0878 45.8685 40.8978 48.1021 37.2627 49.2135C33.6276 50.3249 29.7339 50.2569 26.1398 49.0193C23.1785 47.9997 20.5458 46.2292 18.491 43.8957C17.7611 43.0667 16.5218 42.838 15.617 43.4715C14.7122 44.1051 14.4856 45.3591 15.1987 46.2027C17.7503 49.2212 21.0771 51.5066 24.8375 52.8014C29.2303 54.314 33.9892 54.397 38.4322 53.0387C42.8751 51.6804 46.774 48.9504 49.57 45.2399C52.366 41.5295 53.9156 37.0292 53.9967 32.384C54.0778 27.7387 52.6862 23.1871 50.0214 19.3813C47.3566 15.5756 43.5554 12.7112 39.1625 11.1986C34.7697 9.68602 30.0108 9.60295 25.5678 10.9613C21.9042 12.0814 18.6104 14.1342 16 16.9003V12ZM16 19.9431V20H16.0755L16 19.9431Z"
		/>
	);
}

function Warning(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M55.0064 52.0079H9.02337C7.36602 52.0069 6.02328 50.6625 6.02429 49.0052C6.02462 48.458 6.17456 47.9213 6.45788 47.4532L29.4494 9.4424C30.3058 8.02554 32.1487 7.57122 33.5655 8.42765C33.9809 8.67875 34.3292 9.02698 34.5803 9.4424L57.5719 47.4532H57.5719C58.43 48.8711 57.9763 50.7162 56.5584 51.5743C56.0902 51.8576 55.5536 52.0076 55.0064 52.0079L55.0064 52.0079ZM32.0148 48.0207C33.6716 48.0207 35.0148 46.6775 35.0148 45.0207C35.0148 43.3638 33.6716 42.0207 32.0148 42.0207C30.3579 42.0207 29.0148 43.3638 29.0148 45.0207C29.0148 46.6775 30.3579 48.0207 32.0148 48.0207ZM34.0133 20.0207H30.0344H30.0344C29.4766 20.0142 29.0192 20.4611 29.0126 21.0188C29.0124 21.037 29.0127 21.0552 29.0135 21.0733L29.9282 38.0733C29.9628 38.6102 30.4112 39.0262 30.9492 39.0207H33.0985C33.6364 39.0261 34.0848 38.6101 34.1196 38.0733L35.0343 21.0733C35.0578 20.516 34.6251 20.0451 34.0677 20.0216C34.0496 20.0209 34.0314 20.0206 34.0133 20.0208V20.0207Z"
		/>
	);
}

function Report(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0208 56.021H32.0208C18.766 56.021 8.02081 45.2758 8.02081 32.021C8.02081 18.7662 18.766 8.021 32.0208 8.021C45.2756 8.021 56.0208 18.7662 56.0208 32.021V32.021C56.0208 45.2758 45.2756 56.021 32.0208 56.021H32.0208ZM32.0208 12.021H32.0208C20.9751 12.021 12.0208 20.9753 12.0208 32.021C12.0208 43.0667 20.9751 52.021 32.0208 52.021C43.0665 52.021 52.0208 43.0667 52.0208 32.021V32.0211C52.0208 20.9754 43.0666 12.0212 32.0209 12.0211L32.0208 12.021ZM33.0985 37.021H30.9492C30.4113 37.0265 29.9629 36.6105 29.9281 36.0736L29.0135 19.0736V19.0736C28.99 18.5163 29.4226 18.0454 29.9799 18.0218C29.9981 18.0211 30.0162 18.0208 30.0343 18.021H34.0134C34.5712 18.0145 35.0286 18.4614 35.0351 19.0191C35.0354 19.0373 35.0351 19.0554 35.0343 19.0736L34.1196 36.0736C34.0848 36.6104 33.6364 37.0264 33.0985 37.021V37.021ZM32.0148 40.021C33.6717 40.021 35.0148 41.3641 35.0148 43.021C35.0148 44.6778 33.6717 46.021 32.0148 46.021C30.358 46.021 29.0148 44.6778 29.0148 43.021C29.0148 41.3641 30.358 40.021 32.0148 40.021Z"
		/>
	);
}

function TwoArrowCirclePathCounterclockwise(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.3874 28.7406C8.36474 29.2899 8.7917 29.7536 9.34103 29.7763C9.46128 29.7812 9.58142 29.7643 9.69564 29.7264L21.2798 25.9666C21.8206 25.7953 22.1201 25.2179 21.9488 24.677C21.8862 24.4795 21.7653 24.3055 21.602 24.1779L17.622 21.1787C23.6108 13.2426 34.8989 11.6645 42.835 17.6533C46.1357 20.1442 48.4783 23.6954 49.469 27.71C49.7113 28.788 50.7817 29.4653 51.8596 29.223C52.9375 28.9806 53.6149 27.9103 53.3725 26.8323C50.5055 15.0237 38.6085 7.7751 26.7998 10.6421C21.8605 11.8414 17.4886 14.7137 14.4272 18.7712L10.4392 15.766C9.98008 15.4326 9.3376 15.5345 9.00421 15.9937C8.8825 16.1613 8.81429 16.3618 8.80853 16.5688L8.3874 28.7406ZM54.2882 34.3152L42.7041 38.075C42.1632 38.2463 41.8637 38.8236 42.035 39.3645C42.0976 39.5619 42.2184 39.7359 42.3816 39.8635L46.3612 42.8623C40.3724 50.7983 29.084 52.3771 21.148 46.3884C17.8471 43.8973 15.5044 40.3458 14.5139 36.3307C14.2714 35.2528 13.2009 34.5756 12.1231 34.8182C11.0452 35.0607 10.368 36.1312 10.6105 37.209C13.4775 49.0175 25.3743 56.2661 37.1828 53.3992C42.1222 52.1999 46.4941 49.3275 49.5555 45.2699L53.5445 48.2758C54.0036 48.6092 54.6461 48.5072 54.9795 48.0481C55.1011 47.8805 55.1693 47.6801 55.1751 47.4731L55.5962 35.3014C55.619 34.7521 55.1921 34.2883 54.6428 34.2655C54.5225 34.2606 54.4024 34.2773 54.2882 34.3152Z"
		/>
	);
}

function TomeLogo(props) {
	return (
		<path d="M56.8661 29.9812L52.4396 14.161C52.2661 13.5408 51.9357 12.9759 51.4803 12.5206C51.0249 12.0653 50.4599 11.7351 49.8398 11.5616L34.0193 7.13445C32.6981 6.76475 31.3008 6.76475 29.9796 7.13445L14.1604 11.561C13.5404 11.7345 12.9756 12.0648 12.5203 12.5201C12.065 12.9754 11.7347 13.5403 11.5612 14.1603L7.13477 29.9819C6.76497 31.3027 6.76497 32.6997 7.13477 34.0205L11.5593 49.8414C11.7327 50.4615 12.063 51.0265 12.5183 51.4819C12.9736 51.9373 13.5385 52.2677 14.1586 52.4413L29.9796 56.866C31.3009 57.2352 32.6981 57.2352 34.0193 56.866L49.8416 52.4388C50.4617 52.2652 51.0267 51.9348 51.4819 51.4794C51.9372 51.024 52.2675 50.459 52.4409 49.8389L56.8661 34.0186C57.2355 32.6982 57.2355 31.3017 56.8661 29.9812ZM50.7443 34.8282L34.827 50.744C34.0773 51.4936 33.0606 51.9147 32.0004 51.9147C30.9403 51.9147 29.9235 51.4936 29.1738 50.744L13.2578 34.8282C12.8866 34.4569 12.5921 34.0162 12.3912 33.5311C12.1902 33.0461 12.0868 32.5262 12.0868 32.0012C12.0868 31.4761 12.1902 30.9562 12.3912 30.4712C12.5921 29.9861 12.8866 29.5454 13.2578 29.1741L29.1738 13.2577C29.9235 12.5081 30.9403 12.087 32.0004 12.087C33.0606 12.087 34.0773 12.5081 34.827 13.2577L50.743 29.1741C51.1143 29.5454 51.4088 29.9861 51.6097 30.4712C51.8106 30.9562 51.914 31.4761 51.914 32.0012C51.914 32.5262 51.8106 33.0461 51.6097 33.5311C51.4088 34.0162 51.1143 34.4569 50.743 34.8282H50.7443Z" />
	);
}

function Doc(props) {
	return (
		<g>
			<path d="M24 20C22.8954 20 22 20.8954 22 22C22 23.1046 22.8954 24 24 24H40C41.1046 24 42 23.1046 42 22C42 20.8954 41.1046 20 40 20H24Z" />
			<path d="M22 30C22 28.8954 22.8954 28 24 28H40C41.1046 28 42 28.8954 42 30C42 31.1046 41.1046 32 40 32H24C22.8954 32 22 31.1046 22 30Z" />
			<path d="M24 36C22.8954 36 22 36.8954 22 38C22 39.1046 22.8954 40 24 40H32C33.1046 40 34 39.1046 34 38C34 36.8954 33.1046 36 32 36H24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 8C17.5817 8 14 11.5817 14 16V48C14 52.4183 17.5817 56 22 56H42C46.4183 56 50 52.4183 50 48V16C50 11.5817 46.4183 8 42 8H22ZM22 12C19.7909 12 18 13.7909 18 16V48C18 50.2091 19.7909 52 22 52H42C44.2091 52 46 50.2091 46 48V16C46 13.7909 44.2091 12 42 12H22Z"
			/>
		</g>
	);
}

function OutlineAlt(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 10C12.6863 10 10 12.6863 10 16V48C10 51.3137 12.6863 54 16 54H32C35.3137 54 38 51.3137 38 48V16C38 12.6863 35.3137 10 32 10H16ZM16 14C14.8954 14 14 14.8954 14 16V48C14 49.1046 14.8954 50 16 50H32C33.1046 50 34 49.1046 34 48V16C34 14.8954 33.1046 14 32 14H16Z"
			/>
			<path d="M42 17C42 16.4477 42.4477 16 43 16C44.6569 16 46 17.3431 46 19V45C46 46.6569 44.6569 48 43 48C42.4477 48 42 47.5523 42 47V17Z" />
			<path d="M51 22C50.4477 22 50 22.4477 50 23V41C50 41.5523 50.4477 42 51 42C52.6569 42 54 40.6569 54 39V25C54 23.3431 52.6569 22 51 22Z" />
		</g>
	);
}

function Page(props) {
	return (
		<g>
			<path d="M24 16C22.8954 16 22 16.8954 22 18C22 19.1046 22.8954 20 24 20H40C41.1046 20 42 19.1046 42 18C42 16.8954 41.1046 16 40 16H24Z" />
			<path d="M22 26C22 24.8954 22.8954 24 24 24H32C33.1046 24 34 24.8954 34 26C34 27.1046 33.1046 28 32 28H24C22.8954 28 22 27.1046 22 26Z" />
			<path d="M24 34C22.8954 34 22 34.8954 22 36V46C22 47.1046 22.8954 48 24 48H40C41.1046 48 42 47.1046 42 46V36C42 34.8954 41.1046 34 40 34H24Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 8C17.5817 8 14 11.5817 14 16V48C14 52.4183 17.5817 56 22 56H42C46.4183 56 50 52.4183 50 48V16C50 11.5817 46.4183 8 42 8H22ZM22 12C19.7909 12 18 13.7909 18 16V48C18 50.2091 19.7909 52 22 52H42C44.2091 52 46 50.2091 46 48V16C46 13.7909 44.2091 12 42 12H22Z"
			/>
		</g>
	);
}

function MultiplePagesLandscape(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 17C9.58172 17 6 20.5817 6 25V39C6 43.4183 9.58172 47 14 47H38C42.4183 47 46 43.4183 46 39V25C46 20.5817 42.4183 17 38 17H14ZM38 21H14C11.7909 21 10 22.7909 10 25V39C10 41.2091 11.7909 43 14 43H38C40.2091 43 42 41.2091 42 39V25C42 22.7909 40.2091 21 38 21Z"
			/>
			<path d="M50 23C50 22.4477 50.4477 22 51 22C52.6569 22 54 23.3431 54 25V39C54 40.6569 52.6569 42 51 42C50.4477 42 50 41.5523 50 41V23Z" />
			<path d="M59 26C58.4477 26 58 26.4477 58 27V37C58 37.5523 58.4477 38 59 38C60.6569 38 62 36.6569 62 35V29C62 27.3431 60.6569 26 59 26Z" />
		</g>
	);
}

function PageLandscape(props) {
	return (
		<g>
			<path d="M18 26C16.8954 26 16 26.8954 16 28C16 29.1046 16.8954 30 18 30H30C31.1046 30 32 29.1046 32 28C32 26.8954 31.1046 26 30 26H18Z" />
			<path d="M16 36C16 34.8954 16.8954 34 18 34H26C27.1046 34 28 34.8954 28 36C28 37.1046 27.1046 38 26 38H18C16.8954 38 16 37.1046 16 36Z" />
			<path d="M38 24C36.8954 24 36 24.8954 36 26V38C36 39.1046 36.8954 40 38 40H46C47.1046 40 48 39.1046 48 38V26C48 24.8954 47.1046 24 46 24H38Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 50C11.5817 50 8 46.4183 8 42V22C8 17.5817 11.5817 14 16 14H48C52.4183 14 56 17.5817 56 22V42C56 46.4183 52.4183 50 48 50H16ZM16 46C13.7909 46 12 44.2091 12 42V22C12 19.7909 13.7909 18 16 18H48C50.2091 18 52 19.7909 52 22V42C52 44.2091 50.2091 46 48 46H16Z"
			/>
		</g>
	);
}

function PagesStacked(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 13C10.6863 13 8 15.6863 8 19V35C8 38.3137 10.6863 41 14 41H18V45C18 48.3137 20.6863 51 24 51H50C53.3137 51 56 48.3137 56 45V29C56 25.6863 53.3137 23 50 23H46V19C46 15.6863 43.3137 13 40 13H14ZM42 23V19C42 17.8954 41.1046 17 40 17H14C12.8954 17 12 17.8954 12 19V35C12 36.1046 12.8954 37 14 37H18V29C18 25.6863 20.6863 23 24 23H42ZM24 27C22.8954 27 22 27.8954 22 29V45C22 46.1046 22.8954 47 24 47H50C51.1046 47 52 46.1046 52 45V29C52 27.8954 51.1046 27 50 27H24Z"
			/>
		</g>
	);
}

function BigText(props) {
	return (
		<path d="M22.8146 46L25.7521 37.5312H38.2521L41.174 46H46.299L34.7833 14H29.2052L17.6896 46H22.8146ZM27.1583 33.4688L31.8771 19.8125H32.1271L36.8458 33.4688H27.1583Z" />
	);
}

function Clock(props) {
	return (
		<g>
			<path d="M34 20C34 18.8954 33.1046 18 32 18C30.8954 18 30 18.8954 30 20V32C30 32.5304 30.2107 33.0391 30.5858 33.4142L39.0858 41.9142C39.8668 42.6953 41.1332 42.6953 41.9142 41.9142C42.6953 41.1332 42.6953 39.8668 41.9142 39.0858L34 31.1716V20Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM52 32C52 43.0457 43.0457 52 32 52C20.9543 52 12 43.0457 12 32C12 20.9543 20.9543 12 32 12C43.0457 12 52 20.9543 52 32Z"
			/>
		</g>
	);
}

function AddTableRow(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 20C4 15.5817 7.58172 12 12 12H44C48.4183 12 52 15.5817 52 20V32C52 33.1046 51.1046 34 50 34H8V44C8 46.2091 9.79086 48 12 48H32C33.1046 48 34 48.8954 34 50C34 51.1046 33.1046 52 32 52H12C7.58172 52 4 48.4183 4 44V20ZM48 20V30H8V20C8 17.7909 9.79086 16 12 16H44C46.2091 16 48 17.7909 48 20ZM48 42C48 40.8954 48.8954 40 50 40C51.1046 40 52 40.8954 52 42V48H58C59.1046 48 60 48.8954 60 50C60 51.1046 59.1046 52 58 52H52V58C52 59.1046 51.1046 60 50 60C48.8954 60 48 59.1046 48 58V52H42C40.8954 52 40 51.1046 40 50C40 48.8954 40.8954 48 42 48H48V42Z"
		/>
	);
}

function AddTableColumn(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 20C4 15.5817 7.58172 12 12 12H44C48.4183 12 52 15.5817 52 20V32C52 33.1046 51.1046 34 50 34C48.8954 34 48 33.1046 48 32V20C48 17.7909 46.2091 16 44 16H30V50C30 51.1046 29.1046 52 28 52H12C7.58172 52 4 48.4183 4 44V20ZM12 16H26V48H12C9.79086 48 8 46.2091 8 44V20C8 17.7909 9.79086 16 12 16ZM48 42C48 40.8954 48.8954 40 50 40C51.1046 40 52 40.8954 52 42V48H58C59.1046 48 60 48.8954 60 50C60 51.1046 59.1046 52 58 52H52V58C52 59.1046 51.1046 60 50 60C48.8954 60 48 59.1046 48 58V52H42C40.8954 52 40 51.1046 40 50C40 48.8954 40.8954 48 42 48H48V42Z"
		/>
	);
}

function RemoveTableColumn(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 12C7.58172 12 4 15.5817 4 20V44C4 48.4183 7.58172 52 12 52H28C29.1046 52 30 51.1046 30 50V16H44C46.2091 16 48 17.7909 48 20V32C48 33.1046 48.8954 34 50 34C51.1046 34 52 33.1046 52 32V20C52 15.5817 48.4183 12 44 12H12ZM26 16H12C9.79086 16 8 17.7909 8 20V44C8 46.2091 9.79086 48 12 48H26V16Z"
			/>
			<path d="M42.9289 45.7574C42.1479 44.9763 42.1479 43.71 42.9289 42.9289C43.71 42.1479 44.9763 42.1479 45.7574 42.9289L50 47.1716L54.2426 42.9289C55.0237 42.1479 56.29 42.1479 57.0711 42.9289C57.8521 43.71 57.8521 44.9763 57.0711 45.7574L52.8284 50L57.0711 54.2426C57.8521 55.0237 57.8521 56.29 57.0711 57.0711C56.29 57.8521 55.0237 57.8521 54.2426 57.0711L50 52.8284L45.7574 57.0711C44.9763 57.8521 43.71 57.8521 42.9289 57.0711C42.1479 56.29 42.1479 55.0237 42.9289 54.2426L47.1716 50L42.9289 45.7574Z" />
		</g>
	);
}

function RemoveTableRow(props) {
	return (
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 12C7.58172 12 4 15.5817 4 20V44C4 48.4183 7.58172 52 12 52H32C33.1046 52 34 51.1046 34 50C34 48.8954 33.1046 48 32 48H12C9.79086 48 8 46.2091 8 44V34H50C51.1046 34 52 33.1046 52 32V20C52 15.5817 48.4183 12 44 12H12ZM48 30V20C48 17.7909 46.2091 16 44 16H12C9.79086 16 8 17.7909 8 20V30H48Z"
			/>
			<path d="M42.9286 45.7574C42.1475 44.9763 42.1475 43.71 42.9286 42.9289C43.7096 42.1479 44.9759 42.1479 45.757 42.9289L49.9996 47.1716L54.2423 42.9289C55.0233 42.1479 56.2896 42.1479 57.0707 42.9289C57.8517 43.71 57.8517 44.9763 57.0707 45.7574L52.8281 50L57.0707 54.2426C57.8517 55.0237 57.8517 56.29 57.0707 57.0711C56.2896 57.8521 55.0233 57.8521 54.2423 57.0711L49.9996 52.8284L45.757 57.0711C44.9759 57.8521 43.7096 57.8521 42.9286 57.0711C42.1475 56.29 42.1475 55.0237 42.9286 54.2426L47.1712 50L42.9286 45.7574Z" />
		</g>
	);
}

function WrapText(props) {
	return (
		<g>
			<path d="M12 14C10.8954 14 10 14.8954 10 16V48C10 49.1046 10.8954 50 12 50C13.1046 50 14 49.1046 14 48V16C14 14.8954 13.1046 14 12 14Z" />
			<path d="M52 14C50.8954 14 50 14.8954 50 16V48C50 49.1046 50.8954 50 52 50C53.1046 50 54 49.1046 54 48V16C54 14.8954 53.1046 14 52 14Z" />
			<path d="M22 22C22 20.8954 22.8954 20 24 20H40C41.1046 20 42 20.8954 42 22C42 23.1046 41.1046 24 40 24H24C22.8954 24 22 23.1046 22 22Z" />
			<path d="M22 32C22 30.8954 22.8954 30 24 30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H24C22.8954 34 22 33.1046 22 32Z" />
			<path d="M24 40C22.8954 40 22 40.8954 22 42C22 43.1046 22.8954 44 24 44H32C33.1046 44 34 43.1046 34 42C34 40.8954 33.1046 40 32 40H24Z" />
		</g>
	);
}

function UnwrapText(props) {
	return (
		<g>
			<path d="M14 14C12.8954 14 12 14.8954 12 16V48C12 49.1046 12.8954 50 14 50C15.1046 50 16 49.1046 16 48V16C16 14.8954 15.1046 14 14 14Z" />
			<path d="M50 14C48.8954 14 48 14.8954 48 16V30H28C26.8954 30 26 30.8954 26 32C26 33.1046 26.8954 34 28 34H48V48C48 49.1046 48.8954 50 50 50C51.1046 50 52 49.1046 52 48V16C52 14.8954 51.1046 14 50 14Z" />
		</g>
	);
}

function LineChart(props) {
	return (
		<path d="M14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12V50C10 52.2091 11.7909 54 14 54H52C53.1046 54 54 53.1046 54 52C54 50.8954 53.1046 50 52 50H14V36.1541L22.645 39.6121C23.7592 40.0578 25.0319 39.7965 25.8805 38.948L34.4817 30.3467L42.5039 33.5556C43.8211 34.0825 45.3272 33.6147 46.1142 32.4343L53.6641 21.1094C54.2768 20.1903 54.0285 18.9486 53.1094 18.3359C52.1903 17.7232 50.9486 17.9715 50.3359 18.8906L43.2361 29.5404L35.355 26.3879C34.2408 25.9422 32.9681 26.2035 32.1195 27.052L23.5183 35.6533L14 31.8459V12Z" />
	);
}

function ChartLine(props) {
	return (
		<g>
			<path d="M14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12V50C10 52.2091 11.7909 54 14 54H52C53.1046 54 54 53.1046 54 52C54 50.8954 53.1046 50 52 50H14V12Z" />
			<path d="M53.5726 19.2356C54.2551 18.3671 54.1042 17.1098 53.2356 16.4274C52.3671 15.7449 51.1098 15.8958 50.4274 16.7644L40.4353 29.4816L33.1202 25.824C31.6426 25.0853 29.863 25.3308 28.6406 26.442L18.6547 35.5201C17.8373 36.2631 17.7771 37.528 18.5201 38.3453C19.2631 39.1627 20.528 39.2229 21.3453 38.4799L31.3313 29.4017L38.6464 33.0593C40.3452 33.9087 42.4071 33.4463 43.5805 31.9529L53.5726 19.2356Z" />
		</g>
	);
}

function SpacingHorizontal(props) {
	return (
		<g>
			<path d="M54.4001 14.3999C55.2837 14.3999 56 15.1162 56 15.9999V47.9999C56 48.8836 55.2837 49.5999 54.4 49.5999C53.5164 49.5999 52.8 48.8836 52.8 47.9999V15.9999C52.8 15.1162 53.5164 14.3999 54.4001 14.3999Z" />
			<path d="M9.6 14.3999C10.4837 14.3999 11.2 15.1162 11.2 15.9999V47.9999C11.2 48.8836 10.4837 49.5999 9.6 49.5999C8.71634 49.5999 8 48.8836 8 47.9999V15.9999C8 15.1162 8.71635 14.3999 9.6 14.3999Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M27.2004 21.6003C24.1076 21.6003 21.6004 24.1075 21.6004 27.2003V36.8003C21.6004 39.8931 24.1076 42.4003 27.2004 42.4003H36.8004C39.8932 42.4003 42.4004 39.8931 42.4004 36.8003V27.2003C42.4004 24.1075 39.8932 21.6003 36.8004 21.6003H27.2004ZM26.4004 27.2003C26.4004 26.7585 26.7586 26.4003 27.2004 26.4003H36.8004C37.2422 26.4003 37.6004 26.7585 37.6004 27.2003V36.8003C37.6004 37.2422 37.2422 37.6003 36.8004 37.6003H27.2004C26.7586 37.6003 26.4004 37.2422 26.4004 36.8003V27.2003Z"
			/>
		</g>
	);
}

function PersonMasculine(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M41.4891 38H40.3941V38C39.8805 38.0001 39.4504 37.611 39.399 37.1L38.3126 26.2352L37.6937 30.5678V30.5678C37.5576 31.5206 37.5077 32.4837 37.5447 33.4454L38.4492 56.9616V56.9616C38.4704 57.5135 38.0402 57.978 37.4883 57.9993C37.4756 57.9998 37.4628 58 37.45 58H35.3942V58C34.8804 58 34.4502 57.6107 34.3991 57.0995L32.5 38L30.601 57.1V57.1C30.5496 57.611 30.1196 58 29.606 58H27.55V58C26.9977 58 26.55 57.5523 26.55 57C26.55 56.9872 26.5502 56.9744 26.5507 56.9616L27.4552 33.4454V33.4454C27.4922 32.4837 27.4423 31.5206 27.3062 30.5678L26.6873 26.2352L25.6012 37.1V37.1C25.5498 37.6111 25.1196 38.0001 24.606 38H23.5113V38C22.959 38 22.5113 37.5523 22.5113 37V23V23C22.5113 20.2386 24.7499 18 27.5113 18H37.4891H37.4891C40.2505 18 42.4891 20.2386 42.4891 23V37V37C42.4891 37.5523 42.0414 38 41.4891 38L41.4891 38ZM32.5 16V16C29.7386 16 27.5 13.7614 27.5 11C27.5 8.23858 29.7386 6 32.5 6C35.2614 6 37.5 8.23858 37.5 11V11C37.5 13.7614 35.2614 16 32.5 16V16Z"
		/>
	);
}

function PersonFeminine(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M43.4851 36H42.5672V36C42.0447 36.0029 41.573 35.6872 41.3765 35.203L37.8413 26.3075L36.5279 29.521V29.521C36.4277 29.8153 36.4729 30.1397 36.6498 30.3954V30.3954C39.1163 34.1216 40.4524 38.4817 40.497 42.95V42.95C40.517 43.5096 40.0795 43.9794 39.5199 43.9994C39.5108 43.9997 39.5018 43.9999 39.4927 44H35.5615L34.6071 57.0713V57.0713C34.5631 57.6001 34.1184 58.0052 33.5878 58H31.4123V58C30.8818 58.0051 30.4372 57.5999 30.3931 57.0712L29.4389 44H25.5075V44C24.9477 43.9951 24.4978 43.5373 24.5027 42.9775C24.5028 42.9683 24.503 42.9592 24.5033 42.95V42.9501C24.5478 38.4818 25.8836 34.1217 28.35 30.3955V30.3955C28.5269 30.1398 28.5722 29.8154 28.4721 29.5211L27.1585 26.3076L23.6236 35.203H23.6236C23.4273 35.6871 22.9559 36.0027 22.4336 36H21.515V36C20.9596 36.0079 20.5029 35.564 20.4951 35.0086C20.494 34.9328 20.5015 34.8571 20.5174 34.783L23.2619 22.6983V22.6983C23.9174 19.9279 26.4009 17.9786 29.2477 18H35.7524V18C38.5992 17.9785 41.0828 19.928 41.7382 22.6984L44.483 34.783V34.783C44.5996 35.3262 44.2537 35.8611 43.7105 35.9777C43.6365 35.9936 43.5608 36.0011 43.4851 36L43.4851 36ZM32.5 16V16C29.7386 16 27.5 13.7614 27.5 11C27.5 8.23858 29.7386 6 32.5 6C35.2614 6 37.5 8.23858 37.5 11V11C37.5 13.7614 35.2614 16 32.5 16V16Z"
		/>
	);
}

function Child(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29.047 24.0243V24.0243C28.0619 24.0241 27.1118 23.6586 26.3806 22.9984L18.0457 15.3891V15.3891C17.4553 14.8558 16.5502 14.8798 15.9888 15.4435L14.9672 16.4678V16.4678C14.4203 17.0165 14.3807 17.8913 14.8757 18.4872L24.5277 30.02L25.2726 34.3127V34.3127C25.4608 35.4446 25.5269 36.5935 25.4696 37.7395L24.5128 54.4265V54.4265C24.4707 55.2523 25.1059 55.9559 25.9318 55.998C25.9564 55.9993 25.9811 56 26.0058 56H27.9873V56C28.8196 55.999 29.5353 55.4105 29.6973 54.5942L32.4925 41.048L35.288 54.5932V54.5932C35.4502 55.4104 36.1669 55.9993 37 56H38.9835V56C39.8112 55.9988 40.4811 55.3269 40.48 54.4992C40.4799 54.4745 40.4793 54.4497 40.478 54.425L39.5202 37.725L39.5202 37.725C39.4629 36.5781 39.529 35.4284 39.7174 34.2957L40.4627 30L50.1242 18.4585V18.4585C50.6195 17.8621 50.5799 16.9868 50.0327 16.4377L49.01 15.4125V15.4125C48.4478 14.8484 47.542 14.8245 46.9509 15.3582L38.6079 22.9732V22.9732C37.876 23.6339 36.925 23.9997 35.939 24L29.047 24.0243ZM32.4826 22H32.4826C36.3486 22.0096 39.4904 18.8834 39.5 15.0174C39.5096 11.1514 36.3834 8.00965 32.5174 8.00004C28.6514 7.99043 25.5096 11.1166 25.5 14.9826C25.5 14.9884 25.5 14.9942 25.5 15V15.0001C25.4952 18.8612 28.6214 21.9952 32.4825 22C32.4826 22 32.4826 22 32.4827 22H32.4826Z"
		/>
	);
}

function Baby(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M49.1847 36.4119L48.4347 37.4119V37.4119C47.9723 38.0289 47.1172 38.1945 46.4579 37.7947L40.4879 34.1747V37.012V37.012C40.4879 37.5641 40.0405 38.0117 39.4884 38.012H25.4953V38.012C24.943 38.012 24.4953 37.5643 24.4953 37.012V34.1745L18.5253 37.7945H18.5253C17.866 38.1943 17.011 38.0287 16.5487 37.4117L15.7987 36.4117V36.4117C15.3406 35.8005 15.4146 34.9428 15.9705 34.4191L23.7452 27.0974V27.0974C24.4867 26.3992 25.4667 26.0103 26.4852 26.0101H38.4977V26.0101C39.5162 26.0103 40.4962 26.3992 41.2377 27.0974L49.0126 34.4191V34.4191C49.5686 34.9428 49.6427 35.8006 49.1847 36.4119V36.4119ZM32.5 24V24C28.0817 24 24.5 20.4183 24.5 16C24.5 11.5817 28.0817 8 32.5 8C36.9183 8 40.5 11.5817 40.5 16V16C40.5 20.4183 36.9183 24 32.5 24V24ZM23.78 41.463V41.463C24.062 41.0114 24.6567 40.8738 25.1084 41.1558C25.1722 41.1956 25.2311 41.2428 25.2839 41.2963L29.1989 45.1906V45.1906C29.5259 45.5224 29.5764 46.0377 29.32 46.4267L27.731 48.959L30.21 52.17V52.17C30.6444 52.7561 30.5869 53.5713 30.0746 54.0906L28.62 55.56V55.56C28.0599 56.1281 27.1454 56.1345 26.5774 55.5745C26.5725 55.5697 26.5677 55.5649 26.5629 55.56L21.6351 50.5821V50.5821C20.3488 49.2771 20.1293 47.2586 21.1051 45.7076L23.78 41.463ZM37.2692 48.959L35.68 46.4267V46.4267C35.4237 46.0377 35.4742 45.5225 35.8011 45.1906L39.7161 41.2963V41.2963C40.0901 40.9174 40.7004 40.9134 41.0792 41.2874C41.1328 41.3402 41.18 41.3992 41.2198 41.463L43.8942 45.708V45.708C44.8702 47.2589 44.6507 49.2776 43.3642 50.5825L38.4367 55.56V55.56C37.8767 56.128 36.9622 56.1345 36.3942 55.5745C36.3893 55.5697 36.3845 55.5649 36.3797 55.56L34.9251 54.091V54.091C34.4129 53.5714 34.3556 52.7562 34.79 52.17L37.2692 48.959Z"
		/>
	);
}

function Heart(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21.5008 11.8351C26.0971 11.8747 30.2273 14.6506 32 18.8915C33.7728 14.6506 37.903 11.8747 42.4994 11.8351C48.958 11.9454 54.1054 17.2686 53.9987 23.7272C53.9987 39.0092 35.6908 52.1649 32 52.1649C28.3093 52.1649 10.0019 39.0092 10.0019 23.7272C9.89523 17.2687 15.0424 11.9455 21.5008 11.8351Z"
		/>
	);
}

function Star(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M42.6215 35.4275L47.1357 49.7956C47.4438 50.7054 46.9561 51.6927 46.0463 52.0008C45.5113 52.182 44.9217 52.0921 44.465 51.7598L32.5016 42.7429L20.5623 51.7549C19.7829 52.3163 18.696 52.1396 18.1346 51.3602C17.8054 50.9031 17.7179 50.3149 17.8999 49.7819L22.3813 35.4483L10.2602 26.7438C9.47046 26.1774 9.28945 25.0779 9.85594 24.2881C10.1815 23.8343 10.7031 23.5619 11.2615 23.5542H26.1937L30.853 9.14132C31.1363 8.23088 32.104 7.72245 33.0144 8.00572C33.5567 8.17443 33.9813 8.59905 34.15 9.14132L38.8094 23.5542H53.7906C54.7625 23.5677 55.5393 24.3665 55.5258 25.3383C55.518 25.8973 55.2451 26.4193 54.7906 26.7448L42.6215 35.4275Z"
		/>
	);
}

function Fire(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.0145 52.7829C39.9409 51.1524 41.3791 49.0212 42.1702 46.6247C42.2439 46.3852 42.1096 46.1314 41.8702 46.0577C41.8281 46.0447 41.7843 46.038 41.7403 46.0376C39.7179 46.0758 37.708 46.3634 35.7561 46.894C35.5216 46.984 35.2585 46.8669 35.1685 46.6324C35.1268 46.5238 35.1283 46.4033 35.1727 46.2958C35.8517 44.2334 36.1421 42.063 36.0293 39.8947C36.0293 35.2312 33.1975 31.6211 32.2011 30.382C32.053 30.1927 31.7796 30.1593 31.5903 30.3073C31.5226 30.3602 31.4722 30.4319 31.4452 30.5135C30.1174 34.7532 24.5928 40.8344 24.5928 46.9282C24.5928 50.5911 27.0253 52.1813 27.2045 53.0309C27.352 53.7305 26.996 54.1177 26.3268 53.9069C21.8719 52.5043 14.9155 46.0968 14.9155 38.136C14.9155 23.673 28.9913 20.7869 28.9913 13.5185C28.9019 12.589 28.6166 11.689 28.1541 10.8777C28.0394 10.5259 28.2317 10.1477 28.5836 10.033C28.7095 9.99194 28.8447 9.98914 28.9722 10.0249C33.4965 11.2434 43.9471 17.561 43.9471 30.2232C43.8639 32.948 43.2669 35.6326 42.1876 38.136C42.1876 38.136 45.1456 37.6222 49.1552 37.2532C49.6659 37.2372 50.0929 37.6382 50.109 38.149C50.1104 38.1943 50.1085 38.2397 50.1033 38.2847C50.1033 44.3901 45.3329 51.4292 38.5458 53.9651C37.93 54.195 37.5186 53.2294 38.0145 52.7829Z"
		/>
	);
}

function Water(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.51 54C23.7629 54.0003 16.6717 46.9097 16.6713 38.1626C16.6713 27.8385 28.0975 14.0948 31.54 10.4199C32.043 9.88409 32.8851 9.85754 33.4208 10.3606C33.4412 10.3797 33.461 10.3995 33.4801 10.4199C36.9231 14.0948 48.3487 27.8385 48.3487 38.1626C48.3487 46.9097 41.2571 54 32.51 54C32.51 54 32.51 54 32.51 54ZM29.8518 18.5382C27.3364 24.4924 25.8548 30.832 25.4706 37.2842C25.4586 37.7651 25.0716 38.1522 24.5907 38.1641H21.9509C21.4828 38.182 21.0888 37.8171 21.0709 37.349C21.0701 37.3274 21.0701 37.3058 21.0709 37.2842C21.429 31.493 25.4812 22.9752 29.0331 18.1363C29.3555 17.6975 30.072 18.0456 29.8518 18.5382Z"
		/>
	);
}

function EmojiHappy(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.4989 54V54C20.3487 54 10.4989 44.1502 10.4989 32C10.4989 19.8498 20.3487 10 32.4989 10C44.6491 10 54.4989 19.8498 54.4989 32V32C54.4989 44.1502 44.6491 54 32.4989 54V54ZM25.1666 24.6667C23.5278 24.6667 22.4161 26.3855 22.4161 28.7815C22.4157 31.2208 23.6991 32 25.1666 32C26.6341 32 27.9166 31.2208 27.9166 28.7815C27.9158 26.3855 26.8049 24.6667 25.1666 24.6667ZM39.8332 24.6667C38.1944 24.6667 37.0832 26.3855 37.0832 28.7815C37.0832 31.2208 38.3666 32 39.8332 32C41.2999 32 42.5832 31.2208 42.5832 28.7815C42.5824 26.3855 41.4716 24.6667 39.8332 24.6667ZM42.8124 37.5C41.5408 37.5 39.0335 41.1667 32.4999 41.1667C25.9664 41.1667 23.4591 37.5 22.1874 37.5V37.5C21.834 37.4737 21.5262 37.7389 21.4999 38.0923C21.4976 38.124 21.4976 38.1558 21.4999 38.1875C21.4999 39.3715 25.6241 44.8333 32.4999 44.8333C39.3757 44.8333 43.4999 39.3716 43.4999 38.1875V38.1875C43.5262 37.8341 43.2611 37.5263 42.9077 37.4999C42.8757 37.4976 42.8435 37.4976 42.8115 37.5H42.8124Z"
		/>
	);
}

function EmojiDisappointed(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.5 54H32.5C44.6502 54 54.5 44.1502 54.5 32C54.5 19.8498 44.6502 10 32.5 10C20.3498 10 10.5 19.8498 10.5 32V32C10.5 44.1502 20.3498 54 32.5 54C32.5 54 32.5 54 32.5 54V54ZM39.8333 24.6667C41.4721 24.6667 42.5833 26.3855 42.5833 28.7815C42.5833 31.2208 41.3 32 39.8333 32C38.3667 32 37.0833 31.2208 37.0833 28.7815C37.0833 26.3855 38.1942 24.6667 39.8333 24.6667ZM25.1667 24.6667C26.8055 24.6667 27.9167 26.3855 27.9167 28.7815C27.9167 31.2208 26.6333 32 25.1667 32C23.7 32 22.4167 31.2208 22.4167 28.7815C22.4167 26.3855 23.5273 24.6667 25.1667 24.6667ZM33.4167 37.5C37.9708 37.5 41.6667 39.8594 41.6667 41.1667V41.1667C41.6603 41.6703 41.2536 42.077 40.75 42.0833C39.8975 42.0833 38.5395 41.1667 33.4167 41.1667C26.9827 41.1667 23.5808 44.8333 22.4167 44.8333V44.8333C21.9206 44.8436 21.5102 44.4497 21.5 43.9537C21.4997 43.9414 21.4997 43.929 21.5 43.9167C21.5 42.1408 26.7733 37.5 33.4167 37.5V37.5Z"
		/>
	);
}
function ThumbsUp(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.0064 30.0209H16.0379V30.0209C17.28 30.0211 18.4517 29.4444 19.2092 28.4601L27.1812 18.1001V18.1001C27.7193 17.4009 28.0111 16.5435 28.0112 15.6612V8.02123V8.02122C27.9951 6.93279 28.8643 6.03735 29.9528 6.02121C29.9724 6.02092 29.9921 6.02092 30.0118 6.02122C32.5783 6.02122 36.0134 9.02122 36.0134 15.0212V15.0212C36.1436 18.5222 35.5845 22.0147 34.368 25.3001V25.3001C34.2485 25.5517 34.3555 25.8525 34.607 25.9721C34.672 26.003 34.7429 26.0196 34.8149 26.0208H47.8534V26.0208C49.8728 25.9866 51.6183 27.4238 51.9721 29.4123V29.4123C52.2269 31.0792 51.403 32.7256 49.9161 33.5208V33.5208C51.8511 34.5537 52.5824 36.9596 51.5496 38.8946C51.0783 39.7775 50.291 40.45 49.3452 40.7774V40.7774C50.0726 41.2909 50.6041 42.0361 50.8526 42.891V42.891C51.1105 43.8581 50.9961 44.8868 50.532 45.7736V45.7736C49.9971 47.0331 48.7943 47.8804 47.4283 47.9601V47.9601C47.8581 48.6566 48.0604 49.4695 48.0073 50.2861V50.2861C47.7833 52.4411 45.9451 54.0649 43.7789 54.0212H28.8555V54.0212C25.6959 54.0213 22.607 53.0863 19.9778 51.334L19.016 50.693V50.693C18.3587 50.255 17.5866 50.0213 16.7967 50.0213H12.0067V50.0213C10.9021 50.0216 10.0064 49.1265 10.0061 48.0219C10.0061 48.0217 10.0061 48.0215 10.0061 48.0213V32.0213L10.0061 32.0209C10.0061 30.9163 10.9015 30.0209 12.0061 30.0209C12.0063 30.0209 12.0066 30.0209 12.0068 30.0209L12.0064 30.0209Z"
		/>
	);
}

function ThumbsDown(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.0063 14.0209H16.7963H16.7963C17.5862 14.0209 18.3584 13.7872 19.0156 13.3491L19.9774 12.7081L19.9774 12.7081C22.6066 10.9559 25.6955 10.0209 28.8551 10.0209H43.7788C45.945 9.97715 47.7833 11.601 48.0072 13.7561V13.7561C48.0603 14.5727 47.8579 15.3856 47.4282 16.082C48.7942 16.1618 49.9969 17.0089 50.5322 18.2681V18.2681C50.9961 19.155 51.1103 20.1837 50.8522 21.1507C50.6036 22.0056 50.0721 22.7509 49.3447 23.2643C51.4174 23.9816 52.5162 26.2433 51.7989 28.316C51.4715 29.262 50.7988 30.0496 49.9156 30.5209C51.4029 31.3162 52.227 32.9629 51.972 34.6301C51.6182 36.6185 49.8728 38.0557 47.8534 38.0214H34.8148C34.5364 38.0262 34.3145 38.2558 34.3193 38.5342C34.3206 38.6062 34.3372 38.6771 34.3682 38.7422C35.5846 42.0277 36.1436 45.5203 36.0132 49.0214C36.0132 55.0214 32.5778 58.0214 30.0114 58.0214C28.9229 58.0378 28.0272 57.1688 28.0107 56.0803C28.0104 56.0607 28.0104 56.041 28.0107 56.0214V48.3814V48.3815C28.0107 47.4992 27.7189 46.6417 27.1807 45.9425L19.2091 35.5825C18.4515 34.5981 17.2797 34.0213 16.0374 34.0213H12.0063C10.9017 34.0213 10.0063 33.1259 10.0063 32.0213V16.0213V16.0209C10.0063 14.9163 10.9017 14.0209 12.0063 14.0209C12.0064 14.0209 12.0066 14.0209 12.0067 14.0209L12.0063 14.0209Z"
		/>
	);
}

function Bicycle(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M48.5018 47.9983V47.9983C43.3932 48.0052 39.2463 43.8695 39.2393 38.7609C39.2356 36.0982 40.3797 33.563 42.3787 31.804L40.8483 29.2535L33.904 39.6697V39.6697C33.5918 40.1383 33.0659 40.4198 32.5028 40.4197H25.6056V40.4197C24.6756 45.45 19.8438 48.774 14.8135 47.844C9.78315 46.914 6.45917 42.0822 7.38918 37.0518C8.31918 32.0215 13.151 28.6975 18.1813 29.6275C18.8589 29.7528 19.5203 29.9533 20.1534 30.2252L22.9321 26.0571L20.9398 22.7364H20.0388V22.7364C19.082 22.7364 18.2073 22.1958 17.7794 21.34L17.4029 20.5868V20.5868C17.1949 20.1709 17.3635 19.6651 17.7795 19.4571C17.8964 19.3986 18.0253 19.3682 18.156 19.3682H25.5474V19.3682C26.5043 19.3682 27.379 19.9088 27.8069 20.7647L28.1835 21.5178V21.5178C28.3915 21.9338 28.2229 22.4396 27.8069 22.6475C27.69 22.706 27.5611 22.7364 27.4304 22.7364H24.867L25.8775 24.4205H37.949L34.9176 19.3682H30.9923V19.3682C30.0355 19.3682 29.1608 18.8276 28.7329 17.9718L28.3563 17.2187V17.2187C28.1483 16.8028 28.3168 16.2969 28.7328 16.0889C28.8497 16.0304 28.9787 16 29.1094 16H35.8711V16C36.4626 16.0001 37.0107 16.3106 37.315 16.8178L45.2652 30.068H45.2652C50.0547 28.278 55.3884 30.7094 57.1784 35.4989C58.9685 40.2883 56.537 45.622 51.7475 47.4121C50.7094 47.8001 49.6101 47.9985 48.5019 47.998L48.5018 47.9983ZM16.5038 32.8413V32.8413C13.2485 32.8399 10.6084 35.4778 10.607 38.7331C10.6056 41.9885 13.2434 44.6286 16.4988 44.63C19.1064 44.6312 21.4049 42.9187 22.15 40.4198H16.5038V40.4198C15.5737 40.42 14.8195 39.6661 14.8193 38.736C14.8193 38.4032 14.9178 38.0778 15.1025 37.801L18.2357 33.1017V33.1017C17.6747 32.9288 17.0909 32.841 16.5038 32.8413H16.5038ZM21.0364 34.9729L19.6505 37.0517H22.1499V37.0517C21.9228 36.2907 21.544 35.5836 21.0364 34.9729H21.0364ZM24.8495 29.2535L22.9519 32.0996L22.952 32.0996C24.3288 33.4351 25.2562 35.1657 25.6057 37.0517H29.5287L24.8495 29.2535ZM27.8987 27.7889L32.5779 35.5871L37.777 27.789L27.8987 27.7889ZM48.5018 32.8412V32.8412C48.0095 32.8432 47.5194 32.907 47.0431 33.0314L49.9457 37.8689V37.8689C50.4244 38.6664 50.1659 39.701 49.3683 40.1797C48.5708 40.6584 47.5362 40.3999 47.0575 39.6023L44.1562 34.7667V34.7667C41.9689 37.1715 42.1452 40.8941 44.55 43.0814C46.9548 45.2687 50.6774 45.0924 52.8647 42.6876C55.052 40.2828 54.8756 36.5602 52.4708 34.3729C51.3849 33.3852 49.9691 32.8389 48.5012 32.8412H48.5018Z"
		/>
	);
}

function Car(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M52.7638 31.9516V31.9516C52.1427 32.2622 51.7503 32.897 51.7503 33.5914V40.2501C51.7503 44.8504 45.2727 45.7502 32.5001 45.7502C19.7276 45.7502 13.25 44.8504 13.25 40.2501V33.5914V33.5915C13.25 32.897 12.8576 32.2622 12.2365 31.9517L11.0066 31.3368V31.3368C10.6961 31.1815 10.5 30.8641 10.5 30.5169V28.3333V28.3333C10.5 27.827 10.9104 27.4166 11.4167 27.4166H14.3727L17.3777 18.401V18.401C17.9615 16.6397 19.3963 15.2929 21.1911 14.8218C23.1856 14.2945 26.0099 13.6667 32.5 13.6667C38.9901 13.6667 41.8134 14.2949 43.8085 14.8218V14.8218C45.6035 15.2927 47.0385 16.6398 47.6218 18.4016L50.6271 27.4166H53.5833V27.4166C54.0896 27.4166 54.5 27.827 54.5 28.3333V30.5169V30.5168C54.5 30.864 54.3038 31.1814 53.9933 31.3367L52.7638 31.9516ZM16.9167 35.796V37.3503V37.3503C16.9403 38.4595 17.857 39.3405 18.9663 39.3201H22.2007H22.2007C23.3099 39.3405 24.2266 38.4595 24.2502 37.3503V37.3503C24.246 36.5929 23.8046 35.9062 23.1173 35.5878L19.8834 34.0342V34.0342C19.5976 33.8961 19.2842 33.8245 18.9667 33.8248V33.8248C17.857 33.8049 16.9403 34.6864 16.9167 35.796V35.796ZM46.1889 26.21L43.9996 19.5614V19.5614C43.8108 18.9766 43.3388 18.5271 42.7455 18.3671C41.3012 17.9809 38.8411 17.3331 32.5001 17.3331C26.1591 17.3331 23.6987 17.9809 22.2567 18.3666V18.3666C21.6621 18.5264 21.1889 18.9764 20.9994 19.5622L18.811 26.2101V26.2101C18.6499 26.6891 18.9076 27.2079 19.3866 27.369C19.478 27.3997 19.5736 27.4158 19.6699 27.4167H45.3298V27.4167C45.8351 27.4122 46.2411 26.9989 46.2366 26.4935C46.2358 26.3971 46.2197 26.3014 46.1889 26.21V26.21ZM48.0836 35.796V35.796C48.0602 34.6863 47.1435 33.8046 46.0336 33.8244V33.8244C45.7162 33.8241 45.4028 33.8957 45.117 34.0339L41.8829 35.5878V35.5878C41.1958 35.9062 40.7544 36.593 40.7502 37.3503V37.3503C40.7738 38.4595 41.6904 39.3405 42.7996 39.3201H46.034V39.3201C47.1433 39.3406 48.06 38.4595 48.0836 37.3503V35.796ZM20.8059 46.6941V46.6941C21.219 46.7881 21.5091 47.1596 21.5 47.5832V48.4999V48.4999C21.4989 49.5119 20.6787 50.3321 19.6667 50.3333H16V50.3333C14.988 50.3321 14.1678 49.512 14.1667 48.4999V46.6666V46.6666C14.1186 46.2084 14.451 45.798 14.9092 45.7499C14.9671 45.7438 15.0254 45.7438 15.0833 45.7499C15.5168 45.7502 18.2268 46.469 20.8059 46.6941V46.6941ZM49.9169 45.7499V45.7499C50.3751 45.7018 50.7855 46.0343 50.8336 46.4924C50.8397 46.5503 50.8397 46.6087 50.8336 46.6666V48.4999V48.4999C50.8324 49.5119 50.0123 50.332 49.0003 50.3332H45.3336V50.3332C44.3215 50.3321 43.5014 49.5119 43.5002 48.4999V47.5832V47.5832C43.4911 47.1596 43.7812 46.7881 44.1943 46.6941C46.773 46.469 49.4835 45.7502 49.9169 45.7502V45.7499Z"
		/>
	);
}

function Airplane(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M37.1078 25.0678L41.7862 27.4073C41.9068 26.3113 42.2865 25.5324 43.5152 25.5324C45.4036 25.5324 45.3607 27.2467 45.3607 29.1947L53.6259 33.3271V33.3271C54.2512 33.6398 54.6461 34.2788 54.6461 34.9779V38.4483V38.4485C54.6461 38.9581 54.2329 39.3712 53.7233 39.3712C53.6545 39.3712 53.5859 39.3635 53.5188 39.3483L36.889 35.5687L36.889 35.5687C36.7175 40.7623 36.0458 45.9273 34.8831 50.9921L40.2485 53.9726V53.9726C40.7706 54.2631 40.9584 54.9219 40.6679 55.444C40.4561 55.8247 40.0366 56.0412 39.6036 55.9934V55.9934C34.8826 55.469 30.118 55.469 25.397 55.9934V55.9934C24.803 56.0588 24.2684 55.6303 24.203 55.0363C24.1553 54.6036 24.3717 54.1844 24.7521 53.9726L30.1173 50.9921L30.1173 50.9921C28.9546 45.9274 28.283 40.7623 28.1117 35.5687L11.4813 39.3483V39.3483C10.9843 39.4613 10.4899 39.15 10.3769 38.6531C10.3616 38.5859 10.3539 38.5172 10.354 38.4483V34.9778V34.9779C10.354 34.2788 10.749 33.6397 11.3743 33.3271L19.5814 29.2235H19.5797C19.5797 27.2635 19.5289 25.5324 21.3693 25.5324C22.6476 25.5324 23.0347 26.3252 23.1555 27.4365L27.8926 25.0678C28.0218 9.53297 30.33 8 32.5002 8C34.6704 8 36.9789 9.53295 37.1078 25.0678L37.1078 25.0678Z"
		/>
	);
}

function Rocket(props) {
	return (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M39.3571 38.884V38.8851C39.3571 39.9716 39.1093 41.0439 38.6326 42.0203L37.9976 43.2902V43.2902C37.7797 43.7252 37.3348 43.9999 36.8483 44H28.1517V44C27.6648 44 27.2196 43.7248 27.0019 43.2893L26.3669 42.0192V42.0192C25.8903 41.0428 25.6427 39.9705 25.6429 38.884L20.74 43.7864V43.7864C20.4888 44.0373 20.0818 44.037 19.8309 43.7858C19.7104 43.6653 19.6428 43.5018 19.6429 43.3314V37.7327V37.7331C19.6429 36.8239 20.004 35.9519 20.6468 35.3088L25.3916 30.5641V30.5641C25.5525 30.4033 25.6429 30.185 25.6429 29.9575V23.4286C25.6429 12.5551 29.9286 8 32.5 8C35.0714 8 39.3571 12.5551 39.3571 23.4286V29.9574V29.9573C39.3571 30.1846 39.4474 30.4026 39.6081 30.5634L44.353 35.3086V35.3086C44.9959 35.9515 45.3571 36.8235 45.3571 37.7327V43.332V43.332C45.3568 43.687 45.0688 43.9746 44.7137 43.9743C44.5436 43.9742 44.3804 43.9066 44.26 43.7863L39.3571 38.884ZM32.5 45.7143V45.7143C34.5113 45.8334 36.0455 47.5601 35.9271 49.5714C35.9271 52.0186 33.6272 56 32.5 56C31.3728 56 29.0727 52.0186 29.0727 49.5714V49.5714C28.9544 47.56 30.4886 45.8333 32.5 45.7143V45.7143Z"
		/>
	);
}
